/* Generated from third-party ./third_party/newstroke/newstroke_font.cpp for KiCanvas.
See below for original license. */

/*
 * newstroke_font.cpp - definitions for automatically converted font
 *
 * This program source code file is part of KiCad, a free EDA CAD application.
 *
 * Copyright (C) 2010 vladimir uryvaev <vovanius@bk.ru>
 * Copyright (C) 1992-2019 KiCad Developers, see change_log.txt for contributors.
 *
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, you may find one here:
 * http://www.gnu.org/licenses/old-licenses/gpl-2.0.html
 * or you may search the http://www.gnu.org website for the version 2 license,
 * or you may write to the Free Software Foundation, Inc.,
 * 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA
 */

/**
 * Modified 2019 to include based CJK Unicode Ideographs, using
 * code copyright (c) 2018 Lingdong Huang
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * Font used for CJK is Source Han Sans from https://github.com/adobe-fonts/source-han-sans
 * Source Han Sans is Copyright 2014-2019 Adobe (http://www.adobe.com/), with Reserved Font
 * Name 'Source'. Source is a trademark of Adobe in the United States
 * and/or other countries.
 *
 * This Font Software is licensed under the SIL Open Font License,
 * Version 1.1.
 *
 * This license is copied below, and is also available with a FAQ at:
 * http://scripts.sil.org/OFL
 *
 * -----------------------------------------------------------
 * SIL OPEN FONT LICENSE Version 1.1 - 26 February 2007
 * -----------------------------------------------------------
 *
 * PREAMBLE
 * The goals of the Open Font License (OFL) are to stimulate worldwide
 * development of collaborative font projects, to support the font
 * creation efforts of academic and linguistic communities, and to
 * provide a free and open framework in which fonts may be shared and
 * improved in partnership with others.
 *
 * The OFL allows the licensed fonts to be used, studied, modified and
 * redistributed freely as long as they are not sold by themselves. The
 * fonts, including any derivative works, can be bundled, embedded,
 * redistributed and/or sold with any software provided that any reserved
 * names are not used by derivative works. The fonts and derivatives,
 * however, cannot be released under any other type of license. The
 * requirement for fonts to remain under this license does not apply to
 * any document created using the fonts or their derivatives.
 *
 * DEFINITIONS
 * "Font Software" refers to the set of files released by the Copyright
 * Holder(s) under this license and clearly marked as such. This may
 * include source files, build scripts and documentation.
 *
 * "Reserved Font Name" refers to any names specified as such after the
 * copyright statement(s).
 *
 * "Original Version" refers to the collection of Font Software
 * components as distributed by the Copyright Holder(s).
 *
 * "Modified Version" refers to any derivative made by adding to,
 * deleting, or substituting -- in part or in whole -- any of the
 * components of the Original Version, by changing formats or by porting
 * the Font Software to a new environment.
 *
 * "Author" refers to any designer, engineer, programmer, technical
 * writer or other person who contributed to the Font Software.
 *
 * PERMISSION & CONDITIONS
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of the Font Software, to use, study, copy, merge, embed,
 * modify, redistribute, and sell modified and unmodified copies of the
 * Font Software, subject to the following conditions:
 *
 * 1) Neither the Font Software nor any of its individual components, in
 * Original or Modified Versions, may be sold by itself.
 *
 * 2) Original or Modified Versions of the Font Software may be bundled,
 * redistributed and/or sold with any software, provided that each copy
 * contains the above copyright notice and this license. These can be
 * included either as stand-alone text files, human-readable headers or
 * in the appropriate machine-readable metadata fields within text or
 * binary files as long as those fields can be easily viewed by the user.
 *
 * 3) No Modified Version of the Font Software may use the Reserved Font
 * Name(s) unless explicit written permission is granted by the
 * corresponding Copyright Holder. This restriction only applies to the
 * primary font name as presented to the users.
 *
 * 4) The name(s) of the Copyright Holder(s) or the Author(s) of the Font
 * Software shall not be used to promote, endorse or advertise any
 * Modified Version, except to acknowledge the contribution(s) of the
 * Copyright Holder(s) and the Author(s) or with their explicit written
 * permission.
 *
 * 5) The Font Software, modified or unmodified, in part or in whole,
 * must be distributed entirely under this license, and must not be
 * distributed under any other license. The requirement for fonts to
 * remain under this license does not apply to any document created using
 * the Font Software.
 *
 * TERMINATION
 * This license becomes null and void if any of the above conditions are
 * not met.
 *
 * DISCLAIMER
 * THE FONT SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO ANY WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT
 * OF COPYRIGHT, PATENT, TRADEMARK, OR OTHER RIGHT. IN NO EVENT SHALL THE
 * COPYRIGHT HOLDER BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 * INCLUDING ANY GENERAL, SPECIAL, INDIRECT, INCIDENTAL, OR CONSEQUENTIAL
 * DAMAGES, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF THE USE OR INABILITY TO USE THE FONT SOFTWARE OR FROM
 * OTHER DEALINGS IN THE FONT SOFTWARE.
 */

export const shared_glyphs = ["E_JSZS", "G][EI`", "H\\KFXFQNTNVOWPXRXWWYVZT[N[LZKY", "I[MUWU RK[RFY[", "G\\SPVQWRXTXWWYVZT[L[LFSFUGVHWJWLVNUOSPLP", "F[WYVZS[Q[NZLXKVJRJOKKLINGQFSFVGWH", "H[MPTP RW[M[MFWF", "G]L[LF RLPXP RX[XF", "MWR[RF", "G\\L[LF RX[OO RXFLR", "F^K[KFRUYFY[", "G]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF", "G\\L[LFTFVGWHXJXMWOVPTQLQ", "JZLFXF RR[RF", "H\\KFY[ RYFK[", "I[RQR[ RKFRQYF", "NVPESH", "HZVZT[P[NZMYLWLQMONNPMTMVN", "MWRMR_QaObNb RRFQGRHSGRFRH", "H[P[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[", "JZMMR[WM", "G]JMN[RQV[ZM", "H\\RbRD", "F^K[KFYFY[K[", "RR", "NVTEQH", "JZRRQSRTSSRRRT", "MWR[RF RN?O@NAM@N?NA RV?W@VAU@V?VA", "G\\L[LFQFTGVIWKXOXRWVVXTZQ[L[ RIPQP", "H[P[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ RTEQH", "I[MUWU RK[RFY[ RN>O@QASAU@V>", "IZNMN[ RPSV[ RVMNU", "G]KPYP RPFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF", "I[NNPMTMVNWPWXVZT[P[NZMXMVWT", "H]YMVWUYTZR[P[NZMYLVLRMONNPMRMTNUOVQWXXZZ[", "IZPTNUMWMXNZP[T[VZ RRTPTNSMQMPNNPMTMVN", "MXRMRXSZU[", "H[LTWT RP[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[", "G]RFRb RPMTMVNXPYRYVXXVZT[P[NZLXKVKRLPNNPM", "H]YMVWUYTZR[P[NZMYLVLRMONNPMRMTNUOVQWXXZZ[ RTEQH", "IZPTNUMWMXNZP[T[VZ RRTPTNSMQMPNNPMTMVN RTEQH", "I\\NMN[ RNOONQMTMVNWPWb RTEQH", "MXRMRXSZU[ RTEQH", "G]RTRX RMMLNKPKXLZN[O[QZRXSZU[V[XZYXYPXNWM", "H[MMMXNZP[S[UZVYWWWPVNUM RTEQH", "G]RTRX RMMLNKPKXLZN[O[QZRXSZU[V[XZYXYPXNWM RTEQH", "LXOTUT", "E_PKTKXMZQZUXYT[P[LYJUJQLMPK RPQRPTQUSTURVPUOSPQ", "Pf"];

export const glyph_data: (string|number|undefined)[]  = ["JZ",
"MWRYSZR[QZRYR[ RRSQGRFSGRSRF",
"JZNFNJ RVFVJ",
"H]LM[M RRDL_ RYVJV RS_YD",
"H\\LZO[T[VZWYXWXUWSVRTQPPNOMNLLLJMHNGPFUFXG RRCR^",
"F^J[ZF RMFOGPIOKMLKKJIKGMF RYZZXYVWUUVTXUZW[YZ",
"E_[[Z[XZUWPQNNMKMINGPFQFSGTITJSLRMLQKRJTJWKYLZN[Q[SZTYWUXRXP",
"MWSFQJ",
"KYVcUbS_R]QZPUPQQLRISGUDVC",
"KYNcObQ_R]SZTUTQSLRIQGODNC",
"JZRFRK RMIRKWI ROORKUO",
"E_JSZS RR[RK",
"MWSZS[R]Q^",
0,
"MWRYSZR[QZRYR[",
1,
"H\\QFSFUGVHWJXNXSWWVYUZS[Q[OZNYMWLSLNMJNHOGQF",
"H\\X[L[ RR[RFPINKLL",
"H\\LHMGOFTFVGWHXJXLWOK[X[",
2,
"H\\VMV[ RQELTYT",
"H\\WFMFLPMOONTNVOWPXRXWWYVZT[O[MZLY",
"H\\VFRFPGOHMKLOLWMYNZP[T[VZWYXWXRWPVOTNPNNOMPLR",
"H\\KFYFP[",
"H\\PONNMMLKLJMHNGPFTFVGWHXJXKWMVNTOPONPMQLSLWMYNZP[T[VZWYXWXSWQVPTO",
"H\\N[R[TZUYWVXRXJWHVGTFPFNGMHLJLOMQNRPSTSVRWQXO",
"MWRYSZR[QZRYR[ RRNSORPQORNRP",
"MWSZS[R]Q^ RRNSORPQORNRP",
"E_ZMJSZY",
"E_JPZP RZVJV",
"E_JMZSJY",
"I[QYRZQ[PZQYQ[ RMGOFTFVGWIWKVMUNSORPQRQS",
"D_VQUPSOQOOPNQMSMUNWOXQYSYUXVW RVOVWWXXXZW[U[PYMVKRJNKKMIPHTIXK[N]R^V]Y[",
3,
4,
5,
"G\\L[LFQFTGVIWKXOXRWVVXTZQ[L[",
6,
"HZTPMP RM[MFWF",
"F[VGTFQFNGLIKKJOJRKVLXNZQ[S[VZWYWRSR",
7,
8,
"JZUFUUTXRZO[M[",
9,
"HYW[M[MF",
10,
"G]L[LFX[XF",
11,
12,
"G]Z]X\\VZSWQVOV RP[NZLXKTKMLINGPFTFVGXIYMYTXXVZT[P[",
"G\\X[QQ RL[LFTFVGWHXJXMWOVPTQLQ",
"H\\LZO[T[VZWYXWXUWSVRTQPPNOMNLLLJMHNGPFUFXG",
13,
"G]LFLWMYNZP[T[VZWYXWXF",
"I[KFR[YF",
"F^IFN[RLV[[F",
14,
15,
"H\\KFYFK[Y[",
"KYVbQbQDVD",
"KYID[_",
"KYNbSbSDND",
"LXNHREVH",
"JZJ]Z]",
16,
"I\\W[WPVNTMPMNN RWZU[P[NZMXMVNTPSUSWR",
"H[M[MF RMNOMSMUNVOWQWWVYUZS[O[MZ",
17,
"I\\W[WF RWZU[Q[OZNYMWMQNOONQMUMWN",
"I[VZT[P[NZMXMPNNPMTMVNWPWRMT",
"MYOMWM RR[RISGUFWF",
"I\\WMW^V`UaSbPbNa RWZU[Q[OZNYMWMQNOONQMUMWN",
"H[M[MF RV[VPUNSMPMNNMO",
"MWR[RM RRFQGRHSGRFRH",
18,
"IZN[NF RPSV[ RVMNU",
"MXU[SZRXRF",
"D`I[IM RIOJNLMOMQNRPR[ RRPSNUMXMZN[P[[",
"I\\NMN[ RNOONQMTMVNWPW[",
19,
"H[MMMb RMNOMSMUNVOWQWWVYUZS[O[MZ",
"I\\WMWb RWZU[Q[OZNYMWMQNOONQMUMWN",
"KXP[PM RPQQORNTMVM",
"J[NZP[T[VZWXWWVUTTQTOSNQNPONQMTMVN",
"MYOMWM RRFRXSZU[W[",
"H[VMV[ RMMMXNZP[S[UZVY",
20,
21,
"IZL[WM RLMW[",
"JZMMR[ RWMR[P`OaMb",
"IZLMWML[W[",
"KYVcUcSbR`RVQTOSQRRPRFSDUCVC",
22,
"KYNcOcQbR`RVSTUSSRRPRFQDOCNC",
"KZMSNRPQTSVRWQ",
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
"JZ",
"MWROQNRMSNRORM RRUSaRbQaRURb",
"HZVZT[P[NZMYLWLQMONNPMTMVN RRJR^",
"H[LMTM RL[W[ RO[OIPGRFUFWG",
"H]LYOV RLLOO RVVYY RVOYL RVVTWQWOVNTNQOOQNTNVOWQWTVV",
"F^JTZT RJMZM RRQR[ RKFRQYF",
"MWRbRW RRFRQ",
"I[N]P^S^U]V[UYOSNQNPONQM RVGTFQFOGNIOKUQVSVTUVSW",
"LXNFOGNHMGNFNH RVFWGVHUGVFVH",
"@dVKTJPJNKLMKOKSLUNWPXTXVW RRCMDHGELDQEVH[M^R_W^\\[_V`Q_L\\GWDRC",
"KZOEQDSDUEVGVN RVMTNQNOMNKOIQHVH",
"H\\RMLSRY RXWTSXO",
"E_JQZQZV",
24,
"@dWXRR RNXNJTJVKWMWOVQTRNR RRCMDHGELDQEVH[M^R_W^\\[_V`Q_L\\GWDRC",
"LXMGWG",
"JZRFPGOIPKRLTKUITGRF",
"E_JOZO RRWRG RZ[J[",
"JZNAP@S@UAVCVEUGNNVN",
"JZN@V@RESEUFVHVKUMSNPNNM",
25,
"H^MMMb RWXXZZ[ RMXNZP[T[VZWXWM",
"F]VMV[ ROMOXNZL[ RZMMMKNJP",
26,
"MWR\\T]U_TaRbOb",
"JZVNNN RNCPBR@RN",
"KYQNOMNKNGOEQDSDUEVGVKUMSNQN",
"H\\RMXSRY RLWPSLO",
"G]KQYQ RVNNN RNCPBR@RN RUYUa RQSN]W]",
"G]KQYQ RVNNN RNCPBR@RN RNTPSSSUTVVVXUZNaVa",
"G]KQYQ RN@V@RESEUFVHVKUMSNPNNM RUYUa RQSN]W]",
"I[SORNSMTNSOSM RWaUbPbNaM_M]N[OZQYRXSVSU",
"I[MUWU RK[RFY[ RP>SA",
"I[MUWU RK[RFY[ RT>QA",
"I[MUWU RK[RFY[ RNAR>VA",
"I[MUWU RK[RFY[ RMAN@P?TAV@W?",
"I[MUWU RK[RFY[ RN?O@NAM@N?NA RV?W@VAU@V?VA",
"I[MUWU RK[RFY[ RRFPEOCPAR@TAUCTERF",
"F`JURU RRPYP RH[OF\\F RRFR[\\[",
"F[WYVZS[Q[NZLXKVJRJOKKLINGQFSFVGWH RR\\T]U_TaRbOb",
"H[MPTP RW[M[MFWF RP>SA",
"H[MPTP RW[M[MFWF RT>QA",
"H[MPTP RW[M[MFWF RNAR>VA",
"H[MPTP RW[M[MFWF RN?O@NAM@N?NA RV?W@VAU@V?VA",
"MWR[RF RP>SA",
"MWR[RF RT>QA",
"MWR[RF RNAR>VA",
27,
28,
"G]L[LFX[XF RMAN@P?TAV@W?",
"G]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF RP>SA",
"G]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF RT>QA",
"G]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF RNAR>VA",
"G]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF RMAN@P?TAV@W?",
"G]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF RN?O@NAM@N?NA RV?W@VAU@V?VA",
"E_LMXY RXMLY",
"G]ZFJ[ RP[NZLXKTKMLINGPFTFVGXIYMYTXXVZT[P[",
"G]LFLWMYNZP[T[VZWYXWXF RP>SA",
"G]LFLWMYNZP[T[VZWYXWXF RT>QA",
"G]LFLWMYNZP[T[VZWYXWXF RNAR>VA",
"G]LFLWMYNZP[T[VZWYXWXF RN?O@NAM@N?NA RV?W@VAU@V?VA",
"I[RQR[ RKFRQYF RT>QA",
"G\\LFL[ RLKTKVLWMXOXRWTVUTVLV",
"F]K[KJLHMGOFRFTGUHVJVMSMQNPPPQQSSTVTXUYWYXXZV[R[PZ",
"I\\W[WPVNTMPMNN RWZU[P[NZMXMVNTPSUSWR RPESH",
"I\\W[WPVNTMPMNN RWZU[P[NZMXMVNTPSUSWR RTEQH",
"I\\W[WPVNTMPMNN RWZU[P[NZMXMVNTPSUSWR RNHREVH",
"I\\W[WPVNTMPMNN RWZU[P[NZMXMVNTPSUSWR RMHNGPFTHVGWF",
"I\\W[WPVNTMPMNN RWZU[P[NZMXMVNTPSUSWR RNFOGNHMGNFNH RVFWGVHUGVFVH",
"I\\W[WPVNTMPMNN RWZU[P[NZMXMVNTPSUSWR RRHPGOEPCRBTCUETGRH",
"D`INKMOMQNRP R[ZY[U[SZRXRPSNUMYM[N\\P\\RRSKSITHVHXIZK[O[QZRX",
"HZVZT[P[NZMYLWLQMONNPMTMVN RR\\T]U_TaRbOb",
"I[VZT[P[NZMXMPNNPMTMVNWPWRMT RPESH",
"I[VZT[P[NZMXMPNNPMTMVNWPWRMT RTEQH",
"I[VZT[P[NZMXMPNNPMTMVNWPWRMT RNHREVH",
"I[VZT[P[NZMXMPNNPMTMVNWPWRMT RNFOGNHMGNFNH RVFWGVHUGVFVH",
"MWR[RM RPESH",
"MWR[RM RTEQH",
"LXNHREVH RR[RM",
"LXNFOGNHMGNFNH RVFWGVHUGVFVH RR[RM",
"I\\SCQI RWNUMQMONNOMQMXNZP[T[VZWXWLVITGRFNE",
"I\\NMN[ RNOONQMTMVNWPW[ RMHNGPFTHVGWF",
"H[P[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ RPESH",
29,
"H[P[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ RNHREVH",
"H[P[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ RMHNGPFTHVGWF",
"H[P[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ RNFOGNHMGNFNH RVFWGVHUGVFVH",
"E_ZSJS RRXSYRZQYRXRZ RRLSMRNQMRLRN",
"H[XMK[ RP[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[",
"H[VMV[ RMMMXNZP[S[UZVY RPESH",
"H[VMV[ RMMMXNZP[S[UZVY RTEQH",
"H[VMV[ RMMMXNZP[S[UZVY RNHREVH",
"H[VMV[ RMMMXNZP[S[UZVY RNFOGNHMGNFNH RVFWGVHUGVFVH",
"JZMMR[ RWMR[P`OaMb RTEQH",
"H[MFMb RMNOMSMUNVOWQWWVYUZS[O[MZ",
"JZMMR[ RWMR[P`OaMb RNFOGNHMGNFNH RVFWGVHUGVFVH",
"I[MUWU RK[RFY[ RM@W@",
"I\\W[WPVNTMPMNN RWZU[P[NZMXMVNTPSUSWR RMGWG",
30,
"I\\W[WPVNTMPMNN RWZU[P[NZMXMVNTPSUSWR RNEOGQHSHUGVE",
"I[MUWU RK[RFY[ RY[W]V_WaYb[b",
"I\\W[WPVNTMPMNN RWZU[P[NZMXMVNTPSUSWR RW[U]T_UaWbYb",
"F[WYVZS[Q[NZLXKVJRJOKKLINGQFSFVGWH RT>QA",
"HZVZT[P[NZMYLWLQMONNPMTMVN RTEQH",
"F[WYVZS[Q[NZLXKVJRJOKKLINGQFSFVGWH RNAR>VA",
"HZVZT[P[NZMYLWLQMONNPMTMVN RNHREVH",
"F[WYVZS[Q[NZLXKVJRJOKKLINGQFSFVGWH RR?Q@RAS@R?RA",
"HZVZT[P[NZMYLWLQMONNPMTMVN RRFQGRHSGRFRH",
"F[WYVZS[Q[NZLXKVJRJOKKLINGQFSFVGWH RN>RAV>",
"HZVZT[P[NZMYLWLQMONNPMTMVN RNERHVE",
"G\\L[LFQFTGVIWKXOXRWVVXTZQ[L[ RN>RAV>",
"IfW[WF RWZU[Q[OZNYMWMQNOONQMUMWN RbF`J",
28,
"I\\W[WF RWZU[Q[OZNYMWMQNOONQMUMWN RRHZH",
"H[MPTP RW[M[MFWF RM@W@",
"I[VZT[P[NZMXMPNNPMTMVNWPWRMT RMGWG",
"H[MPTP RW[M[MFWF RN>O@QASAU@V>",
"I[VZT[P[NZMXMPNNPMTMVNWPWRMT RNEOGQHSHUGVE",
"H[MPTP RW[M[MFWF RR?Q@RAS@R?RA",
"I[VZT[P[NZMXMPNNPMTMVNWPWRMT RRFQGRHSGRFRH",
"H[MPTP RW[M[MFWF RR[P]O_PaRbTb",
"I[VZT[P[NZMXMPNNPMTMVNWPWRMT RR[P]O_PaRbTb",
"H[MPTP RW[M[MFWF RN>RAV>",
"I[VZT[P[NZMXMPNNPMTMVNWPWRMT RNERHVE",
"F[VGTFQFNGLIKKJOJRKVLXNZQ[S[VZWYWRSR RNAR>VA",
"I\\WMW^V`UaSbPbNa RWZU[Q[OZNYMWMQNOONQMUMWN RNHREVH",
"F[VGTFQFNGLIKKJOJRKVLXNZQ[S[VZWYWRSR RN>O@QASAU@V>",
"I\\WMW^V`UaSbPbNa RWZU[Q[OZNYMWMQNOONQMUMWN RNEOGQHSHUGVE",
"F[VGTFQFNGLIKKJOJRKVLXNZQ[S[VZWYWRSR RR?Q@RAS@R?RA",
"I\\WMW^V`UaSbPbNa RWZU[Q[OZNYMWMQNOONQMUMWN RRFQGRHSGRFRH",
"F[VGTFQFNGLIKKJOJRKVLXNZQ[S[VZWYWRSR RR\\T]U_TaRbOb",
"I\\WMW^V`UaSbPbNa RWZU[Q[OZNYMWMQNOONQMUMWN RRGPFODPBRAUA",
"G]L[LF RLPXP RX[XF RNAR>VA",
"H[M[MF RV[VPUNSMPMNNMO RIAM>QA",
"G]IJ[J RL[LF RLPXP RX[XF",
"H[M[MF RV[VPUNSMPMNNMO RJHRH",
"MWR[RF RMAN@P?TAV@W?",
"MWR[RM RMHNGPFTHVGWF",
"MWR[RF RM@W@",
"MWR[RM RMGWG",
"MWR[RF RN>O@QASAU@V>",
"MWR[RM RNEOGQHSHUGVE",
"MWR[RF RR[P]O_PaRbTb",
"MWR[RM RR[P]O_PaRbTb",
"MWR[RF RR?Q@RAS@R?RA",
"MWR[RM",
"MgR[RF RbFbUaX_Z\\[Z[",
"MaR[RM RRFQGRHSGRFRH R\\M\\_[aYbXb R\\F[G\\H]G\\F\\H",
"JZUFUUTXRZO[M[ RQAU>YA",
"MWRMR_QaObNb RNHREVH",
"G\\L[LF RX[OO RXFLR RR\\T]U_TaRbOb",
"IZN[NF RPSV[ RVMNU RR\\T]U_TaRbOb",
31,
"HYW[M[MF RO>LA",
"MXU[SZRXRF RTEQH",
"HYW[M[MF RR\\T]U_TaRbOb",
"MXU[SZRXRF RR\\T]U_TaRbOb",
"HYW[M[MF RVHSK",
"M^U[SZRXRF RZFXJ",
"HYW[M[MF RUNTOUPVOUNUP",
"M\\U[SZRXRF RYOZPYQXPYOYQ",
"HYW[M[MF RJQPM",
"MXU[SZRXRF ROQUM",
"G]L[LFX[XF RT>QA",
"I\\NMN[ RNOONQMTMVNWPW[ RTEQH",
"G]L[LFX[XF RR\\T]U_TaRbOb",
"I\\NMN[ RNOONQMTMVNWPW[ RR\\T]U_TaRbOb",
"G]L[LFX[XF RN>RAV>",
"I\\NMN[ RNOONQMTMVNWPW[ RNERHVE",
"MjSFQJ R\\M\\[ R\\O]N_MbMdNePe[",
"G]LFL[ RLINGPFTFVGWHXJX^W`VaTbQb",
"I\\NMN[ RNOONQMTMVNWPW_VaTbRb",
"G]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF RM@W@",
"H[P[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ RMGWG",
"G]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF RN>O@QASAU@V>",
"H[P[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ RNEOGQHSHUGVE",
"G]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF RQ>NA RX>UA",
"H[P[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ RQENH RXEUH",
"E`RPYP RRFR[ R\\FNFLGJIIMITJXLZN[\\[",
"C`[ZY[U[SZRXRPSNUMYM[N\\P\\RRT RRQQOPNNMKMINHOGQGWHYIZK[N[PZQYRW",
"G\\X[QQ RL[LFTFVGWHXJXMWOVPTQLQ RT>QA",
"KXP[PM RPQQORNTMVM RTEQH",
"G\\X[QQ RL[LFTFVGWHXJXMWOVPTQLQ RR\\T]U_TaRbOb",
"KXP[PM RPQQORNTMVM RR\\T]U_TaRbOb",
"G\\X[QQ RL[LFTFVGWHXJXMWOVPTQLQ RN>RAV>",
"KXP[PM RPQQORNTMVM RNERHVE",
"H\\LZO[T[VZWYXWXUWSVRTQPPNOMNLLLJMHNGPFUFXG RT>QA",
"J[NZP[T[VZWXWWVUTTQTOSNQNPONQMTMVN RTEQH",
"H\\LZO[T[VZWYXWXUWSVRTQPPNOMNLLLJMHNGPFUFXG RNAR>VA",
"J[NZP[T[VZWXWWVUTTQTOSNQNPONQMTMVN RNHREVH",
"H\\LZO[T[VZWYXWXUWSVRTQPPNOMNLLLJMHNGPFUFXG RR\\T]U_TaRbOb",
"J[NZP[T[VZWXWWVUTTQTOSNQNPONQMTMVN RR\\T]U_TaRbOb",
"H\\LZO[T[VZWYXWXUWSVRTQPPNOMNLLLJMHNGPFUFXG RN>RAV>",
"J[NZP[T[VZWXWWVUTTQTOSNQNPONQMTMVN RNERHVE",
"JZLFXF RR[RF RR\\T]U_TaRbOb",
"MYOMWM RRFRXSZU[W[ RR\\T]U_TaRbOb",
"JZLFXF RR[RF RN>RAV>",
"M[OMWM RYFXI RRFRXSZU[W[",
"JZLFXF RR[RF RNQVQ",
"MYOMWM RRFRXSZU[W[ ROSUS",
"G]LFLWMYNZP[T[VZWYXWXF RMAN@P?TAV@W?",
"H[VMV[ RMMMXNZP[S[UZVY RMHNGPFTHVGWF",
"G]LFLWMYNZP[T[VZWYXWXF RM@W@",
"H[VMV[ RMMMXNZP[S[UZVY RMGWG",
"G]LFLWMYNZP[T[VZWYXWXF RN>O@QASAU@V>",
"H[VMV[ RMMMXNZP[S[UZVY RNEOGQHSHUGVE",
"G]LFLWMYNZP[T[VZWYXWXF RRAP@O>P<R;T<U>T@RA",
"H[VMV[ RMMMXNZP[S[UZVY RRHPGOEPCRBTCUETGRH",
"G]LFLWMYNZP[T[VZWYXWXF RQ>NA RX>UA",
"H[VMV[ RMMMXNZP[S[UZVY RQENH RXEUH",
"G]LFLWMYNZP[T[VZWYXWXF RR[P]O_PaRbTb",
"H[VMV[ RMMMXNZP[S[UZVY RV[T]S_TaVbXb",
"F^IFN[RLV[[F RNAR>VA",
"G]JMN[RQV[ZM RNHREVH",
"I[RQR[ RKFRQYF RNAR>VA",
"JZMMR[ RWMR[P`OaMb RNHREVH",
"JZLFXF RR[RF RN?O@NAM@N?NA RV?W@VAU@V?VA",
"H\\KFYFK[Y[ RT>QA",
"IZLMWML[W[ RTEQH",
"H\\KFYFK[Y[ RR?Q@RAS@R?RA",
"IZLMWML[W[ RRFQGRHSGRFRH",
"H\\KFYFK[Y[ RN>RAV>",
"IZLMWML[W[ RNERHVE",
"MYR[RISGUFWF",
"H[M[MF RMNOMSMUNVOWQWWVYUZS[O[MZ RJHRH",
"C\\LFL[T[VZWYXWXTWRVQSPLP RFKFIGGIFSFUGVHWJWLVNUOSP",
"G\\VFLFL[R[UZWXXVXSWQUORNLN",
"H[WFMFM[ RMNOMSMUNVOWQWWVYUZS[O[MZ",
"H]MFM[S[VZXXYVYSXQVOSNMN",
"IZNMN[S[UZVXVUUSSRNR",
"I^MHNGQFSFVGXIYKZOZRYVXXVZS[Q[NZMY",
"F[WYVZS[Q[NZLXKVJRJOKKLINGQFSFVGWH RMHKGJEKCLB",
"HZVZT[P[NZMYLWLQMONNPMTMVN RTMTIUGWFYF",
28,
"C\\FKFIGGIFQFTGVIWKXOXRWVVXTZQ[L[LF",
"H]NFXFX[R[OZMXLVLSMQOORNXN",
"I\\MFWFW[ RWNUMQMONNOMQMWNYOZQ[U[WZ",
"I\\Q[T[VZWYXWXQWOVNTMQMONNOMQMWNYOZQ[T\\V]W_VaTbPbNa",
"I\\WPPP RM[W[WFMF",
"F^MHNGQFSFVGXIYKZOZRYVXXVZS[Q[NZLXKVJRZP",
"G[PPTP RWGUFPFNGMHLJLLMNNOPPMQLRKTKWLYMZO[U[WZ",
"HZTPMP RM[MFWF RM[M_LaJbHb",
"MYOMWM RR[RISGUFWF RR[R_QaObMb",
"F[VGTFQFNGLIKKJOJRKVLXNZQ[S[VZWYWRSR RMHKGJEKCLB",
"I[KFU[U_TaRbPaO_O[YF",
"D`I[IF RIOJNLMOMQNRPRXSZU[X[ZZ[Y\\W\\P[NZM",
"MZRFRWSYTZV[X[",
"MWR[RF RNPVP",
"G_L[LF RX[OO RLRWGYF[G\\I\\K",
"IZNMN[ RPSV[ RVMNU RNMNIOGQFSF",
"MXU[SZRXRF RNOVO",
"JZRMM[ RMFOFPGRMW[ RNLTH",
"Ca\\F\\[ R\\XZZX[V[TZSYRWRF RRWQYPZN[L[JZIYHWHF",
"G]L[LFX[XF RL[L_KaIbGb",
"I\\NMN[ RNOONQMTMVNWPWb",
32,
"G]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF RVGXFYDXBWA",
"H[P[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ RUNWMXKWIVH",
"DaSGQFMFKGIIHMHTIXKZM[Q[SZUXVTVMUISGUFYF[G\\I\\b",
"E^RNPMMMKNJOIQIWJYKZM[P[RZSYTWTQSORNTMVMXNYPYb",
"C\\LFL[ RFKFIGGIFTFVGWHXJXMWOVPTQLQ",
"H[MMMb RMNOMSMUNVOWQWWVYUZS[O[MZ RRMRISGUFWF",
"G\\LFL[ RQVXb RLKTKVLWMXOXRWTVUTVLV",
"H\\XZU[P[NZMYLWLUMSNRPQTPVOWNXLXJWHVGTFOFLG",
"IZVZT[P[NZMXMWNUPTSTUSVQVPUNSMPMNN",
"H[W[L[SPLFWF",
"JYWbUbSaR_RIQGOFMGLIMKOLQKRI",
"MYOMWM RRFRXSZU[W[ RW[W_VaTbRb",
"HZR[RF RKKKILGNFXF",
"MYOMWM RWFUFSGRIRXSZU[W[",
"JZLFXF RR[RF RR[R_SaUbWb",
"G]LFLWMYNZP[T[VZWYXWXF RXFZE[CZAY@",
"H[VMV[ RMMMXNZP[S[UZVY RVMXLYJXHWG",
"F^ZFUFUJWKYMZPZUYXWZT[P[MZKXJUJPKMMKOJOFJF",
"G]LFLWMYNZP[T[VZXXYVYIXGWF",
"I`RQR[ RKFRQXGZF\\G]I]K",
"J^MMR[ RMbOaP`R[VNXMZN[P[R",
"H\\KFYFK[Y[ RNPVP",
"IZLMWML[W[ RNTVT",
2,
"H\\YFLFSNPNNOMPLRLWMYNZP[V[XZYY",
"JZWMNMUVRVPWOXNZN^O`PaRbUbWa",
"JZMMVMOTSTUUVWVXUZS[Q[O\\N^N_OaQbVb",
"H\\LHMGOFTFVGWHXJXLWOK[X[ RNSVS",
"H\\WFMFLPMOONTNVOWPXRXWWYVZT[O[MZLY",
"JZVMOMNSPRSRUSVUVXUZS[P[NZ",
"J^MZP[T[WZYXZVZSYQWOTNPNPF RLITI",
"H[MMMb RMONNPMTMVNWPWSVUM^",
"MWRFRb",
"JZOFOb RUFUb",
"MWRFRb ROWUW ROQUQ",
"MWRYSZR[QZRYR[ RRSQGRFSGRSRF",
"GpL[LFQFTGVIWKXOXRWVVXTZQ[L[ R_FmF_[m[ Rb>fAj>",
"GmL[LFQFTGVIWKXOXRWVVXTZQ[L[ R_MjM_[j[ RaEeHiE",
"ImW[WF RWZU[Q[OZNYMWMQNOONQMUMWN R_MjM_[j[ RaEeHiE",
"HiW[M[MF RdFdUcXaZ^[\\[",
"HcW[M[MF R^M^_]a[bZb R^F]G^H_G^F^H",
"MbU[SZRXRF R]M]_\\aZbYb R]F\\G]H^G]F]H",
"GmL[LFX[XF RhFhUgXeZb[`[",
"GgL[LFX[XF RbMb_aa_b^b RbFaGbHcGbFbH",
"IfNMN[ RNOONQMTMVNWPW[ RaMa_`a^b]b RaF`GaHbGaFaH",
"I[MUWU RK[RFY[ RN>RAV>",
"I\\W[WPVNTMPMNN RWZU[P[NZMXMVNTPSUSWR RNERHVE",
"MWR[RF RN>RAV>",
"MWR[RM RNERHVE",
"G]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF RN>RAV>",
"H[P[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ RNERHVE",
"G]LFLWMYNZP[T[VZWYXWXF RN>RAV>",
"H[VMV[ RMMMXNZP[S[UZVY RNERHVE",
"G]LFLWMYNZP[T[VZWYXWXF RN?O@NAM@N?NA RV?W@VAU@V?VA RM;W;",
"H[VMV[ RMMMXNZP[S[UZVY RNFOGNHMGNFNH RVFWGVHUGVFVH RM@W@",
"G]LFLWMYNZP[T[VZWYXWXF RN?O@NAM@N?NA RV?W@VAU@V?VA RT9Q<",
"H[VMV[ RMMMXNZP[S[UZVY RNFOGNHMGNFNH RVFWGVHUGVFVH RT>QA",
"G]LFLWMYNZP[T[VZWYXWXF RN?O@NAM@N?NA RV?W@VAU@V?VA RN9R<V9",
"H[VMV[ RMMMXNZP[S[UZVY RNFOGNHMGNFNH RVFWGVHUGVFVH RN>RAV>",
"G]LFLWMYNZP[T[VZWYXWXF RN?O@NAM@N?NA RV?W@VAU@V?VA RP9S<",
"H[VMV[ RMMMXNZP[S[UZVY RNFOGNHMGNFNH RVFWGVHUGVFVH RP>SA",
33,
"I[MUWU RK[RFY[ RN?O@NAM@N?NA RV?W@VAU@V?VA RM;W;",
"I\\W[WPVNTMPMNN RWZU[P[NZMXMVNTPSUSWR RNFOGNHMGNFNH RVFWGVHUGVFVH RM@W@",
"I[MUWU RK[RFY[ RR?Q@RAS@R?RA RM;W;",
"I\\W[WPVNTMPMNN RWZU[P[NZMXMVNTPSUSWR RRFQGRHSGRFRH RM@W@",
"F`JURU RRPYP RH[OF\\F RRFR[\\[ RO@Y@",
"D`INKMOMQNRP R[ZY[U[SZRXRPSNUMYM[N\\P\\RRSKSITHVHXIZK[O[QZRX RMGWG",
"F[VGTFQFNGLIKKJOJRKVLXNZQ[S[VZWYWRSR RSV[V",
"I\\WMW^V`UaSbPbNa RWZU[Q[OZNYMWMQNOONQMUMWN RS^[^",
"F[VGTFQFNGLIKKJOJRKVLXNZQ[S[VZWYWRSR RN>RAV>",
"I\\WMW^V`UaSbPbNa RWZU[Q[OZNYMWMQNOONQMUMWN RNERHVE",
"G\\L[LF RX[OO RXFLR RN>RAV>",
"IZN[NF RPSV[ RVMNU RJANDRA",
"G]R[P]O_PaRbTb RPFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF",
"H[R[P]O_PaRbTb RP[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[",
"G]R[P]O_PaRbTb RPFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF RM@W@",
"H[R[P]O_PaRbTb RP[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ RMGWG",
"H\\KFXFQNTNVOWPXRXWWYVZT[N[LZKY RN>RAV>",
"JZMMVMOVRVTWUXVZV^U`TaRbObMa RNERHVE",
"MWRMR_QaObNb RNERHVE",
"GpL[LFQFTGVIWKXOXRWVVXTZQ[L[ R_FmF_[m[",
"GmL[LFQFTGVIWKXOXRWVVXTZQ[L[ R_MjM_[j[",
"ImW[WF RWZU[Q[OZNYMWMQNOONQMUMWN R_MjM_[j[",
"F[VGTFQFNGLIKKJOJRKVLXNZQ[S[VZWYWRSR RT>QA",
"I\\WMW^V`UaSbPbNa RWZU[Q[OZNYMWMQNOONQMUMWN RTEQH",
"CaH[HF RHPTP RTFTXUZW[Z[\\Z]X]M",
"G\\LFLb RLINGPFTFVGWHXJXOWRUUL^",
"G]L[LFX[XF RP>SA",
"I\\NMN[ RNOONQMTMVNWPW[ RPESH",
"I[MUWU RK[RFY[ RZ9X< RR;P<O>P@RAT@U>T<R;",
"I\\W[WPVNTMPMNN RWZU[P[NZMXMVNTPSUSWR RZ@XC RRBPCOEPGRHTGUETCRB",
"F`JURU RRPYP RH[OF\\F RRFR[\\[ RV>SA",
"D`INKMOMQNRP R[ZY[U[SZRXRPSNUMYM[N\\P\\RRSKSITHVHXIZK[O[QZRX RTEQH",
"G]ZFJ[ RP[NZLXKTKMLINGPFTFVGXIYMYTXXVZT[P[ RT>QA",
"H[XMK[ RP[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ RTEQH",
"I[MUWU RK[RFY[ ROAL> RVAS>",
"I\\W[WPVNTMPMNN RWZU[P[NZMXMVNTPSUSWR ROHLE RVHSE",
"I[MUWU RK[RFY[ RNAO?Q>S>U?VA",
"I\\W[WPVNTMPMNN RWZU[P[NZMXMVNTPSUSWR RNHOFQESEUFVH",
"H[MPTP RW[M[MFWF ROAL> RVAS>",
"I[VZT[P[NZMXMPNNPMTMVNWPWRMT ROHLE RVHSE",
"H[MPTP RW[M[MFWF RNAO?Q>S>U?VA",
"I[VZT[P[NZMXMPNNPMTMVNWPWRMT RNHOFQESEUFVH",
"MWR[RF ROAL> RVAS>",
"MWR[RM ROHLE RVHSE",
"MWR[RF RNAO?Q>S>U?VA",
"MWR[RM RNHOFQESEUFVH",
"G]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF ROAL> RVAS>",
"H[P[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ ROHLE RVHSE",
"G]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF RNAO?Q>S>U?VA",
"H[P[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ RNHOFQESEUFVH",
"G\\X[QQ RL[LFTFVGWHXJXMWOVPTQLQ ROAL> RVAS>",
"KXP[PM RPQQORNTMVM RPHME RWHTE",
"G\\X[QQ RL[LFTFVGWHXJXMWOVPTQLQ RNAO?Q>S>U?VA",
"KXP[PM RPQQORNTMVM ROHPFRETEVFWH",
"G]LFLWMYNZP[T[VZWYXWXF ROAL> RVAS>",
"H[VMV[ RMMMXNZP[S[UZVY ROHLE RVHSE",
"G]LFLWMYNZP[T[VZWYXWXF RNAO?Q>S>U?VA",
"H[VMV[ RMMMXNZP[S[UZVY RNHOFQESEUFVH",
"H\\LZO[T[VZWYXWXUWSVRTQPPNOMNLLLJMHNGPFUFXG RS`SaRcQd",
"J[NZP[T[VZWXWWVUTTQTOSNQNPONQMTMVN RS`SaRcQd",
"JZLFXF RR[RF RS`SaRcQd",
"MYOMWM RRFRXSZU[W[ RU`UaTcSd",
"I]VRXTYVY[X]V_T`Lb RLHMGOFUFWGXHYJYNXPVRTSNU",
"J[UWVXWZW]V_U`SaMb RMNOMSMUNVOWQWTVVUWSXOY",
"G]L[LF RLPXP RX[XF RN>RAV>",
"H[M[MF RV[VPUNSMPMNNMO RI>MAQ>",
"G]L[LFX[XF RX[Xb",
"IbWFWXXZZ[\\[^Z_X^V\\UZVV^ RWNUMQMONNOMQMWNYOZQ[T[VZWX",
"G]NFLGKIKKLMMNOO RVFXGYIYKXMWNUO ROOUOWPXQYSYWXYWZU[O[MZLYKWKSLQMPOO",
"J[MJMMNORQVOWMWJ RPQTQVRWTWXVZT[P[NZMXMTNRPQ",
"H\\KFYFK[Y[ RY[Y_XaVbTb",
"IZLMWML[W[ RW[W_VaTbRb",
"I[MUWU RK[RFY[ RR?Q@RAS@R?RA",
"I\\W[WPVNTMPMNN RWZU[P[NZMXMVNTPSUSWR RRFQGRHSGRFRH",
"H[MPTP RW[M[MFWF RR\\T]U_TaRbOb",
"I[VZT[P[NZMXMPNNPMTMVNWPWRMT RR\\T]U_TaRbOb",
"G]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF RN?O@NAM@N?NA RV?W@VAU@V?VA RM;W;",
"H[P[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ RNFOGNHMGNFNH RVFWGVHUGVFVH RM@W@",
"G]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF RMAN@P?TAV@W? RM;W;",
"H[P[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ RMHNGPFTHVGWF RM@W@",
"G]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF RR?Q@RAS@R?RA",
"H[P[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ RRFQGRHSGRFRH",
"G]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF RR?Q@RAS@R?RA RM;W;",
"H[P[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ RRFQGRHSGRFRH RM@W@",
"I[RQR[ RKFRQYF RM@W@",
"JZMMR[ RWMR[P`OaMb RMGWG",
"M]RFRXSZU[W[YZZXYVWUUVQ^",
"IbNMN[ RNOONQMTMVNWPWXXZZ[\\[^Z_X^V\\UZVV^",
"M]OMWM RRFRXSZU[W[YZZXYVWUUVQ^",
"MWRMR_QaObNb",
"D`R[RF RRZP[L[JZIYHWHQIOJNLMPMRN RTMXMZN[O\\Q\\W[YZZX[T[RZ",
"D`RMRb RRZP[L[JZIYHWHQIOJNLMPMRN RTMXMZN[O\\Q\\W[YZZX[T[RZ",
"I[MUWU RK[RFY[ RXCL`",
"F[WYVZS[Q[NZLXKVJRJOKKLINGQFSFVGWH RXCL`",
"HZVZT[P[NZMYLWLQMONNPMTMVN RWHM`",
"HYW[M[MF RIOQO",
"JZLFXF RR[RF RXCL`",
"J[P[R^T_W_ RNZP[T[VZWXWWVUTTQTOSNQNPONQMTMVN",
"IZLMWML[N[P\\R^T_W_",
"J^MGPFTFWGYIZKZNYPWRTSPSP[",
"J^NNPMTMVNWOXQXSWUVVTWPWP[",
"G\\SPVQWRXTXWWYVZT[L[LFSFUGVHWJWLVNUOSPLP RIUOU",
"G]IM[M RLFLWMYNZP[T[VZWYXWXF",
"I[Y[RFK[",
"H[MPTP RW[M[MFWF RXCL`",
"I[VZT[P[NZMXMPNNPMTMVNWPWRMT RWHM`",
"JZUFUUTXRZO[M[ RQPYP",
"MWRMR_QaObNb ROTUT RRFQGRHSGRFRH",
"G]XFX^Y`Za\\b^b RXIVGTFPFNGLIKMKTLXNZP[T[VZXX",
"I\\WMW^X`Ya[b]b RWZU[Q[OZNYMWMQNOONQMUMWN",
"G\\X[QQ RL[LFTFVGWHXJXMWOVPTQLQ RIQOQ",
"KXP[PM RPQQORNTMVM RMTUT",
"I[KIYI RRQR[ RKFRQYF",
"JZLQXQ RMMR[ RWMR[P`OaMb",
"H[MMMXNZP[T[VZ RMNOMTMVNWPWRVTTUOUMV",
34,
"G\\K[NQOOPNRMTMVNWOXRXVWYVZT[R[PZOYNWMPLNJM",
"H[RFPFNGMIM[ RMNOMSMUNVOWQWWVYUZS[O[MZ",
"J\\NNPMTMVNWOXQXWWYVZT[P[NZ",
"HZVNTMPMNNMOLQLWMYNZP[S[UZVXUVSUQVM^",
"I\\W[WF RWZU[Q[OZNYMWMQNOONQMUMWN RW[W_XaZb\\b",
"I\\\\FZFXGWIW[ RWZU[Q[OZNYMWMQNOONQMUMWN",
"I[NZP[T[VZWXWPVNTMPMNNMPMRWT",
33,
"IbNNPMTMVNWPWXVZT[P[NZMXMV\\S\\U]W_X`X",
35,
"J[TTVSWQWPVNTMPMNN RRTTTVUWWWXVZT[P[NZ",
"JaRTTTVUWWWXVZT[P[NZ RNNPMTMVNWPWQVSTT[S[U\\W^X_X",
"H[TTVSWQWPVNTMPMNNMOLRLVMYNZP[T[VZWXWWVUTTRT",
"MWRMR_QaObNb ROTUT",
"I\\WMW^V`UaSbPbNa RWZU[Q[OZNYMWMQNOONQMUMWN RWMWIXGZF\\F",
"I\\WYVZT[P[NZMXMQNOONQMWMW^V`UaSbMb",
"HZUNSMPMNNMOLQLWMYNZP[T[VZVUSU",
"JZMMU[U_TaRbPaO_O[WM",
"JZMMTVUXTZR[PZOXPVWM",
"I\\WMWb RNMNXOZQ[T[VZWY",
"H[RFPFNGMIM[ RV[VPUNSMPMNNMO",
"H[RFPFNGMIM[ RV[VPUNSMPMNNMO RV[V_UaSbQb",
"MWR[RM ROTUT RRFQGRHSGRFRH",
36,
"MWR[RM RU[O[ RUMOM",
"MXU[SZRXRF RMONNPMTOVNWM",
"IYU[SZRXRF RRQQOONMOLQMSOTWT",
"MXRFR_SaUbWb",
"GZLFLXMZO[ RLMVMOVRVTWUXVZV^U`TaRbObMa",
"D`[M[[ R[YZZX[U[SZRXRM RRXQZO[L[JZIXIM",
"D`[M[[ R[YZZX[U[SZRXRM RRXQZO[L[JZIXIM R[[[b",
"D`I[IM RIOJNLMOMQNRPR[ RRPSNUMXMZN[P[[ R[[[_ZaXbVb",
"I\\NMN[ RNOONQMTMVNWPW[ RN[N_MaKbIb",
"I\\NMN[ RNOONQMTMVNWPW[ RW[W_XaZb\\b",
"H[M[MMV[VM",
37,
"E]RTXT RRMR[ RZMMMKNJOIQIWJYKZM[Z[",
"G]RTRXSZU[V[XZYXYQXOWNUMOMMNLOKQKXLZN[O[QZRX",
38,
"LYTMT[ RTWSYRZP[N[",
"LYTMT[ RTWSYRZP[N[ RTMTF",
"LYTMT[ RTWSYRZP[N[ RT[T_UaWbYb",
"KXP[PM RPQQORNTMVM RP[Pb",
"KXP[PM RPQQORNTMVM RP[P_QaSbUb",
"KXM[S[ RVMTMRNQOPRP[",
"LYW[Q[ RNMPMRNSOTRT[",
"I[RUW[ RN[NMTMVNWPWRVTTUNU",
"I[RSWM RNMN[T[VZWXWVVTTSNS",
"J[NZP[T[VZWXWWVUTTQTOSNQNPONQMTMVN RN[N_OaQbSb",
"KYWFUFSGRIR_QaObMb",
"MWRMR_QaObNb ROTUT RRMRISGUFWF",
"KYMFOFQGRIRXSZU[W[",
"KYWFUFSGRIR_QaObMaL_M]O\\V\\",
"KWU[M[ RRbRPQNOMMM",
"MYOMWM RRFR_SaUbWb",
"H[JRYR RVMV[ RMMMXNZP[S[UZVY",
"I\\XMUMUPWRXTXWWYVZT[Q[OZNYMWMTNRPPPMMM",
"H[MMMXNZP[S[UZVYWWWPVNUM",
"JZW[RMM[",
"G]Z[VMRWNMJ[",
"JZW[RM RM[RMTHUGWF",
"KYRTR[ RMMRTWM",
"IZLMWML[W[ RW[W_XaZb\\b",
"IZLMWML[T[VZWXVVTURVN^",
"JZMMVMOVRVTWUXVZV^U`TaRbObMa",
"JZMMVMOVRVTWUXVZV^U`TaRbPbNaM_N]P\\R]Uc",
"J^MGPFTFWGYIZKZNYPWRTSPSP[",
"FZWGTFPFMGKIJKJNKPMRPSTST[",
"J^MZP[T[WZYXZVZSYQWOTNPNPF",
"F[WHVGSFQFNGLIKKJOJYK]L_NaQbSbVaW`",
"G]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF RROQPRQSPRORQ",
"I[STVUWWWXVZT[N[NMSMUNVPVQUSSTNT",
"I\\PTNUMWMXNZP[T[VZWYXVXRWOVNTMPMNNMPMQNSPTRT",
"HZUNSMPMNNMOLQLWMYNZP[T[VZVUSU RUMUIVGXFZF",
"H[MTVT RMMM[ RVMV[",
"LXRMR_QaObMaL_M]O\\V\\ RRFQGRHSGRFRH",
"J[VMVb RTUNM RN[VS",
"JYOMO[V[",
"I\\WMWb RWZU[Q[OZNYMWMQNOONQMUMWN RWMWIXGZF\\F",
"J^MGPFTFWGYIZKZNYPWRTSPSP[ RLXTX",
"FZWGTFPFMGKIJKJNKPMRPSTST[ RPXXX",
"D`R[RF RRM]MR[][ RRZP[L[JZIYHWHQIOJNLMPMRN",
"E`RFR[ RRNPMMMKNJOIQIWJYKZM[P[RZ RRM\\MUVXVZW[X\\Z\\^[`ZaXbUbSa",
"D`R[RF RRM]MR[Z[\\Z]X\\VZUXVT^ RRZP[L[JZIYHWHQIOJNLMPMRN",
"G^IMQM RLFLXMZO[QZS[W[YZZXZWYUWTTTRSQQQPRNTMWMYN",
"I[KMTM RNFNXOZQ[T[ RYFWFUGTIT_SaQbOb",
"F^HMPM RKFKXLZN[P[RZ RZNXMTMRNQOPQPWQYRZT[W[YZZXYVWUUVQ^",
"F]HMPMP[ RK[KILGNFPF RPOQNSMVMXNYPY_XaVbTb",
"G^LFLXMZO[QZS[W[YZZXZWYUWTTTRSQQQPRNTMWMYN",
"H^MM[MP[ RMFMXNZP[[[",
"G]JSN[RUV[ZS RJFNNRHVNZF",
"G]XXXSLSLX RXKXFLFLK",
"I\\WMWb RNMNXOZQ[T[VZWY RNMNIMGKFIF",
"I\\\\bZbXaW_WM RNMNXOZQ[T[VZWY RNMNIMGKFIF",
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
"H[MFM[ RXPMP",
"IZNTVT RNMN[",
"G]R[RF RKOKFYFYO",
"I[R[RF RMOMFWFWO",
"MWSFQJ",
"MWS[Q_",
"G]LFL[XFX[",
"H\\MMM[WMW[",
23,
23,
"NVR`RcSdTd",
"J\\NZP[T[VZWYXWXQWOVNTMPMNN",
"HZVZT[P[NZMYLWLQMONNPMTMVN RRSQTRUSTRSRU",
"J\\NZP[T[VZWYXWXQWOVNTMPMNN RRSQTRUSTRSRU",
"MWSZS[R]Q^ RRNSORPQORNRP",
23,
23,
23,
23,
23,
25,
"LXNFOGNHMGNFNH RVFWGVHUGVFVH RT>QA",
"G[MUWU RK[RFY[ RMEJH",
26,
"B[MPTP RW[M[MFWF RHEEH",
"A]L[LF RLPXP RX[XF RGEDH",
"GWR[RF RMEJH",
24,
"B]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF RHEEH",
24,
"@[RQR[ RKFRQYF RFECH",
"@^J[O[OWMVKTJQJLKIMGPFTFWGYIZLZQYTWVUWU[Z[ RFECH",
"MXRMRXSZU[ RNFOGNHMGNFNH RVFWGVHUGVFVH RT>QA",
3,
4,
"HZM[MFXF",
"I[K[RFY[K[",
6,
"H\\KFYFK[Y[",
7,
"F^OPUP RPFTFVGXIYKZNZSYVXXVZT[P[NZLXKVJSJNKKLINGPF",
8,
9,
"I[K[RFY[",
10,
"G]L[LFX[XF",
"H[L[W[ RLFWF RUPNP",
11,
"G]L[LFXFX[",
12,
24,
"H[W[L[SPLFWF",
13,
15,
"G]R[RF RPITIWJYLZNZRYTWVTWPWMVKTJRJNKLMJPI",
14,
"G]R[RF RHFJGKIKNLQMROSUSWRXQYNYIZG\\F",
"F^J[O[OWMVKTJQJLKIMGPFTFWGYIZLZQYTWVUWU[Z[",
27,
"I[RQR[ RKFRQYF RN?O@NAM@N?NA RV?W@VAU@V?VA",
39,
40,
41,
42,
"H[MMMXNZP[S[UZVYWWWPVNUM RNFOGNHMGNFNH RVFWGVHUGVFVH RT>QA",
34,
"H[SOUPVQWSWWVYUZS[P[NZMY RKbLaM_MINGPFSFUGVIVLUNSOQO",
"JZRYRb RLMMMNNRYWM",
"H[SMPMNNMOLQLWMYNZP[S[UZVYWWWQVOUNSMPLNKMINGPFTFVG",
35,
"HZMFWFPMNPMSMWNYOZQ[S[U\\V^V_UaSbRb",
"I\\NMN[ RNOONQMTMVNWPWb",
"H[LPWP RPFSFUGVHWKWVVYUZS[P[NZMYLVLKMHNGPF",
36,
31,
"JZRMM[ RMFOFPGRMW[",
"H^MMMb RWXXZZ[ RMXNZP[T[VZWXWM",
"J[MMR[WPWOVM",
"HZMFWF RQFOGNINLONQOUO RQOOPNQMSMWNYOZQ[S[U\\V^V_UaSbRb",
19,
"F]VMV[ ROMOXNZL[ RZMMMKNJP",
"H\\MbMQNOONQMTMVNWOXQXWWYVZT[Q[OZMX",
"HZVNTMPMNNMOLQLWMYNZP[S[U\\V^V_UaSb",
"H\\YMPMNNMOLQLWMYNZP[S[UZVYWWWQVOUNSM",
"H\\LPMNOMXM RRMRXSZU[",
"H[MMMXNZP[S[UZVYWWWPVNUM",
"G]MMLNKPKVLXNZP[T[VZXXYVYPXNVMUMSNRPRb",
"IZWMLb RLMNNOPT_UaWb",
"G]RMRb RKMKVLXNZP[T[VZXXYVYM",
43,
"LXNFOGNHMGNFNH RVFWGVHUGVFVH RRMRXSZU[",
"H[MMMXNZP[S[UZVYWWWPVNUM RNFOGNHMGNFNH RVFWGVHUGVFVH",
29,
44,
45,
"G\\L[LF RXFLR ROOX[Qb",
"H[SOUPVQWSWWVYUZS[P[NZMXMINGPFSFUGVIVLUNSOQO",
"H[JPKQLSLVMYNZP[S[UZVYWVWKVHUGSFPFNGMHLJLLMNNOPPWP",
"I\\KFMFOGQIRKR[ RRKSHTGVFWFYGZI",
"NiTEQH RXFZF\\G^I_K_[ R_K`HaGcFdFfGgI",
"I\\KFMFOGQIRKR[ RRKSHTGVFWFYGZI RN?O@NAM@N?NA RV?W@VAU@V?VA",
38,
"F^RTRX R[MIM RMMLNKPKXLZN[O[QZRXSZU[V[XZYXYPXNWM",
"IZLMNNOPOXNZM[LZLXMVVRWPWNVMUNTPTXUZW[V^U`TaRb",
"G]R[Rb RPFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF",
"H[R[Rb RP[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[",
"FZWFQFNGLIKKJOJRKVLXNZQ[R[T\\U^U_TaSbQb",
"HZVMPMNNMOLQLWMYNZP[R[T\\U^U_TaRbPb",
"HZTPMP RM[MFWF",
"MZVPRP RWFUFSGRIR_QaOb",
"H\\MFOGPILSXNTXUZW[",
"I[RFMPWPR[",
"H\\NGNL RXIULTNTW RKIMGPFTFVGXIYKZOZUYYX[",
"H\\L[UR RR[WV RLMPNSPURWVXZXb",
"CaRWRR R\\XY]V`SaMa RLFJGHIGLGUHXJZL[N[PZQYRWSYTZV[X[ZZ\\X]U]L\\IZGXF",
"G]RTRX RXZW\\S`PaOa RMMLNKPKXLZN[O[QZRXSZU[V[XZYXYPXNWM",
"G]XFXb RPFNGLIKMKTLXNZP[T[VZXX",
"I\\WMWb RQMONNOMQMWNYOZQ[T[VZWY",
"F]KFK[ RKQMOPNTNVOXQYTYWXZW\\U^R`Nb",
"I[WLWMVPTRRSPSNRMPMONMPLRLTMVPWSWWVYUZS[M[",
"F]KHLGOFTFWGXHYJYLXOVQJ[N^Q_V_Y^",
"J[NNPMTMVNWPWRVTTVN[P]R^U^W]",
"G]I[[[ RIFJFLGXZZ[ R[FZFXGLZJ[",
"H[KMMNVZX[K[MZVNXM",
"G\\XEVFOFMGLHKJKWLYMZO[T[VZWYXWXPWNVMTLNLLMKN",
"H[WEVFTGPGNHMILKLWMYNZP[S[UZVYWWWQVOUNSMOMMNLO",
"G]RFRb RKQKMYMYQ",
"I[MMWM RRFRb",
"IZLMNNOPOXNZM[LZLXMVVRWPWNVMUNTPTXUZW[",
"H\\WbQbOaN`M^MQNOONQMTMVNWOXQXWWYVZT[Q[OZMX",
17,
18,
32,
"HZLTST RVZT[P[NZMYLWLQMONNPMTMVN",
"J\\XTQT RNZP[T[VZWYXWXQWOVNTMPMNN",
"G\\LFL[ RLKTKVLWMXOXRWTVUTVLV",
"H[MFMb RMNOMSMUNVOWQWWVYUZS[O[MZ",
5,
"F^K[KFRMYFY[",
"G]LbLMRSXMX[",
"G\\J`S` RMbMQNOONQMTMVNWOXQXWWYVZT[Q[OZMX",
"I^MYNZQ[S[VZXXYVZRZOYKXIVGSFQFNGMH",
"F[WYVZS[Q[NZLXKVJRJOKKLINGQFSFVGWH RROQPRQSPRORQ",
"I^MYNZQ[S[VZXXYVZRZOYKXIVGSFQFNGMH RROQPRQSPRORQ",
"H[MPTP RW[M[MFWF RP>SA",
"H[MPTP RW[M[MFWF RN?O@NAM@N?NA RV?W@VAU@V?VA",
"JbLFXF RR[RF RRMXM[N]P^S^\\]_[aXbVb",
"HZM[MFXF RT>QA",
"F[JPTP RWYVZS[Q[NZLXKVJRJOKKLINGQFSFVGWH",
"H\\LZO[T[VZWYXWXUWSVRTQPPNOMNLLLJMHNGPFUFXG",
8,
27,
"JZUFUUTXRZO[M[",
"AbC[D[FZGXILJILGOFRFR[X[[Z]X^V^S]Q[OXNRN",
"AbF[FF RRFR[X[[Z]X^V^S]Q[OXNFN",
"JbLFXF RR[RF RRMXM[N]P^S^[",
"G\\L[LF RX[OO RXFLR RT>QA",
"G]LFL[XFX[ RP>SA",
"G[KFRT RYFPXNZL[K[ RN>O@QASAU@V>",
"G]R[R` RLFL[X[XF",
3,
"G\\VFLFL[R[UZWXXVXSWQUORNLN",
4,
"HZM[MFXF",
"F^[`[[I[I` RW[WFRFPGOHNJL[",
6,
"BbOOF[ RR[RF RRRFF R^[UO R^FRR",
"I]PPTP RMGOFTFVGWHXJXLWNVOTPWQXRYTYWXYWZU[O[MZ",
"G]LFL[XFX[",
"G]LFL[XFX[ RN>O@QASAU@V>",
9,
"F\\W[WFTFQGOINLLXKZI[H[",
10,
7,
11,
"G]L[LFXFX[",
12,
5,
13,
"G[KFRT RYFPXNZL[K[",
"G]R[RF RPITIWJYLZNZRYTWVTWPWMVKTJRJNKLMJPI",
14,
"G]XFX[ RLFL[Z[Z`",
"H\\WFW[ RLFLNMPNQPRWR",
"CaRFR[ RHFH[\\[\\F",
"CaRFR[ RHFH[\\[\\F R\\[^[^`",
"F]HFMFM[S[VZXXYVYSXQVOSNMN",
"Da\\F\\[ RIFI[O[RZTXUVUSTQROONIN",
"H]MFM[S[VZXXYVYSXQVOSNMN",
"I^ZQPQ RMHNGQFSFVGXIYKZOZRYVXXVZS[Q[NZMY",
"CaHFH[ ROPHP RTFXFZG\\I]M]T\\XZZX[T[RZPXOTOMPIRGTF",
"G\\RQK[ RW[WFOFMGLHKJKMLOMPOQWQ",
"I\\W[WPVNTMPMNN RWZU[P[NZMXMVNTPSUSWR",
"H[WEVFTGPGNHMILKLWMYNZP[S[UZVYWWWQVOUNSMOMMNLO",
"I[STVUWWWXVZT[N[NMSMUNVPVQUSSTNT",
"JYO[OMWM",
"H[WOVNTMPMNNMOLQLWMYNZP[S[UZVYWWWJVHUGSFOFMG",
"I[VZT[P[NZMXMPNNPMTMVNWPWRMT",
"F^QTJ[ RRUJM RRMR[ RZ[ST RZMRU",
"K[RTTT RNNPMTMVNWPWQVSTTVUWWWXVZT[P[NZ",
"H\\MMM[WMW[",
"H\\MMM[WMW[ RNEOGQHSHUGVE",
31,
"I[V[VMSMQNPPOXNZL[",
"G]L[LMRXXMX[",
"H[MTVT RMMM[ RVMV[",
19,
"H[M[MMVMV[",
"H[MMMb RMNOMSMUNVOWQWWVYUZS[O[MZ",
17,
"KYMMWM RRMR[",
"JZMMR[ RWMR[P`OaMb",
38,
"IZL[WM RLMW[",
"I\\WMW[ RNMN[Y[Y`",
"J\\VMV[ RNMNROTQUVU",
"F^RMR[ RKMK[Y[YM",
"F^RMR[ RKMK[Y[YM RY[[[[`",
"HZJMNMN[S[UZVXVUUSSRNR",
"F^YMY[ RKMK[P[RZSXSURSPRKR",
"IZNMN[S[UZVXVUUSSRNR",
"J\\XTQT RNNPMTMVNWOXQXWWYVZT[P[NZ",
"E_JTPT RJMJ[ RT[RZQYPWPQQORNTMWMYNZO[Q[WZYYZW[T[",
"I[RUM[ RV[VMPMNNMPMRNTPUVU",
"I[VZT[P[NZMXMPNNPMTMVNWPWRMT RPESH",
"I[VZT[P[NZMXMPNNPMTMVNWPWRMT RNFOGNHMGNFNH RVFWGVHUGVFVH",
"M^OKXK RRFR[ RRSSRUQWQYRZTZ[Y^WaVb",
"JYO[OMWM RTEQH",
"HZLTST RVZT[P[NZMYLWLQMONNPMTMVN",
"J[NZP[T[VZWXWWVUTTQTOSNQNPONQMTMVN",
"MWR[RM RRFQGRHSGRFRH",
"LXNFOGNHMGNFNH RVFWGVHUGVFVH RR[RM",
18,
"E^H[JZKXLPMNOMRMR[W[YZZXZUYSWRRR",
"D^IMI[ RRMR[W[YZZXZVYTWSIS",
"M^OKXK RRFR[ RRSSRUQWQYRZTZ[",
"IZNMN[ RPSV[ RVMNU RTEQH",
"H\\MMM[WMW[ RPESH",
"JZMMR[ RWMR[P`OaMb RNEOGQHSHUGVE",
"H]R[R` RMMM[W[WM",
"CaRWRR RLFJGHIGLGUHXJZL[N[PZQYRWSYTZV[X[ZZ\\X]U]L\\IZGXF",
43,
"F]IIVI RMFM[S[VZXXYVYSXQVOSNMN",
"HZJMTM RNFN[S[UZVXVUUSSRNR",
"D`IFI[ RYPIP R\\Y[ZX[V[SZQXPVOROOPKQISGVFXF[G\\H",
"F^KMK[ RWTKT RZZX[T[RZQYPWPQQORNTMXMZN",
"F^LSXS RRSR[ RH[RF\\[",
"I[NUVU RRUR[ RK[RMY[",
"AbF[FF RFS\\S RVSV[ RL[VF`[",
"E_J[JM RVUV[ RZUJU RO[VM][",
"E_R[RPJFZFRP RI[IVJSLQOPUPXQZS[V[[",
"G]R[RTLMXMRT RK[KXLVMUOTUTWUXVYXY[",
"AcF[FF RFPSP RV[VPNF^FVP RM[MVNSPQSPYP\\Q^S_V_[",
"DaI[IM RITST RV[VTPM\\MVT RO[OXPVQUSTYT[U\\V]X][",
"H\\OPSP RNAQFSBTAUA RLGNFSFUGVHWJWLVNUOSPVQWRXTXWWYVZT[O[M\\L^L_MaObWb",
"J[RTTT ROHRMTIUHVH RNNPMTMVNWPWQVSTTVUWWWXVZT[Q[O\\N^N_OaQbVb",
"G]R[RF RHFJGKIKNLQMROSUSWRXQYNYIZG\\F",
"G]RMRb RKMKVLXNZP[T[VZXXYVYM",
32,
37,
"I[KFR[YF",
20,
"I[KFR[YF ROAL> RVAS>",
"JZMMR[WM ROHLE RVHSE",
"GmPFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF R`Me[ RjMe[c`ba`b",
"HkP[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ R^Mc[ RhMc[a``a^b",
"CaRXR^ RRCRI RMFJGHIGLGUHXJZM[W[ZZ\\X]U]L\\IZGWFMF",
"G]RYR] RRKRO ROMMNLOKQKWLYMZO[U[WZXYYWYQXOWNUMOM",
"CaRWRR RLFJGHIGLGUHXJZL[N[PZQYRWSYTZV[X[ZZ\\X]U]L\\IZGXF RLBM@O?R?U@X@",
"G]RTRX RMMLNKPKXLZN[O[QZRXSZU[V[XZYXYPXNWM RLIMGOFRFUGXG",
"CaRWRR RLFJGHIGLGUHXJZL[N[PZQYRWSYTZV[X[ZZ\\X]U]L\\IZGXF RM<W< RR<R?",
"G]RTRX RMMLNKPKXLZN[O[QZRXSZU[V[XZYXYPXNWM RMEWE RRERH",
"FZWGTFPFMGKIJKJNKPMRPSTST[",
"FZVNTMPMNNMOLQLSMUNVPWTWT[",
"H[N]UO ROQWU RT[LW",
"JZMHMFWGWE",
"JZMHUEVH",
16,
25,
"KZLIMGOFRFUGXG",
":j>R?PAOCPDR RC^D\\F[H\\I^ RCFDDFCHDIF ROcPaR`TaUc ROAP?R>T?UA R[^\\\\^[`\\a^ R[F\\D^C`DaF R`RaPcOePfR",
":jDQ>Q RH[D_ RHGDC RR_Re RRCR= R\\[`_ R\\G`C R`QfQ",
"G]LFL[XFX[ RX[[[Ub RN>O@QASAU@V>",
"H\\MMM[WMW[ RW[Z[Tb RNEOGQHSHUGVE",
"H]MFM[S[VZXXYVYSXQVOSNMN RJIPI",
"IZKMQM RNFN[S[UZVXVUUSSRNR",
"G\\L[LFTFVGWHXJXMWOVPTQLQ RTMXS",
"H[MMMb RMNOMSMUNVOWQWWVYUZS[O[MZ RSWW]",
"HZM[MFXFXA",
"JYO[OMWMWH",
"HZM[MFXF RJQRQ",
"JYO[OMWM RLTTT",
"H]M[MFXF RMMSMVNXPYSY\\X_VaSbQb",
"J\\O[OMWM ROTTTVUWVXXX[W^UaTb",
"BbOOF[ RR[RF RRRFF R^[UO R^FRR R^[`[``",
"F^QTJ[ RRUJM RRMR[ RZ[ST RZMRU RZ[\\[\\`",
"I]PPTP RMGOFTFVGWHXJXLWNVOTPWQXRYTYWXYWZU[O[MZ RR\\T]U_TaRbOb",
"K[RTTT RNNPMTMVNWPWQVSTTVUWWWXVZT[P[NZ RR\\T]U_TaRbOb",
"G\\L[LF RX[OO RXFLR RX[Z[Z`",
"IZNMN[ RPSV[ RVMNU RV[X[X`",
"G\\L[LF RX[OO RXFLR RPKPS",
"IZNMN[ RPSV[ RVMNU RRORW",
"G\\L[LF RX[OO RXFLR RIJOJ",
"IZN[NF RPSV[ RVMNU RKJQJ",
"E\\X[OO RXFLR RGFLFL[",
"HZPSV[ RVMNU RJMNMN[",
"G]L[LF RLPXP RX[XF RX[Z[Z`",
"H[MTVT RMMM[ RVMV[ RV[X[X`",
"GeL[LF RLPXP RX[XFcF",
"H`MTVT RMMM[ RV[VM^M",
"GhL[LFXFX[ RXM^MaNcPdSd\\c_aa^b\\b",
"HcM[MMVMV[ RVT[T]U^V_X_[^^\\a[b",
"F^QFNGLIKKJOJRKVLXNZQ[S[VZXXYVZRZMYJWIVITJSMSRTVUXWZY[[[",
"H\\QMPMNNMOLQLWMYNZP[T[VZWYXWXRWPUOSPRRRWSYTZV[Y[",
"F[WYVZS[Q[NZLXKVJRJOKKLINGQFSFVGWH RR\\T]U_TaRbOb",
"HZVZT[P[NZMYLWLQMONNPMTMVN RR\\T]U_TaRbOb",
"JZLFXF RR[RF RR[T[T`",
"KYMMWM RRMR[ RR[T[T`",
15,
"JZR[Rb RMMR[WM",
"I[RQR[ RKFRQYF RNUVU",
"JZR[Rb RMMR[WM RN]V]",
"H\\KFY[ RYFK[ RX[Z[Z`",
"IZL[WM RLMW[ RV[X[X`",
"D]FFRF RXFX[ RLFL[Z[Z`",
"G\\RMIM RWMW[ RNMN[Y[Y`",
"H\\WFW[ RLFLNMPNQPRWR RW[Y[Y`",
"J\\VMV[ RNMNROTQUVU RV[X[X`",
"H\\WFW[ RLFLNMPNQPRWR RRNRV",
"J\\VMV[ RNMNROTQUVU RRQRY",
"G]L[LF RL[ RLPRPUQWSXVX[",
"H[M[MF RV[VPUNSMPMNNMO",
"@^WYVZS[Q[NZLXKVJRJOKKLINGQFSFVGXIYKZOJQGQEPDOCMCK",
"E[VZT[P[NZMXMPNNPMTMVNWPWRMTKTISHQHO",
"@^WYVZS[Q[NZLXKVJRJOKKLINGQFSFVGXIYKZOJQGQEPDOCMCK RR[P]O_PaRbTb",
"E[VZT[P[NZMXMPNNPMTMVNWPWRMTKTISHQHO RR[P]O_PaRbTb",
8,
"BbOOF[ RR[RF RRRFF R^[UO R^FRR RN>O@QASAU@V>",
"F^QTJ[ RRUJM RRMR[ RZ[ST RZMRU RNEOGQHSHUGVE",
"G\\L[LF RX[OO RXFLR RX[X_WaUbSb",
"IZNMN[ RPSV[ RVMNU RV[V_UaSbQb",
"F\\W[WFTFQGOINLLXKZI[H[ RW[Z[Tb",
"I[V[VMSMQNPPOXNZL[ RV[Y[Sb",
"G]L[LF RLPXP RX[XF RX[X_WaUbSb",
"H[MTVT RMMM[ RVMV[ RV[V_UaSbQb",
"G]L[LF RLPXP RX[XF RX[[[Ub",
"H[MTVT RMMM[ RVMV[ RV[Y[Sb",
"H\\WFW[ RLFLNMPNQPRWR RW[U[U`",
"J\\VMV[ RNMNROTQUVU RV[T[T`",
"F^K[KFRUYFY[ RY[\\[Vb",
"G]L[LMRXXMX[ RX[[[Ub",
8,
30,
"I\\W[WPVNTMPMNN RWZU[P[NZMXMVNTPSUSWR RNEOGQHSHUGVE",
"I[MUWU RK[RFY[ RN?O@NAM@N?NA RV?W@VAU@V?VA",
"I\\W[WPVNTMPMNN RWZU[P[NZMXMVNTPSUSWR RNFOGNHMGNFNH RVFWGVHUGVFVH",
"F`JURU RRPYP RH[OF\\F RRFR[\\[",
"D`INKMOMQNRP R[ZY[U[SZRXRPSNUMYM[N\\P\\RRSKSITHVHXIZK[O[QZRX",
"H[MPTP RW[M[MFWF RN>O@QASAU@V>",
"I[VZT[P[NZMXMPNNPMTMVNWPWRMT RNEOGQHSHUGVE",
"F^MHNGQFSFVGXIYKZOZRYVXXVZS[Q[NZLXKVJRZP",
33,
"F^MHNGQFSFVGXIYKZOZRYVXXVZS[Q[NZLXKVJRZP RNBOCNDMCNBND RVBWCVDUCVBVD",
"I[NNPMTMVNWPWXVZT[P[NZMXMVWT RNFOGNHMGNFNH RVFWGVHUGVFVH",
"BbOOF[ RR[RF RRRFF R^[UO R^FRR RN?O@NAM@N?NA RV?W@VAU@V?VA",
"F^QTJ[ RRUJM RRMR[ RZ[ST RZMRU RNFOGNHMGNFNH RVFWGVHUGVFVH",
"I]PPTP RMGOFTFVGWHXJXLWNVOTPWQXRYTYWXYWZU[O[MZ RN?O@NAM@N?NA RV?W@VAU@V?VA",
"K[RTTT RNNPMTMVNWPWQVSTTVUWWWXVZT[P[NZ RNFOGNHMGNFNH RVFWGVHUGVFVH",
2,
"JZMMVMOVRVTWUXVZV^U`TaRbObMa",
"G]LFL[XFX[ RM@W@",
"H\\MMM[WMW[ RMGWG",
"G]LFL[XFX[ RN?O@NAM@N?NA RV?W@VAU@V?VA",
"H\\MMM[WMW[ RNFOGNHMGNFNH RVFWGVHUGVFVH",
"G]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF RN?O@NAM@N?NA RV?W@VAU@V?VA",
"H[P[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ RNFOGNHMGNFNH RVFWGVHUGVFVH",
32,
37,
"G]KPYP RPFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF RN?O@NAM@N?NA RV?W@VAU@V?VA",
"H[LTWT RP[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ RNFOGNHMGNFNH RVFWGVHUGVFVH",
"I^ZPPP RMYNZQ[S[VZXXYVZRZOYKXIVGSFQFNGMH RN?O@NAM@N?NA RV?W@VAU@V?VA",
"J\\XTQT RNZP[T[VZWYXWXQWOVNTMPMNN RNFOGNHMGNFNH RVFWGVHUGVFVH",
"G[KFRT RYFPXNZL[K[ RM@W@",
"JZMMR[ RWMR[P`OaMb RMGWG",
"G[KFRT RYFPXNZL[K[ RN?O@NAM@N?NA RV?W@VAU@V?VA",
"JZMMR[ RWMR[P`OaMb RNFOGNHMGNFNH RVFWGVHUGVFVH",
"G[KFRT RYFPXNZL[K[ RQ>NA RX>UA",
"JZMMR[ RWMR[P`OaMb RQENH RXEUH",
"H\\WFW[ RLFLNMPNQPRWR RN?O@NAM@N?NA RV?W@VAU@V?VA",
"J\\VMV[ RNMNROTQUVU RNFOGNHMGNFNH RVFWGVHUGVFVH",
"HZM[MFXF RM[O[O`",
"JYO[OMWM RO[Q[Q`",
"Da\\F\\[ RIFI[O[RZTXUVUSTQROONIN RN?O@NAM@N?NA RV?W@VAU@V?VA",
"F^YMY[ RKMK[P[RZSXSURSPRKR RNFOGNHMGNFNH RVFWGVHUGVFVH",
"HZWFMFM[Q[Q_PaNbLb RJQRQ",
"JYWMOMO[S[S_RaPbNb RLTTT",
"H\\KFY[ RYFK[ RX[X_WaUbSb",
"IZL[WM RLMW[ RV[V_UaSbQb",
"H\\KFY[ RYFK[ RNPVP",
"IZL[WM RLMW[ RNTVT",
"G\\WFW[Q[NZLXKVKSLQNOQNWN",
"J[VMV[Q[OZNXNUOSQRVR",
"B_RXSZU[X[ZZ[X[M RRFRXQZO[L[IZGXFVFSGQIOLNRN",
"E]RXSZU[V[XZYXYQ RRMRXQZO[M[KZJXJUKSMRRR",
"IePPTP RMGOFTFVGWHXJXLWNVOTPVQWRXTXXYZ[[^[`ZaXaM",
"KbRTTT RNNPMTMVNWPWQVSTTVUWWWXXZZ[[[]Z^X^Q",
"I\\PPTP RMGOFTFVGWHXJXLWNVOTPVQWRXTX[Z[Z`",
"K[RTTT RNNPMTMVNWPWQVSTTVUWWW[Y[Y`",
"FdH[I[KZLXNLOIQGTFWFWXXZZ[][_Z`X`M",
"IaL[NZOXPPQNSMVMVXWZY[Z[\\Z]X]Q",
"CaH[HF RHPTP RTFTXUZW[Z[\\Z]X]M",
"F^KTTT RKMK[ RTMTXUZW[X[ZZ[X[R",
"F[VGTFQFNGLIKKJOJRKVLXNZQ[S[VZWYWRSR",
"HZUNSMPMNNMOLQLWMYNZP[T[VZVUSU",
"J_LFXF RRFRXSZU[X[ZZ[X[M",
"K]MMWM RRMRXSZU[V[XZYXYS",
"G[PPTP RWGUFPFNGMHLJLLMNNOPPMQLRKTKWLYMZO[U[WZ",
35,
"F\\W[WFTFQGOINLLXKZI[H[ RW[W_VaTbRb",
"I[V[VMSMQNPPOXNZL[ RV[V_UaSbQb",
"BaP[^F RD[E[GZHXJLKIMGPF^[",
"E^[MO[ RH[JZKXLPMNOM[[",
"E_\\FUO\\[ RJ[JFRFTGUHVJVMUOTPRQJQ",
"F^KMKb R[MUT[[ RKNMMQMSNTOUQUWTYSZQ[M[KZ",
"DaOQH[ RTFT[^[ R[QLQJPIOHMHJIHJGLF^F",
"D`H[MU RRPRMKMINHPHRITKURU R[ZY[U[SZRXRPSNUMYM[N\\P\\RRT",
"G]Z]X\\VZSWQVOV RP[NZLXKTKMLINGPFTFVGXIYMYTXXVZT[P[",
"I\\WMWb RWZU[Q[OZNYMWMQNOONQMUMWN",
"F^IFN[RLV[[F",
21,
"G\\L[LF RX[OO RXFLR RXKRG",
"IZNMN[ RPSV[ RVMNU RWQQM",
"FgW[WFTFQGOINLLXKZI[H[ RWM]M`NbPcSc\\b_`a]b[b",
"IcV[VMSMQNPPOXNZL[ RVT[T]U^V_X_[^^\\a[b",
"GhL[LF RLPXP RX[XF RXM^MaNcPdSd\\c_aa^b\\b",
"HcMTVT RMMM[ RVMV[ RVT[T]U^V_X_[^^\\a[b",
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
"JZNXVX RM[RMW[",
"H\\LXRX RRTWT RRMR[Y[ RYMPMK[",
"D`[ZY[U[SZRX RINKMOMQNRPRXQZO[K[IZHXHVRUYU[T\\R\\P[NYMUMSNRP",
"I[STVUWWWXVZT[N[NMSMUNVPVQUSSTNT RKWQW",
17,
"J[SMOMO[S[UZVYWVWRVOUNSM",
"J[SMOMO[S[UZVYWVWRVOUNSM RLTRT",
"JYOTTT RVMOMO[V[",
"J[TTVSWQWPVNTMPMNN RRTTTVUWWWXVZT[P[NZ",
"MWRMR[ RRbSaR`QaRbR`",
"LYTMTWSYRZP[O[",
31,
"JYOMO[V[ RLVRR",
"G]L[LMRXXMX[",
"I\\W[WMN[NM",
19,
"J\\NNPMTMVNWOXQXWWYVZT[P[NZ",
"G]YSYVXXWYUZOZMYLXKVKSLQMPOOUOWPXQYS",
"G]XYYWYSXQWPUOOOMPLQKSKWLY",
"G]YNK[ RYSYVXXWYUZOZMYLXKVKSLQMPOOUOWPXQYS",
"DaINKMOMQNRPRXQZO[K[IZHXHVRT RRWSYTZV[Y[[Z\\Y]W]Q\\O[NYMVMTNSORQ",
"G]OMNNMPNRPS RTSVRWPVNUM RPSTSVTWVWXVZT[P[NZMXMVNTPS",
"I\\XTXQWOVNTMQMONNOMQMT",
"H[LTLWMYNZP[S[UZVYWWWT",
"I[N[NMTMVNWPWRVTTUNU",
"I[RUM[ RV[VMPMNNMPMRNTPUVU",
"I[RSMM RVMV[P[NZMXMVNTPSVS",
"KYMMWM RRMR[",
"H[MMMXNZP[S[UZVXVM",
"G]KPYP RKYVYXXYVYSXQWP",
"@]KPYP RKYVYXXYVYSXQWP REWFXEYDXEWEY REOFPEQDPEOEQ",
"G]KKYK RWKXLYNYQXSVTKT RVTXUYWYZX\\V]K]",
20,
21,
"IZLMWML[W[",
"JZNMVMRRSRUSVUVXUZS[P[NZ",
"H\\XNUMPMNNMOLQLSMUNVPWTXVYWZX\\X^W`VaTbObLa RRTR\\",
"JZW[PROPPNRMTNUPTRM[",
"JYO[OMWM",
"JZM[RMW[",
"H[M[MMVMV[",
"I[N[NMTMVNWPWRVTTUNU",
"I[RMR[ RLMMNMRNTPUTUVTWRWNXM",
"I[V[VMSMQNPPOXNZL[",
"JZNKVK RMNR@WN",
"H\\LKRK RRGWG RR@RNYN RY@P@KN",
"I[SGVHWJWKVMTNNNN@S@UAVCVDUFSGNG",
"I[SGVHWJWKVMTNNNN@S@UAVCVDUFSGNG RKGQG",
"J[S@O@ONSNUMVLWIWEVBUAS@",
"JYOGTG RV@O@ONVN",
"KZUGPG RN@U@UNNN",
"HZUAS@P@NAMBLDLJMLNMPNTNVMVHSH",
"H[MGVG RM@MN RV@VN",
"MWRNR@ RUNON RU@O@",
"LYT@TJSLRMPNON",
"IZN@NN RPFVN RV@NH",
"JYO@ONVN",
"G]LNL@RKX@XN",
"H[MNM@VNV@",
"I\\WNW@NNN@",
"H[PNNMMLLJLDMBNAP@S@UAVBWDWJVLUMSNPN",
"G]O@NAMCNEPF RTFVEWCVAU@ RPFTFVGWIWKVMTNPNNMMKMINGPF",
"I[NNN@T@VAWCWEVGTHNH",
"I[RHWN RNNN@T@VAWCWEVGTHNH",
"KYM@W@ RR@RN",
"H[M@MKNMPNSNUMVKV@",
"G]J@NNRDVNZ@",
"KZOEQDSDUEVGVN RVMTNQNOMNKOIQHVH",
"JYNDNKOMQNSNUM RNEPDSDUEVGUISJNJ",
"H]WDUKTMRNPNNMMKMGNEPDRDTEVMWN",
"H\\XMVNUNSMRK RLDODQERHRKQMONNNLMKKKJVJXIYGXEVDUDSERH",
"KYO@ON ROMQNSNUMVKVGUESDQDOE",
"KYU@UN RUESDQDOENGNKOMQNSNUM",
"LYVMTNRNPMOKOGPERDSDUEVGVHOI",
"LYOEQDSDUEVGVKUMSNRNPMOKOJVI",
"LXPIRI RUETDPDOEOHPIOJOMPNTNUM",
"LXRITI ROEPDTDUEUHTIUJUMTNPNOM",
"KYUDUPTRRSOS RUESDQDOENGNKOMQNSNUM",
"NVRDRN RRUSTRSQTRURS",
"IZO@ON RUNQH RUDOJ",
"G]KNKD RKEMDODQERGRN RRGSEUDVDXEYGYN",
"KZODON ROEQDSDUEVGVPURSSRS",
"KYQNOMNKNGOEQDSDUEVGVKUMSNQN",
"LYOEQDSDUEVGVKUMSNQNOM",
"KYNINGOEQDSDUEVGVI",
"KYNINKOMQNSNUMVKVI",
"KYOSOD ROEQDSDUEVGVKUMSNQNOM",
"NXPDVD RR@RKSMUNVN",
"KYUDUN RNDNKOMQNSNUM",
"I[MFWF RMMTMVLWJWHVF",
"G]YDYN RYMWNUNSMRKRD RRKQMONNNLMKKKD",
"LXNDRNVD",
"LXVNPGPEQDSDTETGNN",
"KYSFRF RNSOQOCPAR@S@UAVCUESFUGVIVKUMSNQNOM",
"KXRMRS RMDOERMVD",
"KYSDQDOENGNKOMQNSNUMVKVGUESDPCOBOAP@U@",
"I[MDLFLJMLNMPNTNVMWLXJXGWEUDSERGRS",
"LXVDNS RNDPETRVS",
"NVRWRa RRPQQRRSQRPRR",
"LWPWPa RPZQXSWUW",
"KYUWUa RNWN^O`QaSaU`",
"LXNWRaVW",
"KYSYRY RNfOdOVPTRSSSUTVVUXSYUZV\\V^U`SaQaO`",
"KXR`Rf RMWOXR`VW",
"KYOfOZPXRWSWUXVZV^U`SaQaO`",
"I[MWLYL]M_N`PaTaV`W_X]XZWXUWSXRZRf",
"LXVWNf RNWPXTeVf",
"D`IMIXJZL[O[QZRX R[ZY[U[SZRXRPSNUMYM[N\\P\\RRT",
"H[M[MF RMNOMSMUNVOWQWWVYUZS[O[MZ RIHJGLFPHRGSF",
"I\\W[WF RWZU[Q[OZNYMWMQNOONQMUMWN RQHRGTFXHZG[F",
"MYOMWM RR[RISGUFWF RMTNSPRTTVSWR",
"D`I[IM RIOJNLMOMQNRPR[ RRPSNUMXMZN[P[[ RMTNSPRTTVSWR",
"I\\NMN[ RNOONQMTMVNWPW[ RMTNSPRTTVSWR",
"H[MMMb RMNOMSMUNVOWQWWVYUZS[O[MZ RI`J_L^P`R_S^",
"KXP[PM RPQQORNTMVM RLTMSORSTUSVR",
"KXM[S[ RVMTMRNQOPRP[ RLTMSORSTUSVR",
"J[NZP[T[VZWXWWVUTTQTOSNQNPONQMTMVN RNTOSQRUTWSXR",
"MYOMWM RRFRXSZU[W[ RMSNRPQTSVRWQ",
"IZLMWML[W[ RMTNSPRTTVSWR",
"H[M[MJNHOGQFTFVG RMNOMSMUNVOWQWWVYUZS[O[MZ",
"H[MGVG RM@MN RV@VN",
"JZMMVMOURUTVUWVYV^U`TaRbPbNaM_M^N\\P[V[",
"MlOMWM RRFRXSZU[W[ R^[^F Rg[gPfNdMaM_N^O RiC]`",
"MWR[RM RU[O[ RUMOM ROTUT",
"MXRMRXSZU[ ROTUT",
"H[MMMb RMNOMSMUNVOWQWWVYUZS[O[MZ RHT\\T",
"H[MMMXNZP[S[UZVXVM RHT\\T",
"I\\XMUMUPWRXTXWWYVZT[Q[OZNYMWMTNRPPPMMM RHU\\U",
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
"I[MUWU RK[RFY[ RR`TaUcTeRfPeOcPaR`",
"I\\W[WPVNTMPMNN RWZU[P[NZMXMVNTPSUSWR RR`TaUcTeRfPeOcPaR`",
"G\\SPVQWRXTXWWYVZT[L[LFSFUGVHWJWLVNUOSPLP RR?Q@RAS@R?RA",
"H[M[MF RMNOMSMUNVOWQWWVYUZS[O[MZ RN?M@NAO@N?NA",
"G\\SPVQWRXTXWWYVZT[L[LFSFUGVHWJWLVNUOSPLP RRbSaR`QaRbR`",
"H[M[MF RMNOMSMUNVOWQWWVYUZS[O[MZ RRbSaR`QaRbR`",
"G\\SPVQWRXTXWWYVZT[L[LFSFUGVHWJWLVNUOSPLP RWaMa",
"H[M[MF RMNOMSMUNVOWQWWVYUZS[O[MZ RWaMa",
"F[WYVZS[Q[NZLXKVJRJOKKLINGQFSFVGWH RR\\T]U_TaRbOb RT>QA",
"HZVZT[P[NZMYLWLQMONNPMTMVN RR\\T]U_TaRbOb RTEQH",
"G\\L[LFQFTGVIWKXOXRWVVXTZQ[L[ RR?Q@RAS@R?RA",
"I\\W[WF RWZU[Q[OZNYMWMQNOONQMUMWN RV?U@VAW@V?VA",
"G\\L[LFQFTGVIWKXOXRWVVXTZQ[L[ RRbSaR`QaRbR`",
"I\\W[WF RWZU[Q[OZNYMWMQNOONQMUMWN RSbTaS`RaSbS`",
"G\\L[LFQFTGVIWKXOXRWVVXTZQ[L[ RWaMa",
"I\\W[WF RWZU[Q[OZNYMWMQNOONQMUMWN RXaNa",
"G\\L[LFQFTGVIWKXOXRWVVXTZQ[L[ RQ\\S]T_SaQbNb",
"I\\W[WF RWZU[Q[OZNYMWMQNOONQMUMWN RS\\U]V_UaSbPb",
"G\\L[LFQFTGVIWKXOXRWVVXTZQ[L[ RVcR`Nc",
"I\\W[WF RWZU[Q[OZNYMWMQNOONQMUMWN RWcS`Oc",
"H[MPTP RW[M[MFWF RM@W@ RP9S<",
"I[VZT[P[NZMXMPNNPMTMVNWPWRMT RMGWG RP>SA",
"H[MPTP RW[M[MFWF RM@W@ RT9Q<",
"I[VZT[P[NZMXMPNNPMTMVNWPWRMT RMGWG RT>QA",
"H[MPTP RW[M[MFWF RVcR`Nc",
"I[VZT[P[NZMXMPNNPMTMVNWPWRMT RVcR`Nc",
"H[MPTP RW[M[MFWF RW`VaTbP`NaMb",
"I[VZT[P[NZMXMPNNPMTMVNWPWRMT RW`VaTbP`NaMb",
"H[MPTP RW[M[MFWF RR\\T]U_TaRbOb RN>O@QASAU@V>",
"I[VZT[P[NZMXMPNNPMTMVNWPWRMT RR\\T]U_TaRbOb RNEOGQHSHUGVE",
"HZTPMP RM[MFWF RR?Q@RAS@R?RA",
"MYOMWM RR[RISGUFWF RT?S@TAU@T?TA",
"F[VGTFQFNGLIKKJOJRKVLXNZQ[S[VZWYWRSR RM@W@",
"I\\WMW^V`UaSbPbNa RWZU[Q[OZNYMWMQNOONQMUMWN RMGWG",
"G]L[LF RLPXP RX[XF RR?Q@RAS@R?RA",
"H[M[MF RV[VPUNSMPMNNMO RM?L@MAN@M?MA",
"G]L[LF RLPXP RX[XF RRbSaR`QaRbR`",
"H[M[MF RV[VPUNSMPMNNMO RRbSaR`QaRbR`",
"G]L[LF RLPXP RX[XF RN?O@NAM@N?NA RV?W@VAU@V?VA",
"H[M[MF RV[VPUNSMPMNNMO RI?J@IAH@I?IA RQ?R@QAP@Q?QA",
"G]L[LF RLPXP RX[XF RL\\N]O_NaLbIb",
"H[M[MF RV[VPUNSMPMNNMO RM\\O]P_OaMbJb",
"G]L[LF RLPXP RX[XF RV`UbScQcObN`",
"H[M[MF RV[VPUNSMPMNNMO RV`UbScQcObN`",
"MWR[RF RW`VaTbP`NaMb",
"MWR[RM RRFQGRHSGRFRH RW`VaTbP`NaMb",
"MWR[RF RN?O@NAM@N?NA RV?W@VAU@V?VA RT9Q<",
"MWR[RM RNFOGNHMGNFNH RVFWGVHUGVFVH RT>QA",
"G\\L[LF RX[OO RXFLR RT>QA",
"IZN[NF RPSV[ RVMNU RPAMD",
"G\\L[LF RX[OO RXFLR RRbSaR`QaRbR`",
"IZN[NF RPSV[ RVMNU RRbSaR`QaRbR`",
"G\\L[LF RX[OO RXFLR RWaMa",
"IZN[NF RPSV[ RVMNU RWaMa",
"HYW[M[MF RRbSaR`QaRbR`",
"MXU[SZRXRF RSbTaS`RaSbS`",
"HYW[M[MF RH@R@ RRbSaR`QaRbR`",
"MXU[SZRXRF RM@W@ RSbTaS`RaSbS`",
"HYW[M[MF RWaMa",
"MXU[SZRXRF RXaNa",
"HYW[M[MF RVcR`Nc",
"MXU[SZRXRF RWcS`Oc",
"F^K[KFRUYFY[ RT>QA",
"D`I[IM RIOJNLMOMQNRPR[ RRPSNUMXMZN[P[[ RTEQH",
"F^K[KFRUYFY[ RR?Q@RAS@R?RA",
"D`I[IM RIOJNLMOMQNRPR[ RRPSNUMXMZN[P[[ RRFQGRHSGRFRH",
"F^K[KFRUYFY[ RRbSaR`QaRbR`",
"D`I[IM RIOJNLMOMQNRPR[ RRPSNUMXMZN[P[[ RRbSaR`QaRbR`",
"G]L[LFX[XF RR?Q@RAS@R?RA",
"I\\NMN[ RNOONQMTMVNWPW[ RRFQGRHSGRFRH",
"G]L[LFX[XF RRbSaR`QaRbR`",
"I\\NMN[ RNOONQMTMVNWPW[ RRbSaR`QaRbR`",
"G]L[LFX[XF RWaMa",
"I\\NMN[ RNOONQMTMVNWPW[ RWaMa",
"G]L[LFX[XF RVcR`Nc",
"I\\NMN[ RNOONQMTMVNWPW[ RVcR`Nc",
"G]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF RMAN@P?TAV@W? RT9Q<",
"H[P[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ RMHNGPFTHVGWF RT>QA",
"G]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF RMAN@P?TAV@W? RN:O;N<M;N:N< RV:W;V<U;V:V<",
"H[P[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ RMHNGPFTHVGWF RN?O@NAM@N?NA RV?W@VAU@V?VA",
"G]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF RM@W@ RP9S<",
"H[P[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ RMGWG RP>SA",
"G]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF RM@W@ RT9Q<",
"H[P[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ RMGWG RT>QA",
"G\\L[LFTFVGWHXJXMWOVPTQLQ RT>QA",
"H[MMMb RMNOMSMUNVOWQWWVYUZS[O[MZ RTEQH",
"G\\L[LFTFVGWHXJXMWOVPTQLQ RR?Q@RAS@R?RA",
"H[MMMb RMNOMSMUNVOWQWWVYUZS[O[MZ RRFQGRHSGRFRH",
"G\\X[QQ RL[LFTFVGWHXJXMWOVPTQLQ RR?Q@RAS@R?RA",
"KXP[PM RPQQORNTMVM RSFRGSHTGSFSH",
"G\\X[QQ RL[LFTFVGWHXJXMWOVPTQLQ RRbSaR`QaRbR`",
"KXP[PM RPQQORNTMVM RPbQaP`OaPbP`",
"G\\X[QQ RL[LFTFVGWHXJXMWOVPTQLQ RM@W@ RRbSaR`QaRbR`",
"KXP[PM RPQQORNTMVM RNGXG RPbQaP`OaPbP`",
"G\\X[QQ RL[LFTFVGWHXJXMWOVPTQLQ RWaMa",
"KXP[PM RPQQORNTMVM RUaKa",
"H\\LZO[T[VZWYXWXUWSVRTQPPNOMNLLLJMHNGPFUFXG RR?Q@RAS@R?RA",
"J[NZP[T[VZWXWWVUTTQTOSNQNPONQMTMVN RRFQGRHSGRFRH",
"H\\LZO[T[VZWYXWXUWSVRTQPPNOMNLLLJMHNGPFUFXG RRbSaR`QaRbR`",
"J[NZP[T[VZWXWWVUTTQTOSNQNPONQMTMVN RRbSaR`QaRbR`",
"H\\LZO[T[VZWYXWXUWSVRTQPPNOMNLLLJMHNGPFUFXG RU>RA RM>N?M@L?M>M@",
"J[NZP[T[VZWXWWVUTTQTOSNQNPONQMTMVN RUERH RMENFMGLFMEMG",
"H\\LZO[T[VZWYXWXUWSVRTQPPNOMNLLLJMHNGPFUFXG RN>RAV> RR:Q;R<S;R:R<",
"J[NZP[T[VZWXWWVUTTQTOSNQNPONQMTMVN RNERHVE RR?Q@RAS@R?RA",
"H\\LZO[T[VZWYXWXUWSVRTQPPNOMNLLLJMHNGPFUFXG RR?Q@RAS@R?RA RRbSaR`QaRbR`",
"J[NZP[T[VZWXWWVUTTQTOSNQNPONQMTMVN RRFQGRHSGRFRH RRbSaR`QaRbR`",
"JZLFXF RR[RF RR?Q@RAS@R?RA",
"MYOMWM RRFRXSZU[W[ RR?Q@RAS@R?RA",
"JZLFXF RR[RF RRbSaR`QaRbR`",
"MYOMWM RRFRXSZU[W[ RTbUaT`SaTbT`",
"JZLFXF RR[RF RWaMa",
"MYOMWM RRFRXSZU[W[ RYaOa",
"JZLFXF RR[RF RVcR`Nc",
"MYOMWM RRFRXSZU[W[ RXcT`Pc",
"G]LFLWMYNZP[T[VZWYXWXF RVbUaV`WaVbV` RNbMaN`OaNbN`",
"H[VMV[ RMMMXNZP[S[UZVY RVbUaV`WaVbV` RNbMaN`OaNbN`",
"G]LFLWMYNZP[T[VZWYXWXF RW`VaTbP`NaMb",
"H[VMV[ RMMMXNZP[S[UZVY RW`VaTbP`NaMb",
"G]LFLWMYNZP[T[VZWYXWXF RVcR`Nc",
"H[VMV[ RMMMXNZP[S[UZVY RVcR`Nc",
"G]LFLWMYNZP[T[VZWYXWXF RMAN@P?TAV@W? RT9Q<",
"H[VMV[ RMMMXNZP[S[UZVY RMHNGPFTHVGWF RT>QA",
"G]LFLWMYNZP[T[VZWYXWXF RM@W@ RN:O;N<M;N:N< RV:W;V<U;V:V<",
"H[VMV[ RMMMXNZP[S[UZVY RMGWG RN?O@NAM@N?NA RV?W@VAU@V?VA",
"I[KFR[YF RMAN@P?TAV@W?",
"JZMMR[WM RMHNGPFTHVGWF",
"I[KFR[YF RRbSaR`QaRbR`",
"JZMMR[WM RRbSaR`QaRbR`",
"F^IFN[RLV[[F RP>SA",
"G]JMN[RQV[ZM RPESH",
"F^IFN[RLV[[F RT>QA",
"G]JMN[RQV[ZM RTEQH",
"F^IFN[RLV[[F RN?O@NAM@N?NA RV?W@VAU@V?VA",
"G]JMN[RQV[ZM RNFOGNHMGNFNH RVFWGVHUGVFVH",
"F^IFN[RLV[[F RR?Q@RAS@R?RA",
"G]JMN[RQV[ZM RRFQGRHSGRFRH",
"F^IFN[RLV[[F RRbSaR`QaRbR`",
"G]JMN[RQV[ZM RRbSaR`QaRbR`",
"H\\KFY[ RYFK[ RR?Q@RAS@R?RA",
"IZL[WM RLMW[ RRFQGRHSGRFRH",
"H\\KFY[ RYFK[ RN?O@NAM@N?NA RV?W@VAU@V?VA",
"IZL[WM RLMW[ RNFOGNHMGNFNH RVFWGVHUGVFVH",
"I[RQR[ RKFRQYF RR?Q@RAS@R?RA",
"JZMMR[ RWMR[P`OaMb RRFQGRHSGRFRH",
"H\\KFYFK[Y[ RNAR>VA",
"IZLMWML[W[ RNHREVH",
"H\\KFYFK[Y[ RRbSaR`QaRbR`",
"IZLMWML[W[ RRbSaR`QaRbR`",
"H\\KFYFK[Y[ RWaMa",
"IZLMWML[W[ RWaMa",
"H[M[MF RV[VPUNSMPMNNMO RWaMa",
"MYOMWM RRFRXSZU[W[ RN?O@NAM@N?NA RV?W@VAU@V?VA",
"G]JMN[RQV[ZM RRHPGOEPCRBTCUETGRH",
"JZMMR[ RWMR[P`OaMb RRHPGOEPCRBTCUETGRH",
"I\\W[WPVNTMPMNN RWZU[P[NZMXMVNTPSUSWR RWJYIZGYEWD",
"MYR[RISGUFWF RT?S@TAU@T?TA",
"MYR[RISGUFWF ROSUO",
"MYR[RISGUFWF ROLUL",
"E^J[JLKIMGPFZFSNVNXOYPZRZWYYXZV[R[PZOY",
"H[SMPMNNMOLQLWMYNZP[S[UZVYWWWQVOUNSMPLNKMINGPFTFVG",
"I[MUWU RK[RFY[ RRbSaR`QaRbR`",
"I\\W[WPVNTMPMNN RWZU[P[NZMXMVNTPSUSWR RRbSaR`QaRbR`",
"I[MUWU RK[RFY[ RRAT?U=T;R:P:",
"I\\W[WPVNTMPMNN RWZU[P[NZMXMVNTPSUSWR RRHTFUDTBRAPA",
"I[MUWU RK[RFY[ RU>X; RNAR>VA",
"I\\W[WPVNTMPMNN RWZU[P[NZMXMVNTPSUSWR RUEXB RNHREVH",
"I[MUWU RK[RFY[ RO>L; RNAR>VA",
"I\\W[WPVNTMPMNN RWZU[P[NZMXMVNTPSUSWR ROELB RNHREVH",
"I[MUWU RK[RFY[ RNAR>VA RXAZ?[=Z;X:V:",
"I\\W[WPVNTMPMNN RWZU[P[NZMXMVNTPSUSWR RNHREVH RXHZF[DZBXAVA",
"I[MUWU RK[RFY[ RNAR>VA RM<N;P:T<V;W:",
"I\\W[WPVNTMPMNN RWZU[P[NZMXMVNTPSUSWR RNHREVH RMAN@P?TAV@W?",
"I[MUWU RK[RFY[ RNAR>VA RRbSaR`QaRbR`",
"I\\W[WPVNTMPMNN RWZU[P[NZMXMVNTPSUSWR RNHREVH RRbSaR`QaRbR`",
"I[MUWU RK[RFY[ RN>O@QASAU@V> RT9Q<",
"I\\W[WPVNTMPMNN RWZU[P[NZMXMVNTPSUSWR RNEOGQHSHUGVE RT>QA",
"I[MUWU RK[RFY[ RN>O@QASAU@V> RP9S<",
"I\\W[WPVNTMPMNN RWZU[P[NZMXMVNTPSUSWR RNEOGQHSHUGVE RP>SA",
"I[MUWU RK[RFY[ RN>O@QASAU@V> RP>R<S:R8P7N7",
"I\\W[WPVNTMPMNN RWZU[P[NZMXMVNTPSUSWR RNEOGQHSHUGVE RPERCSAR?P>N>",
"I[MUWU RK[RFY[ RN>O@QASAU@V> RM<N;P:T<V;W:",
"I\\W[WPVNTMPMNN RWZU[P[NZMXMVNTPSUSWR RNEOGQHSHUGVE RMAN@P?TAV@W?",
"I[MUWU RK[RFY[ RN>O@QASAU@V> RRbSaR`QaRbR`",
"I\\W[WPVNTMPMNN RWZU[P[NZMXMVNTPSUSWR RNEOGQHSHUGVE RRbSaR`QaRbR`",
"H[MPTP RW[M[MFWF RRbSaR`QaRbR`",
"I[VZT[P[NZMXMPNNPMTMVNWPWRMT RRbSaR`QaRbR`",
"H[MPTP RW[M[MFWF RRAT?U=T;R:P:",
"I[VZT[P[NZMXMPNNPMTMVNWPWRMT RRHTFUDTBRAPA",
"H[MPTP RW[M[MFWF RMAN@P?TAV@W?",
"I[VZT[P[NZMXMPNNPMTMVNWPWRMT RMHNGPFTHVGWF",
"H[MPTP RW[M[MFWF RU>X; RNAR>VA",
"I[VZT[P[NZMXMPNNPMTMVNWPWRMT RUEXB RNHREVH",
"H[MPTP RW[M[MFWF RO>L; RNAR>VA",
"I[VZT[P[NZMXMPNNPMTMVNWPWRMT ROELB RNHREVH",
"H[MPTP RW[M[MFWF RNAR>VA RXAZ?[=Z;X:V:",
"I[VZT[P[NZMXMPNNPMTMVNWPWRMT RNHREVH RXHZF[DZBXAVA",
"H[MPTP RW[M[MFWF RNAR>VA RM<N;P:T<V;W:",
"I[VZT[P[NZMXMPNNPMTMVNWPWRMT RNHREVH RMAN@P?TAV@W?",
"H[MPTP RW[M[MFWF RNAR>VA RRbSaR`QaRbR`",
"I[VZT[P[NZMXMPNNPMTMVNWPWRMT RNHREVH RRbSaR`QaRbR`",
"MWR[RF RRAT?U=T;R:P:",
"MWR[RM RRHTFUDTBRAPA",
"MWR[RF RRbSaR`QaRbR`",
"MWR[RM RRFQGRHSGRFRH RRbSaR`QaRbR`",
"G]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF RRbSaR`QaRbR`",
"H[P[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ RRbSaR`QaRbR`",
"G]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF RRAT?U=T;R:P:",
"H[P[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ RRHTFUDTBRAPA",
"G]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF RU>X; RNAR>VA",
"H[P[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ RUEXB RNHREVH",
"G]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF RO>L; RNAR>VA",
"H[P[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ ROELB RNHREVH",
"G]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF RNAR>VA RXAZ?[=Z;X:V:",
"H[P[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ RNHREVH RXHZF[DZBXAVA",
"G]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF RNAR>VA RM<N;P:T<V;W:",
"H[P[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ RNHREVH RMAN@P?TAV@W?",
"G]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF RNAR>VA RRbSaR`QaRbR`",
"H[P[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ RNHREVH RRbSaR`QaRbR`",
"G]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF RVGXFYDXBWA RT>QA",
"H[P[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ RUNWMXKWIVH RTEQH",
"G]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF RVGXFYDXBWA RP>SA",
"H[P[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ RUNWMXKWIVH RPESH",
"G]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF RVGXFYDXBWA RRAT?U=T;R:P:",
"H[P[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ RUNWMXKWIVH RRHTFUDTBRAPA",
"G]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF RVGXFYDXBWA RWAVBTCPANBMC",
"H[P[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ RUNWMXKWIVH RWHVITJPHNIMJ",
"G]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF RVGXFYDXBWA RRbSaR`QaRbR`",
"H[P[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ RUNWMXKWIVH RRbSaR`QaRbR`",
"G]LFLWMYNZP[T[VZWYXWXF RRbSaR`QaRbR`",
"H[VMV[ RMMMXNZP[S[UZVY RRbSaR`QaRbR`",
"G]LFLWMYNZP[T[VZWYXWXF RRAT?U=T;R:P:",
"H[VMV[ RMMMXNZP[S[UZVY RRHTFUDTBRAPA",
"G]LFLWMYNZP[T[VZWYXWXF RXFZE[CZAY@ RT>QA",
"H[VMV[ RMMMXNZP[S[UZVY RVMXLYJXHWG RTEQH",
"G]LFLWMYNZP[T[VZWYXWXF RXFZE[CZAY@ RP>SA",
"H[VMV[ RMMMXNZP[S[UZVY RVMXLYJXHWG RPESH",
"G]LFLWMYNZP[T[VZWYXWXF RXFZE[CZAY@ RRAT?U=T;R:P:",
"H[VMV[ RMMMXNZP[S[UZVY RVMXLYJXHWG RRHTFUDTBRAPA",
"G]LFLWMYNZP[T[VZWYXWXF RXFZE[CZAY@ RWAVBTCPANBMC",
"H[VMV[ RMMMXNZP[S[UZVY RVMXLYJXHWG RWHVITJPHNIMJ",
"G]LFLWMYNZP[T[VZWYXWXF RXFZE[CZAY@ RRbSaR`QaRbR`",
"H[VMV[ RMMMXNZP[S[UZVY RVMXLYJXHWG RRbSaR`QaRbR`",
"I[RQR[ RKFRQYF RP>SA",
"JZMMR[ RWMR[P`OaMb RPESH",
"I[RQR[ RKFRQYF RRbSaR`QaRbR`",
"JZMMR[ RWMR[P`OaMb RVbWaV`UaVbV`",
"I[RQR[ RKFRQYF RRAT?U=T;R:P:",
"JZMMR[ RWMR[P`OaMb RRHTFUDTBRAPA",
"I[RQR[ RKFRQYF RMAN@P?TAV@W?",
"JZMMR[ RWMR[P`OaMb RMHNGPFTHVGWF",
"E\\PFP[ RJFJ[Z[",
"J[MMWM ROFOXPZR[ RX[VZUXUF",
"G]QFOGMJLMLWMYNZP[T[VZXXYVYTXPVMUL",
"H[QMONNOMQMWNYOZQ[S[UZVYWWWUVSURSQ",
"G[KFRT RYFRTPXOZM[KZJXKVMUOVPX",
"JZMMR[ RWMR[Q_PaNbLaK_L]N\\P]Q_",
"H]YMVWUYTZR[P[NZMYLVLRMONNPMRMTNUOVQWXXZZ[ RQHRHSGSE",
"H]YMVWUYTZR[P[NZMYLVLRMONNPMRMTNUOVQWXXZZ[ RQEQGRHSH",
"H]YMVWUYTZR[P[NZMYLVLRMONNPMRMTNUOVQWXXZZ[ RTEWH RMHNHOGOE",
"H]YMVWUYTZR[P[NZMYLVLRMONNPMRMTNUOVQWXXZZ[ RTEWH RMEMGNHOH",
"H]YMVWUYTZR[P[NZMYLVLRMONNPMRMTNUOVQWXXZZ[ RXEUH RMHNHOGOE",
"H]YMVWUYTZR[P[NZMYLVLRMONNPMRMTNUOVQWXXZZ[ RXEUH RMEMGNHOH",
"H]YMVWUYTZR[P[NZMYLVLRMONNPMRMTNUOVQWXXZZ[ RQHRHSGSE RMAN@P?TAV@W?",
"H]YMVWUYTZR[P[NZMYLVLRMONNPMRMTNUOVQWXXZZ[ RQEQGRHSH RMAN@P?TAV@W?",
"G[MUWU RK[RFY[ RJHKHLGLE",
"G[MUWU RK[RFY[ RJEJGKHLH",
"?[MUWU RK[RFY[ RIELH RBHCHDGDE",
"?[MUWU RK[RFY[ RIELH RBEBGCHDH",
"?[MUWU RK[RFY[ RMEJH RBHCHDGDE",
"?[MUWU RK[RFY[ RMEJH RBEBGCHDH",
"D[MUWU RK[RFY[ RFAG@I?MAO@P? RJHKHLGLE",
"D[MUWU RK[RFY[ RFAG@I?MAO@P? RJEJGKHLH",
"IZPTNUMWMXNZP[T[VZ RRTPTNSMQMPNNPMTMVN RQHRHSGSE",
"IZPTNUMWMXNZP[T[VZ RRTPTNSMQMPNNPMTMVN RQEQGRHSH",
"IZPTNUMWMXNZP[T[VZ RRTPTNSMQMPNNPMTMVN RTEWH RMHNHOGOE",
"IZPTNUMWMXNZP[T[VZ RRTPTNSMQMPNNPMTMVN RTEWH RMEMGNHOH",
"IZPTNUMWMXNZP[T[VZ RRTPTNSMQMPNNPMTMVN RXEUH RMHNHOGOE",
"IZPTNUMWMXNZP[T[VZ RRTPTNSMQMPNNPMTMVN RXEUH RMEMGNHOH",
23,
23,
"B[MPTP RW[M[MFWF REHFHGGGE",
"B[MPTP RW[M[MFWF REEEGFHGH",
":[MPTP RW[M[MFWF RDEGH R=H>H?G?E",
":[MPTP RW[M[MFWF RDEGH R=E=G>H?H",
":[MPTP RW[M[MFWF RHEEH R=H>H?G?E",
":[MPTP RW[M[MFWF RHEEH R=E=G>H?H",
23,
23,
"I\\NMN[ RNOONQMTMVNWPWb RQHRHSGSE",
"I\\NMN[ RNOONQMTMVNWPWb RQEQGRHSH",
"I\\NMN[ RNOONQMTMVNWPWb RTEWH RMHNHOGOE",
"I\\NMN[ RNOONQMTMVNWPWb RTEWH RMEMGNHOH",
"I\\NMN[ RNOONQMTMVNWPWb RXEUH RMHNHOGOE",
"I\\NMN[ RNOONQMTMVNWPWb RXEUH RMEMGNHOH",
"I\\NMN[ RNOONQMTMVNWPWb RQHRHSGSE RMAN@P?TAV@W?",
"I\\NMN[ RNOONQMTMVNWPWb RQEQGRHSH RMAN@P?TAV@W?",
"A]L[LF RLPXP RX[XF RDHEHFGFE",
"A]L[LF RLPXP RX[XF RDEDGEHFH",
"9]L[LF RLPXP RX[XF RCEFH R<H=H>G>E",
"9]L[LF RLPXP RX[XF RCEFH R<E<G=H>H",
"9]L[LF RLPXP RX[XF RGEDH R<H=H>G>E",
"9]L[LF RLPXP RX[XF RGEDH R<E<G=H>H",
">]L[LF RLPXP RX[XF R@AA@C?GAI@J? RDHEHFGFE",
">]L[LF RLPXP RX[XF R@AA@C?GAI@J? RDEDGEHFH",
"MXRMRXSZU[ RQHRHSGSE",
"MXRMRXSZU[ RQEQGRHSH",
"MXRMRXSZU[ RTEWH RMHNHOGOE",
"MXRMRXSZU[ RTEWH RMEMGNHOH",
"MXRMRXSZU[ RXEUH RMHNHOGOE",
"MXRMRXSZU[ RXEUH RMEMGNHOH",
"MXRMRXSZU[ RQHRHSGSE RMAN@P?TAV@W?",
"MXRMRXSZU[ RQEQGRHSH RMAN@P?TAV@W?",
"GWR[RF RJHKHLGLE",
"GWR[RF RJEJGKHLH",
"?WR[RF RIELH RBHCHDGDE",
"?WR[RF RIELH RBEBGCHDH",
"?WR[RF RMEJH RBHCHDGDE",
"?WR[RF RMEJH RBEBGCHDH",
"DWR[RF RFAG@I?MAO@P? RJHKHLGLE",
"DWR[RF RFAG@I?MAO@P? RJEJGKHLH",
"H[P[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ RQHRHSGSE",
"H[P[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ RQEQGRHSH",
"H[P[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ RTEWH RMHNHOGOE",
"H[P[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ RTEWH RMEMGNHOH",
"H[P[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ RXEUH RMHNHOGOE",
"H[P[NZMYLWLQMONNPMSMUNVOWQWWVYUZS[P[ RXEUH RMEMGNHOH",
23,
23,
"B]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF REHFHGGGE",
"B]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF REEEGFHGH",
":]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF RDEGH R=H>H?G?E",
":]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF RDEGH R=E=G>H?H",
":]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF RHEEH R=H>H?G?E",
":]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF RHEEH R=E=G>H?H",
23,
23,
"H[MMMXNZP[S[UZVYWWWPVNUM RQHRHSGSE",
"H[MMMXNZP[S[UZVYWWWPVNUM RQEQGRHSH",
"H[MMMXNZP[S[UZVYWWWPVNUM RTEWH RMHNHOGOE",
"H[MMMXNZP[S[UZVYWWWPVNUM RTEWH RMEMGNHOH",
"H[MMMXNZP[S[UZVYWWWPVNUM RXEUH RMHNHOGOE",
"H[MMMXNZP[S[UZVYWWWPVNUM RXEUH RMEMGNHOH",
"H[MMMXNZP[S[UZVYWWWPVNUM RQHRHSGSE RMAN@P?TAV@W?",
"H[MMMXNZP[S[UZVYWWWPVNUM RQEQGRHSH RMAN@P?TAV@W?",
23,
"@[RQR[ RKFRQYF RCECGDHEH",
23,
"8[RQR[ RKFRQYF RBEEH R;E;G<H=H",
23,
"8[RQR[ RKFRQYF RFECH R;E;G<H=H",
23,
"=[RQR[ RKFRQYF R?A@@B?FAH@I? RCECGDHEH",
"G]RTRX RMMLNKPKXLZN[O[QZRXSZU[V[XZYXYPXNWM RQHRHSGSE",
"G]RTRX RMMLNKPKXLZN[O[QZRXSZU[V[XZYXYPXNWM RQEQGRHSH",
"G]RTRX RMMLNKPKXLZN[O[QZRXSZU[V[XZYXYPXNWM RTEWH RMHNHOGOE",
"G]RTRX RMMLNKPKXLZN[O[QZRXSZU[V[XZYXYPXNWM RTEWH RMEMGNHOH",
"G]RTRX RMMLNKPKXLZN[O[QZRXSZU[V[XZYXYPXNWM RXEUH RMHNHOGOE",
"G]RTRX RMMLNKPKXLZN[O[QZRXSZU[V[XZYXYPXNWM RXEUH RMEMGNHOH",
"G]RTRX RMMLNKPKXLZN[O[QZRXSZU[V[XZYXYPXNWM RQHRHSGSE RMAN@P?TAV@W?",
"G]RTRX RMMLNKPKXLZN[O[QZRXSZU[V[XZYXYPXNWM RQEQGRHSH RMAN@P?TAV@W?",
"@^J[O[OWMVKTJQJLKIMGPFTFWGYIZLZQYTWVUWU[Z[ RCHDHEGEE",
"@^J[O[OWMVKTJQJLKIMGPFTFWGYIZLZQYTWVUWU[Z[ RCECGDHEH",
"8^J[O[OWMVKTJQJLKIMGPFTFWGYIZLZQYTWVUWU[Z[ RBEEH R;H<H=G=E",
"8^J[O[OWMVKTJQJLKIMGPFTFWGYIZLZQYTWVUWU[Z[ RBEEH R;E;G<H=H",
"8^J[O[OWMVKTJQJLKIMGPFTFWGYIZLZQYTWVUWU[Z[ RFECH R;H<H=G=E",
"8^J[O[OWMVKTJQJLKIMGPFTFWGYIZLZQYTWVUWU[Z[ RFECH R;E;G<H=H",
"=^J[O[OWMVKTJQJLKIMGPFTFWGYIZLZQYTWVUWU[Z[ R?A@@B?FAH@I? RCHDHEGEE",
"=^J[O[OWMVKTJQJLKIMGPFTFWGYIZLZQYTWVUWU[Z[ R?A@@B?FAH@I? RCECGDHEH",
39,
39,
40,
40,
41,
41,
42,
42,
29,
29,
44,
44,
45,
45,
23,
23,
"H]YMVWUYTZR[P[NZMYLVLRMONNPMRMTNUOVQWXXZZ[ RQHRHSGSE RR`RcSdTd",
"H]YMVWUYTZR[P[NZMYLVLRMONNPMRMTNUOVQWXXZZ[ RQEQGRHSH RR`RcSdTd",
"H]YMVWUYTZR[P[NZMYLVLRMONNPMRMTNUOVQWXXZZ[ RTEWH RMHNHOGOE RR`RcSdTd",
"H]YMVWUYTZR[P[NZMYLVLRMONNPMRMTNUOVQWXXZZ[ RTEWH RMEMGNHOH RR`RcSdTd",
"H]YMVWUYTZR[P[NZMYLVLRMONNPMRMTNUOVQWXXZZ[ RXEUH RMHNHOGOE RR`RcSdTd",
"H]YMVWUYTZR[P[NZMYLVLRMONNPMRMTNUOVQWXXZZ[ RXEUH RMEMGNHOH RR`RcSdTd",
"H]YMVWUYTZR[P[NZMYLVLRMONNPMRMTNUOVQWXXZZ[ RQHRHSGSE RMAN@P?TAV@W? RR`RcSdTd",
"H]YMVWUYTZR[P[NZMYLVLRMONNPMRMTNUOVQWXXZZ[ RQEQGRHSH RMAN@P?TAV@W? RR`RcSdTd",
"G[MUWU RK[RFY[ RJHKHLGLE RR`RcSdTd",
"G[MUWU RK[RFY[ RJEJGKHLH RR`RcSdTd",
"?[MUWU RK[RFY[ RIELH RBHCHDGDE RR`RcSdTd",
"?[MUWU RK[RFY[ RIELH RBEBGCHDH RR`RcSdTd",
"?[MUWU RK[RFY[ RMEJH RBHCHDGDE RR`RcSdTd",
"?[MUWU RK[RFY[ RMEJH RBEBGCHDH RR`RcSdTd",
"D[MUWU RK[RFY[ RFAG@I?MAO@P? RJHKHLGLE RR`RcSdTd",
"D[MUWU RK[RFY[ RFAG@I?MAO@P? RJEJGKHLH RR`RcSdTd",
"I\\NMN[ RNOONQMTMVNWPWb RQHRHSGSE RN`NcOdPd",
"I\\NMN[ RNOONQMTMVNWPWb RQEQGRHSH RN`NcOdPd",
"I\\NMN[ RNOONQMTMVNWPWb RTEWH RMHNHOGOE RN`NcOdPd",
"I\\NMN[ RNOONQMTMVNWPWb RTEWH RMEMGNHOH RN`NcOdPd",
"I\\NMN[ RNOONQMTMVNWPWb RXEUH RMHNHOGOE RN`NcOdPd",
"I\\NMN[ RNOONQMTMVNWPWb RXEUH RMEMGNHOH RN`NcOdPd",
"I\\NMN[ RNOONQMTMVNWPWb RQHRHSGSE RMAN@P?TAV@W? RN`NcOdPd",
"I\\NMN[ RNOONQMTMVNWPWb RQEQGRHSH RMAN@P?TAV@W? RN`NcOdPd",
"N]L[LF RLPXP RX[XF RR`RcSdTd",
"A]L[LF RLPXP RX[XF RDEDGEHFH RR`RcSdTd",
"9]L[LF RLPXP RX[XF RCEFH R<H=H>G>E RR`RcSdTd",
"9]L[LF RLPXP RX[XF RCEFH R<E<G=H>H RR`RcSdTd",
"9]L[LF RLPXP RX[XF RGEDH R<H=H>G>E RR`RcSdTd",
"9]L[LF RLPXP RX[XF RGEDH R<E<G=H>H RR`RcSdTd",
">]L[LF RLPXP RX[XF R@AA@C?GAI@J? RDHEHFGFE RR`RcSdTd",
">]L[LF RLPXP RX[XF R@AA@C?GAI@J? RDEDGEHFH RR`RcSdTd",
"G]RTRX RMMLNKPKXLZN[O[QZRXSZU[V[XZYXYPXNWM RQHRHSGSE RR`RcSdTd",
"G]RTRX RMMLNKPKXLZN[O[QZRXSZU[V[XZYXYPXNWM RQEQGRHSH RR`RcSdTd",
"G]RTRX RMMLNKPKXLZN[O[QZRXSZU[V[XZYXYPXNWM RTEWH RMHNHOGOE RR`RcSdTd",
"G]RTRX RMMLNKPKXLZN[O[QZRXSZU[V[XZYXYPXNWM RTEWH RMEMGNHOH RR`RcSdTd",
"G]RTRX RMMLNKPKXLZN[O[QZRXSZU[V[XZYXYPXNWM RXEUH RMHNHOGOE RR`RcSdTd",
"G]RTRX RMMLNKPKXLZN[O[QZRXSZU[V[XZYXYPXNWM RXEUH RMEMGNHOH RR`RcSdTd",
"G]RTRX RMMLNKPKXLZN[O[QZRXSZU[V[XZYXYPXNWM RQHRHSGSE RMAN@P?TAV@W? RR`RcSdTd",
"G]RTRX RMMLNKPKXLZN[O[QZRXSZU[V[XZYXYPXNWM RQEQGRHSH RMAN@P?TAV@W? RR`RcSdTd",
"@^J[O[OWMVKTJQJLKIMGPFTFWGYIZLZQYTWVUWU[Z[ RCHDHEGEE RR`RcSdTd",
"@^J[O[OWMVKTJQJLKIMGPFTFWGYIZLZQYTWVUWU[Z[ RCECGDHEH RR`RcSdTd",
"8^J[O[OWMVKTJQJLKIMGPFTFWGYIZLZQYTWVUWU[Z[ RBEEH R;H<H=G=E RR`RcSdTd",
"8^J[O[OWMVKTJQJLKIMGPFTFWGYIZLZQYTWVUWU[Z[ RBEEH R;E;G<H=H RR`RcSdTd",
"8^J[O[OWMVKTJQJLKIMGPFTFWGYIZLZQYTWVUWU[Z[ RFECH R;H<H=G=E RR`RcSdTd",
"8^J[O[OWMVKTJQJLKIMGPFTFWGYIZLZQYTWVUWU[Z[ RFECH R;E;G<H=H RR`RcSdTd",
"=^J[O[OWMVKTJQJLKIMGPFTFWGYIZLZQYTWVUWU[Z[ R?A@@B?FAH@I? RCHDHEGEE RR`RcSdTd",
"=^J[O[OWMVKTJQJLKIMGPFTFWGYIZLZQYTWVUWU[Z[ R?A@@B?FAH@I? RCECGDHEH RR`RcSdTd",
"H]YMVWUYTZR[P[NZMYLVLRMONNPMRMTNUOVQWXXZZ[ RNEOGQHSHUGVE",
"H]YMVWUYTZR[P[NZMYLVLRMONNPMRMTNUOVQWXXZZ[ RMGWG",
"H]YMVWUYTZR[P[NZMYLVLRMONNPMRMTNUOVQWXXZZ[ RPESH RR`RcSdTd",
"H]YMVWUYTZR[P[NZMYLVLRMONNPMRMTNUOVQWXXZZ[ RR`RcSdTd",
"H]YMVWUYTZR[P[NZMYLVLRMONNPMRMTNUOVQWXXZZ[ RTEQH RR`RcSdTd",
23,
"H]YMVWUYTZR[P[NZMYLVLRMONNPMRMTNUOVQWXXZZ[ RMHNGPFTHVGWF",
"H]YMVWUYTZR[P[NZMYLVLRMONNPMRMTNUOVQWXXZZ[ RMHNGPFTHVGWF RR`RcSdTd",
30,
"I[MUWU RK[RFY[ RM@W@",
"G[MUWU RK[RFY[ RIELH",
"G[MUWU RK[RFY[ RMEJH",
"I[MUWU RK[RFY[ RR`RcSdTd",
"NVQHRHSGSE",
"NVR`RcSdTd",
"NVQHRHSGSE",
"KZMHNGPFTHVGWF",
"LXMCNBPATCVBWA RNFOGNHMGNFNH RVFWGVHUGVFVH",
"I\\NMN[ RNOONQMTMVNWPWb RPESH RN`NcOdPd",
"I\\NMN[ RNOONQMTMVNWPWb RN`NcOdPd",
"I\\NMN[ RNOONQMTMVNWPWb RTEQH RN`NcOdPd",
23,
"I\\NMN[ RNOONQMTMVNWPWb RMHNGPFTHVGWF",
"I\\NMN[ RNOONQMTMVNWPWb RMHNGPFTHVGWF RN`NcOdPd",
"B[MPTP RW[M[MFWF RDEGH",
"B[MPTP RW[M[MFWF RHEEH",
"A]L[LF RLPXP RX[XF RCEFH",
"A]L[LF RLPXP RX[XF RGEDH",
"G]L[LF RLPXP RX[XF RR`RcSdTd",
"JZTEWH RMHNHOGOE",
"JZXEUH RMHNHOGOE",
"NVQHRHSGSE RMAN@P?TAV@W?",
"MXRMRXSZU[ RNEOGQHSHUGVE",
"MXRMRXSZU[ RMGWG",
"MXRMRXSZU[ RNFOGNHMGNFNH RVFWGVHUGVFVH RP>SA",
"MXRMRXSZU[ RNFOGNHMGNFNH RVFWGVHUGVFVH RT>QA",
23,
23,
"MXRMRXSZU[ RMHNGPFTHVGWF",
"MXRMRXSZU[ RMCNBPATCVBWA RNFOGNHMGNFNH RVFWGVHUGVFVH",
"MWR[RF RN>O@QASAU@V>",
"MWR[RF RM@W@",
"GWR[RF RIELH",
"GWR[RF RMEJH",
23,
"JZTEWH RMEMGNHOH",
"JZXEUH RMEMGNHOH",
"NVQEQGRHSH RMAN@P?TAV@W?",
"H[MMMXNZP[S[UZVYWWWPVNUM RNEOGQHSHUGVE",
"H[MMMXNZP[S[UZVYWWWPVNUM RMGWG",
"H[MMMXNZP[S[UZVYWWWPVNUM RNFOGNHMGNFNH RVFWGVHUGVFVH RP>SA",
"H[MMMXNZP[S[UZVYWWWPVNUM RNFOGNHMGNFNH RVFWGVHUGVFVH RT>QA",
"H\\MbMQNOONQMTMVNWOXQXWWYVZT[Q[OZMX RQHRHSGSE",
"H\\MbMQNOONQMTMVNWOXQXWWYVZT[Q[OZMX RQEQGRHSH",
"H[MMMXNZP[S[UZVYWWWPVNUM RMHNGPFTHVGWF",
"H[MMMXNZP[S[UZVYWWWPVNUM RMCNBPATCVBWA RNFOGNHMGNFNH RVFWGVHUGVFVH",
"I[RQR[ RKFRQYF RN>O@QASAU@V>",
"I[RQR[ RKFRQYF RM@W@",
"@[RQR[ RKFRQYF RBEEH",
"@[RQR[ RKFRQYF RFECH",
"A\\L[LFTFVGWHXJXMWOVPTQLQ RDEDGEHFH",
"LXNFOGNHMGNFNH RVFWGVHUGVFVH RP>SA",
"LXNFOGNHMGNFNH RVFWGVHUGVFVH RT>QA",
16,
23,
23,
"G]RTRX RMMLNKPKXLZN[O[QZRXSZU[V[XZYXYPXNWM RPESH RR`RcSdTd",
"G]RTRX RMMLNKPKXLZN[O[QZRXSZU[V[XZYXYPXNWM RR`RcSdTd",
"G]RTRX RMMLNKPKXLZN[O[QZRXSZU[V[XZYXYPXNWM RTEQH RR`RcSdTd",
23,
"G]RTRX RMMLNKPKXLZN[O[QZRXSZU[V[XZYXYPXNWM RMHNGPFTHVGWF",
"G]RTRX RMMLNKPKXLZN[O[QZRXSZU[V[XZYXYPXNWM RMHNGPFTHVGWF RR`RcSdTd",
"B]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF RDEGH",
"B]PFTFVGXIYMYTXXVZT[P[NZLXKTKMLINGPF RHEEH",
"@^J[O[OWMVKTJQJLKIMGPFTFWGYIZLZQYTWVUWU[Z[ RBEEH",
"@^J[O[OWMVKTJQJLKIMGPFTFWGYIZLZQYTWVUWU[Z[ RFECH",
"F^J[O[OWMVKTJQJLKIMGPFTFWGYIZLZQYTWVUWU[Z[ RR`RcSdTd",
25,
"NVQEQGRHSH",
23,
"F^",
"LX",
"F^",
"LX",
"NV",
"OU",
"PT",
"H\\",
"MW",
"PT",
"QS",
24,
24,
24,
24,
24,
46,
46,
"H\\JRZR",
"LXVTNT",
"F^IT[T",
"F^IT[T",
"H\\ODOb RUDUb",
"JZJbZb RJ]Z]",
"MWQGQFRDSC",
"MWSFSGRIQJ",
"MWSZS[R]Q^",
"MWQFQGRISJ",
"JZUGUFVDWC RMGMFNDOC",
"JZOFOGNIMJ RWFWGVIUJ",
"JZOZO[N]M^ RWZW[V]U^",
"JZUFUGVIWJ RMFMGNIOJ",
"I[MMWM RRFRb",
"I[M[W[ RMMWM RRFRb",
"E_PQPU RQUQQ RRPRV RSUSQ RTQTU RPTRVTT RPRRPTR RPQRPTQUSTURVPUOSPQ",
"E_PPPV RQQQU RRQRU RSSUS RSRST ROPUSOV RVSOWOOVS",
"MWRYSZR[QZRYR[",
"MaRYSZR[QZRYR[ R\\Y]Z\\[[Z\\Y\\[",
"MkRYSZR[QZRYR[ R\\Y]Z\\[[Z\\Y\\[ RfYgZf[eZfYf[",
26,
24,
24,
24,
24,
24,
24,
24,
24,
"FjJ[ZF RMFOGPIOKMLKKJIKGMF RcUeVfXeZc[aZ`XaVcU RYZZXYVWUUVTXUZW[YZ",
"FvJ[ZF RMFOGPIOKMLKKJIKGMF RcUeVfXeZc[aZ`XaVcU RoUqVrXqZo[mZlXmVoU RYZZXYVWUUVTXUZW[YZ",
"MWTFQL",
"JZQFNL RWFTL",
"G]NFKL RTFQL RZFWL",
"MWPFSL",
"JZSFVL RMFPL",
"G]VFYL RPFSL RJFML",
"LXVcR`Nc",
"KYUMOSUY",
"KYOMUSOY",
"E_LMXY RXMLY RKRLSKTJSKRKT RRYSZR[QZRYR[ RRKSLRMQLRKRM RYRZSYTXSYRYT",
"MaRYSZR[QZRYR[ RRSQGRFSGRSRF R\\Y]Z\\[[Z\\Y\\[ R\\S[G\\F]G\\S\\F",
"I[QFQS RQYRZQ[PZQYQ[ RQYRZQ[PZQYQ[ RMGOFTFVGWIWKVMUNSORPQRQS RMGOFTFVGWIWKVMUNSORPQRQS",
"E_JGZG",
"OUb`aa^c\\dYeTfPfKeHdFcCaB`",
"OUBFCEFCHBKAP@T@YA\\B^CaEbF",
"E_N_VW RV_R[",
"CaKRKW RRFRK RYRYW RFUKWPU RH[KWN[ RMIRKWI ROORKUO RTUYW^U RV[YW\\[",
46,
1,
"KYQSVS RVbQbQDVD",
"KYSSNS RNbSbSDND",
"ImQYRZQ[PZQYQ[ RMGOFTFVGWIWKVMUNSORPQRQS RcYdZc[bZcYc[ R_GaFfFhGiIiKhMgNeOdPcRcS",
"IeQYRZQ[PZQYQ[ RMGOFTFVGWIWKVMUNSORPQRQS R`YaZ`[_Z`Y`[ R`S_G`FaG`S`F",
"MiRYSZR[QZRYR[ RRSQGRFSGRSRF R_Y`Z_[^Z_Y_[ R[G]FbFdGeIeKdMcNaO`P_R_S",
"KYNMVMPb",
"G^NMN[ RUMUXVZX[ RJMWMYNZP",
"H\\NQNU RWPWV RPVPPOQOUPV RQPPPNQMSNUPVQVQP",
"H\\VQVU RMPMV RTVTPUQUUTV RSPTPVQWSVUTVSVSP",
"JZR[RV RWXRVMX RURRVOR",
"MWQZQ[R]S^ RRNQORPSORNRP",
"OUBFCEFCHBKAP@T@YA\\B^CaEbF Rb`aa^c\\dYeTfPfKeHdFcCaB`",
"JZRFRK RMIRKWI ROORKUO RRFRK RWIRKMI RUORKOO",
"JZM^WB RNFOGNHMGNFNH RVYWZV[UZVYV[",
"E_JSKRNQQRSTVUYTZS",
">fB^B]C[EZOZQYRWSYUZ_Za[b]b^",
"E_JSZS RR[RK RLMXY RXMLY",
"E_LRMSLTKSLRLT RXYYZX[WZXYX[ RXKYLXMWLXKXM",
"D`KFHL RQFNL RWFTL R]FZL",
"E_KRLSKTJSKRKT RRYSZR[QZRYR[ RRKSLRMQLRKRM RYRZSYTXSYRYT",
"E_LXMYLZKYLXLZ RLLMMLNKMLLLN RRRSSRTQSRRRT RXXYYXZWYXXXZ RXLYMXNWMXLXN",
"MWRYSZR[QZRYR[ RRNSORPQORNRP",
"E_KRLSKTJSKRKT RRYSZR[QZRYR[ RRKSLRMQLRKRM RYRZSYTXSYRYT",
"E_JSZS RR[RK RLXMYLZKYLXLZ RLLMMLNKMLLLN RXXYYXZWYXXXZ RXLYMXNWMXLXN",
"CaR\\S]R^Q]R\\R^ RRRSSRTQSRRRT RRHSIRJQIRHRJ",
"CaR^S_R`Q_R^R` RRVSWRXQWRVRX RRNSORPQORNRP RRFSGRHQGRFRH",
"OU",
24,
24,
24,
24,
24,
23,
23,
23,
23,
23,
24,
24,
24,
24,
24,
24,
"JZQ@S@UAVDVJUMSNQNOMNJNDOAQ@",
"NVRDRN RR=Q>R?S>R=R?",
23,
23,
"JZUFUN RQ@NJWJ",
"JZV@O@NFPESEUFVHVKUMSNPNNM",
"JZNHOFQESEUFVHVKUMSNQNOMNKNFOCPAR@U@",
"JZM@W@PN",
"JZQFOENCOAQ@S@UAVCUESFQFOGNINKOMQNSNUMVKVIUGSF",
"JZVFUHSIQIOHNFNCOAQ@S@UAVCVHUKTMRNON",
"I[LHXH RRBRN",
"I[LHXH",
"I[LJXJ RLFXF",
"MWT=S>RAQFQJROSRTS",
"MWP=Q>RASFSJROQRPS",
"KZODON ROEQDSDUEVGVN",
"JZQSSSUTVWV]U`SaQaO`N]NWOTQS",
"JZVaNa RNVPURSRa",
"JZNTPSSSUTVVVXUZNaVa",
"JZNSVSRXSXUYV[V^U`SaPaN`",
"JZUYUa RQSN]W]",
"JZVSOSNYPXSXUYV[V^U`SaPaN`",
"JZN[OYQXSXUYV[V^U`SaQaO`N^NYOVPTRSUS",
"JZMSWSPa",
"JZQYOXNVOTQSSSUTVVUXSYQYOZN\\N^O`QaSaU`V^V\\UZSY",
"JZVYU[S\\Q\\O[NYNVOTQSSSUTVVV[U^T`RaOa",
"I[L[X[ RRURa",
"I[L[X[",
"I[L]X] RLYXY",
"MWTPSQRTQYQ]RbSeTf",
"MWPPQQRTSYS]RbQePf",
24,
"KZOXQWSWUXVZVa RV`TaQaO`N^O\\Q[V[",
"LYV`TaRaP`O^OZPXRWSWUXVZV[O\\",
"KYQaO`N^NZOXQWSWUXVZV^U`SaQa",
"KYNWVa RVWNa",
"LYOXQWSWUXVZV^U`SaRaP`O^O]V\\",
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
"F[XMPMP[X[ RTGRFNFLGKHJJJPKRLSNTUT",
"F[WYVZS[Q[NZLXKVJRJOKKLINGQFSFVGWH RSBG_ RZBN_",
"F[WYVZS[Q[NZLXKVJRJOKKLINGQFSFVGWH RR[RM RRQSOTNVMXM",
"HZTPMP RM[MFWF RJVRV",
"H[LMTM RL[W[ RO[OIPGRFUFWG RLSTS",
"D`I[IM RIOJNLMOMQNRPR[ RRPSNUMXMZN[P[[ RWHM`",
"G]L[LFX[XF RHV\\V RHP\\P",
"GyL[LFTFVGWHXJXMWOVPTQLQ R^MfM RaFaXbZd[f[ RlZn[r[tZuXuWtUrToTmSlQlPmNoMrMtN",
"GmX[QQ RL[LFTFVGWHXJXMWOVPTQLQ R`Zb[f[hZiXiWhUfTcTaS`Q`PaNcMfMhN",
"F^IFN[RLV[[F RHV\\V RHP\\P",
"D`I[IFOFRGTIULUR RONOUPXRZU[[[[F",
"I\\W[WF RWZU[Q[OZNYMWMQNOONQMUMWN RRHZH RXaNa",
"F[HSQS RHNTN RWYVZS[Q[NZLXKVJRJOKKLINGQFSFVGWH",
"G\\L[LF RX[OO RXFLR RLOTO",
"JZLFXF RR[RF ROVUR ROPUL",
"IoK[RFY[K[ R`b`QaObNdMgMiNjOkQkWjYiZg[d[bZ`X",
"G]ITJSLRNSOTQUSTXOYLYIXGVFUFSGRIRLSOXTYVYWXYWZT[",
"G\\L[LFTFVGWHXJXMWOVPTQLQ RHL\\L",
"F[VGTFQFNGLIKKJOJRKVLXNZQ[S[VZWYWRSR RRCR^",
"I[K[RFY[ RHV\\V RHP\\P",
"H\\XZU[P[NZMYLWLUMSNRPQTPVOWNXLXJWHVGTFOFLG RRCR^",
"HZVZT[P[NZMYLWLQMONNPMTMVN RRJR^",
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
"F^J[O[OWMVKTJQJLKIMGPFTFWGYIZLZQYTWVUWU[Z[",
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
"E_ZSJS RNWJSNO",
"E_R[RK RNORKVO",
"E_JSZS RVWZSVO",
"E_RKR[ RVWR[NW",
"E_JSZS RVWZSVO RNOJSNW",
"E_R[RK RNORKVO RVWR[NW",
"E_KLYZ RRLKLKS",
"E_YLKZ RRLYLYS",
"E_YZKL RRZYZYS",
"E_KZYL RRZKZKS",
"E_ZSJS RRWVO RNOJSNW",
"E_JSZS RRONW RVWZSVO",
"E_JWJQPQ RJQMTOUQTSRUQWRZU",
"E_ZWZQTQ RZQWTUUSTQROQMRJU",
"E_ZSJS RTOPSTW RNWJSNO",
"E_R[RK RNURQVU RNORKVO",
"E_JSZS RPOTSPW RVWZSVO",
"E_RKR[ RVQRUNQ RVWR[NW",
"E_JSVS RZOVSZW RNWJSNO",
"E_ZSNS RJONSJW RVWZSVO",
"E_ZOZW RJSZS RNWJSNO",
"E_R[RK RV[N[ RNORKVO",
"E_JOJW RZSJS RVWZSVO",
"E_RKR[ RNKVK RVWR[NW",
"E_N[V[ RR[RK RNWR[VW RNORKVO",
"E_NWJSNO RJSWSYRZPYNWM",
"E_VWZSVO RZSMSKRJPKNMM",
"E_NWJSNO RJSWSYRZPYNWMUNTPTW",
"E_VWZSVO RZSMSKRJPKNMMONPPPW",
"E_PUJUJO RZWZQTQ RZQWTUUSTQROQMRJU",
"E_JSZS RTOPW RNOJSNW RVWZSVO",
"E_PWR[VY ROKLTVOR[",
"E_V[VOJO RNSJONK",
"E_N[NOZO RVSZOVK",
"E_VKVWJW RNSJWN[",
"E_NKNWZW RVSZWV[",
"E_JOVOV[ RZWV[RW",
"E_VKVWJW RNSJWN[",
"E_OQKUGQ RYRYQXNVLSKQKNLLNKQKU",
"E_UQYU]Q RKRKQLNNLQKSKVLXNYQYU",
"E_KLYZ RKHYH RRLKLKS",
"E_JWZW RJKJS RZSZ[ RZOJO RNSJONK RV[ZWVS",
"E_[KUKUQ RMMLNKQKSLVNXQYSYVXXVYSYQXNUK",
"E_IKOKOQ RWMXNYQYSXVVXSYQYNXLVKSKQLNOK",
"E_ZSJSNO",
"E_ZSJSNW",
"E_R[RKVO",
"E_R[RKNO",
"E_JSZSVO",
"E_JSZSVW",
"E_RKR[VW",
"E_RKR[NW",
"E_ZWJW RJOZO RVSZOVK RN[JWNS",
"E_N[NK RVKV[ RJONKRO RRWV[ZW",
"E_JWZW RZOJO RNSJONK RV[ZWVS",
"E_ZWJW RJOZO RN[JWNSJONK",
"E_N[NK RVKV[ RJONKROVKZO",
"E_JWZW RZOJO RV[ZWVSZOVK",
"E_VKV[ RN[NK RZWV[RWN[JW",
"E_JVZVVZ RZPJPNL",
"E_ZVJVNZ RJPZPVL",
"E_ZPMP RZVMV RRXVN ROXJSON",
"E_MVWV RMPWP RSNQX ROXJSON RUNZSUX",
"E_JVWV RJPWP RRNNX RUNZSUX",
"E_ZPMP RZVMV ROXJSON",
"E_ONO[ RUNU[ RWPRKMP",
"E_JVWV RJPWP RUNZSUX",
"E_UXUK ROXOK RMVR[WV",
"E_MVWV RMPWP ROXJSON RUNZSUX",
"E_OXON RUXUN RMVR[WV RWPRKMP",
"E_[XOL RW\\KP RSLKLKT",
"E_IXUL RM\\YP RQLYLYT",
"E_INUZ RMJYV RQZYZYR",
"E_[NOZ RWJKV RSZKZKR",
"E_ZXOX RZSJS RZNON RQLJSQZ",
"E_JXUX RJSZS RJNUN RSLZSSZ",
"E_NWJSNO RZUWQTUQQNULSJS",
"E_VWZSVO RJUMQPUSQVUXSZS",
"E_NXVX RNSVS RR[RK RNORKVO",
"E_VNNN RVSNS RRKR[ RVWR[NW",
"E_ZSWS RSSQS RMSJS RNOJSNW",
"E_R[RX RRTRR RRNRK RNORKVO",
"E_JSMS RQSSS RWSZS RVWZSVO",
"E_RKRN RRRRT RRXR[ RVWR[NW",
"E_ZSJS RJWJO RNOJSNW",
"E_JSZS RZOZW RVWZSVO",
"E_ZPZVOVOXJSONOPZP",
"E_U[O[OPMPRKWPUPU[",
"E_JVJPUPUNZSUXUVJV",
"E_OKUKUVWVR[MVOVOK",
"E_U[O[OWUWU[ RUSOSOPMPRKWPUPUS",
"E_W[M[MWOWOPMPRKWPUPUWWWW[",
"E_ONUN RW[M[MWOWOPMPRKWPUPUWWWW[",
"E_RKR[ RW[M[MWOWOPMPRKWPUPUWWWW[",
"E_PPMPRKWPTP RU[O[OSMSRNWSUSU[",
"E_PPMPRKWPTP RW[M[MWOWOSMSRNWSUSUWWWW[",
"E_JNNNNPUPUNZSUXUVNVNXJXJN",
"E_Z[NO RZKJKJ[ RUONONV",
"E_JKVW RJ[Z[ZK ROWVWVP",
"E_MPRKWPUPUVWVR[MVOVOPMP",
"E_JSZS RVWZSVO RTRTTSVQWOWMVLTLRMPOOQOSPTR",
"E_V[VK RNKN[ RZOVKRO RRWN[JW",
"E_J[Z[ RJKZK RZSJS RVGZKVOZSVWZ[V_",
"E_ZSJS RTWTO RNOJSNW",
"E_JSZS RPOPW RVWZSVO",
"E_JSZS RRORW RNOJSNW RVWZSVO",
"E_ZSJS RWWWO RRWRO RNOJSNW",
"E_JSZS RMOMW RRORW RVWZSVO",
"E_JSZS RPOPW RTOTW RNWJSNO RVWZSVO",
"E_NSZS RNWNOJSNW",
"E_VSJS RVWVOZSVW",
"E_NSVS RNWJSNONW RVWVOZSVW",
"I[MLWL RKFR[YF",
"HZVHUGSFPFNGMHLKLVMYNZP[S[UZVY",
"H[WOVNTMPMNNMOLQLWMYNZP[S[UZVYWWWJVHUGSFOFMG",
"I\\WPPP RM[W[WFMF",
"I\\WQPQ RMFWFW[M[ RXCL`",
"C`G[\\F ROFTFXHZJ\\N\\SZWXYT[O[KYIWGSGNIJKHOF",
"I[K[RFY[K[",
"I[YFR[KFYF",
"C`\\QGQ R\\GOGKIIKGOGSIWKYO[\\[",
"C`[CH^ R\\QGQ R\\GOGKIIKGOGSIWKYO[\\[",
"E_JSZS RZZPZMYKWJTJRKOMMPLZL",
"DaHP]P RHZUZYX[V]R]N[JYHUFHF",
"DaI^\\C RHP]P RHZUZYX[V]R]N[JYHUFHF",
"E_ZSJS RJZTZWYYWZTZRYOWMTLJL",
"E_M[WQ RMZWP RMYWO RMXWN RMWWM RMVWL RMUWK RMTVK RMSUK RMRTK RMQSK RMPRK RMOQK RMNPK RMMOK RMLNK RN[WR RO[WS RP[WT RQ[WU RR[WV RS[WW RT[WX RU[WY RV[WZ RM[MKWKW[M[",
"E_Z`ZFJFJ`",
"E_ZFZ`J`JF",
"E_Z`I`TSIF[F",
0,
"E_ZWJW RROR_ RJKZK",
"E_JSZS RR[RK RRDQERFSERDRF",
1,
"KYID[_",
"E_KOYW RR[RK RYOKW",
"E_PQRPTQUSTURVPUOSPQ",
"E_PQPU RQUQQ RRPRV RSUSQ RTQTU RPTRVTT RPRRPTR RPQRPTQUSTURVPUOSPQ",
"IbMTQSS[bB",
"IbMTQSS[bB RN@V@RESEUFVHVKUMSNPNNM",
"IbMTQSS[bB RUFUN RQ@NJWJ",
"E_XPWPUQQUOVMULSMQOPQQUUWVXV",
"E_TQVPXQYSXUVVTUPQNPLQKSLUNVPUTQ",
"E_JKJ[Z[",
"E_ZKJ[Z[",
"E_ZKJ[Z[ RPSRUTZT]",
"E_Z[JSZK RSYTWUSTOSM",
22,
"H\\NUVQ RRDRb",
"H\\ODOb RUDUb",
"H\\LVXP RODOb RUDUb",
"E_[[RKI[",
"E_IKR[[K",
"E_Z[ZQXMTKPKLMJQJ[",
"E_JKJULYP[T[XYZUZK",
"H\\L]M_O`Q_R]RISGUFWGXI",
"D`H]I_K`M_N]NIOGQFSGTI RP]Q_S`U_V]VIWGYF[G\\I",
"@dD]E_G`I_J]JIKGMFOGPI RL]M_O`Q_R]RISGUFWGXI RT]U_W`Y_Z]ZI[G]F_G`I",
"H\\L]M_O`Q_R]RISGUFWGXI RRMUNWPXSWVUXRYOXMVLSMPONRM",
"D`H]I_K`M_N]NIOGQFSGTI RP]Q_S`U_V]VIWGYF[G\\I RVMYN[P\\S[VYXVYNYKXIVHSIPKNNMVM",
"@dD]E_G`I_J]JIKGMFOGPI RL]M_O`Q_R]RISGUFWGXI RT]U_W`Y_Z]ZI[G]F_G`I RZM]N_P`S_V]XZYJYGXEVDSEPGNJMZM",
"H\\URXU[R RLSMPONRMUNWPXSXU RL]M_O`Q_R]RISGUFWGXI",
"H\\UQXT[Q RL]M_O`Q_R]RISGUFWGXI RLSMPONRMUNWPXSWVUXRYOXMVLS",
"H\\UUXR[U RL]M_O`Q_R]RISGUFWGXI RLSMPONRMUNWPXSWVUXRYOXMVLS",
"E_KXLYKZJYKXKZ RRLSMRNQMRLRN RYXZYYZXYYXYZ",
"E_YNXMYLZMYNYL RRZQYRXSYRZRX RKNJMKLLMKNKL",
"JZRXSYRZQYRXRZ RRLSMRNQMRLRN",
"E_LXMYLZKYLXLZ RLLMMLNKMLLLN RXXYYXZWYXXXZ RXLYMXNWMXLXN",
"E_JSZS RRFQGRHSGRFRH",
"E_JSTS RYXZYYZXYYXYZ RYLZMYNXMYLYN",
"E_JSZS RLXMYLZKYLXLZ RLLMMLNKMLLLN RXXYYXZWYXXXZ RXLYMXNWMXLXN",
"E_JSKRNQQRSTVUYTZS RRXSYRZQYRXRZ RRLSMRNQMRLRN",
"E_JSKRNQQRSTVUYTZS",
"E_ZSYRVQSRQTNUKTJS",
"E_WPYQZSYUWVTUPQMPKQJSKUMV",
"E_JSKNLLNKPLQNSXTZV[XZYXZS",
"E_RKSLTOSRQTPWQZR[",
"E_JSKRNQQRSTVUYTZS RVKN[",
"E_ZPJP RZVYWVXSWQUNTKUJV",
"E_JVZV RJPKONNQOSQVRYQZP",
"E_JVZV RJPKONNQOSQVRYQZP RVKN[",
"E_JYZY RJSZS RJMKLNKQLSNVOYNZM",
"E_JYZY RJSZS RUPO\\ RJMKLNKQLSNVOYNZM",
"E_JYZY RJSZS RJMKLNKQLSNVOYNZM RXGL_",
"E_JVKUNTQUSWVXYWZV RJPKONNQOSQVRYQZP",
"E_JVKUNTQUSWVXYWZV RJPKONNQOSQVRYQZP RVKN[",
"E_JYZY RJSKRNQQRSTVUYTZS RJMKLNKQLSNVOYNZM",
"E_JYKXNWQXSZV[YZZY RJSKRNQQRSTVUYTZS RJMKLNKQLSNVOYNZM",
"E_ZYJY RZSJS RZMYLVKSLQNNOKNJM",
"E_JXLWPVTVXWZX RJNLOPPTPXOZN",
"E_JVNVNWOYQZSZUYVWVVZV RJPNPNOOMQLSLUMVOVPZP",
"E_ZVJV RJPNPNOOMQLSLUMVOVPZP",
"E_JPZP RZVJV RRHQIRJSIRHRJ",
"E_JPZP RZVJV RRXSYRZQYRXRZ RRLSMRNQMRLRN",
"E_JPZP RZVJV RKJLKKLJKKJKL RYZZ[Y\\X[YZY\\",
"E_ZPJP RJVZV RYJXKYLZKYJYL RKZJ[K\\L[KZK\\",
"AcNP^P R^VNV RGVHWGXFWGVGX RGNHOGPFOGNGP",
"AcVPFP RFVVV R]V\\W]X^W]V]X R]N\\O]P^O]N]P",
"E_JPZP RZVJV RPQRPTQUSTURVPUOSPQ",
"E_JPZP RZVJV RRJPIOGPERDTEUGTIRJ",
"E_JPZP RZVJV RNJOHQGSGUHVJ",
"E_JPZP RZVJV RNJRGVJ",
"E_JPZP RZVJV RNGRJVG",
"E_JPZP RZVJV RRATGOCUCPGRA",
"E_JPZP RZVJV RR?NJVJR?",
"E_JPZP RYC]C RZVJV R]?[@ZBZJ RM?MJKJIIHGHEICKBMB RQFVFVCUBRBQCQIRJUJ",
"E_JPZP RZVJV RMBMJ RMCNBQBRCRJ RRCSBVBWCWJ",
"E_JPZP RZVJV RRHSIRJQIRHRJ RN@P?S?U@VBUDSE",
"E_JPZP RTMPY RZVJV",
"E_JYZY RJSZS RJMZM",
"E_JYZY RJSZS RJMZM RXGL_",
"E_J\\Z\\ RJPZP RJJZJ RZVJV",
"E_ZZJZ RZVJPZJ",
"E_JZZZ RJVZPJJ",
"E_J]Z] RZWJW RZSJMZG",
"E_Z]J] RJWZW RJSZMJG",
"E_J]Z] RTTP` RZWJW RZSJMZG",
"E_JWZW RTTP` RZ]J] RJSZMJG",
"=gRMBSRY RbMRSbY",
"=gRMbSRY RBMRSBY",
"I[OCPDRGSITLUQUUTZS]R_PbOc RUcTbR_Q]PZOUOQPLQIRGTDUC",
"E_JXLWPVTVXWZX RJNLOPPTPXOZN RVKN[",
"E_ZMJSZY RVKN[",
"E_JMZSJY RVKN[",
"E_ZZJZ RZVJPZJ RXGL_",
"E_JZZZ RJVZPJJ RXGL_",
"E_ZVJPZJ RJZKYNXQYS[V\\Y[ZZ",
"E_JVZPJJ RJZKYNXQYS[V\\Y[ZZ",
"E_ZVJPZJ RJZKYNXQYS[V\\Y[ZZ RXGL_",
"E_JVZPJJ RJZKYNXQYS[V\\Y[ZZ RXGL_",
"E_JSZYJ_ RZSJMZG",
"E_ZSJYZ_ RJSZMJG",
"E_JSZYJ_ RZSJMZG RXGL_",
"E_ZSJYZ_ RJSZMJG RXGL_",
"E_ZKXNVPRRJSRTVVXXZ[",
"E_JKLNNPRRZSRTNVLXJ[",
"E_JVRWVYX[Z^ RZHXKVMROJPRQVSXUZX",
"E_ZVRWNYL[J^ RJHLKNMROZPRQNSLUJX",
"E_J[KZNYQZS\\V]Y\\Z[ RZHXKVMROJPRQVSXUZX",
"E_J[KZNYQZS\\V]Y\\Z[ RJXLUNSRQZPRONMLKJH",
"E_ZKXNVPRRJSRTVVXXZ[ RVKN[",
"E_JKLNNPRRZSRTNVLXJ[ RVKN[",
"E_ZMNMLNKOJQJUKWLXNYZY",
"E_JMVMXNYOZQZUYWXXVYJY",
"E_ZMNMLNKOJQJUKWLXNYZY RVKN[",
"E_JMVMXNYOZQZUYWXXVYJY RVKN[",
"E_J\\Z\\ RZJNJLKKLJNJRKTLUNVZV",
"E_Z\\J\\ RJJVJXKYLZNZRYTXUVVJV",
"E_J\\Z\\ RZJNJLKKLJNJRKTLUNVZV RXGL_",
"E_Z\\J\\ RJJVJXKYLZNZRYTXUVVJV RXGL_",
"E_J\\Z\\ RZJNJLKKLJNJRKTLUNVZV RSYQ_",
"E_Z\\J\\ RJJVJXKYLZNZRYTXUVVJV RSYQ_",
"E_JKJULYP[T[XYZUZK ROSUS RSUUSSQ",
"E_JKJULYP[T[XYZUZK RRRQSRTSSRRRT",
"E_JKJULYP[T[XYZUZK RLSXS RRMRY",
"E_ZYJYJMZM",
"E_JYZYZMJM",
"E_Z\\J\\ RZVJVJJZJ",
"E_J\\Z\\ RJVZVZJJJ",
"E_Z[ZKJKJ[",
"E_JKJ[Z[ZK",
"E_PKTKXMZQZUXYT[P[LYJUJQLMPK RLSXS RRMRY",
"E_PKTKXMZQZUXYT[P[LYJUJQLMPK RLSXS",
"E_PKTKXMZQZUXYT[P[LYJUJQLMPK RMNWX RWNMX",
"E_PKTKXMZQZUXYT[P[LYJUJQLMPK RWFM^",
"E_PKTKXMZQZUXYT[P[LYJUJQLMPK RRRQSRTSSRRRT",
47,
"E_PKTKXMZQZUXYT[P[LYJUJQLMPK RRNRS RMQRSWQ ROWRSUW",
"E_PKTKXMZQZUXYT[P[LYJUJQLMPK RLUXU RLQXQ",
"E_PKTKXMZQZUXYT[P[LYJUJQLMPK RNSVS",
"E_JKZKZ[J[JK RLSXS RRMRY",
"E_JKZKZ[J[JK RLSXS",
"E_JKZKZ[J[JK RMNWX RWNMX",
"E_JKZKZ[J[JK RRRQSRTSSRRRT",
"E_J[JK RJSZS",
"E_Z[ZK RZSJS",
"E_ZKJK RRKR[",
"E_J[Z[ RR[RK",
"I[NSVS RNKN[",
"I[NVVV RNPVP RNKN[",
"E_JVZV RJPZP RJKJ[",
"E_JKJ[ RPSZS RPKP[",
"E_JKJ[ ROKO[ RTKT[ RYSTS",
"E_JKJ[ RPVYV RPPYP RPKP[",
"E_J[JK RJSZS RXGL_",
"E_JVZV RJPZP RJKJ[ RXGL_",
"E_JKJ[ RPSZS RPKP[ RXGL_",
"E_JKJ[ RPVYV RPPYP RPKP[ RXGL_",
"E_VKXLYNXPVQRRJSRTVUXVYXXZV[",
"E_NKLLKNLPNQRRZSRTNULVKXLZN[",
"E_JSZYZMJS",
"E_ZSJYJMZS",
"E_Z[J[ RJQZWZKJQ",
"E_J[Z[ RZQJWJKZQ",
"BbXQXU RYQYU RZPZV R[Q[U R\\Q\\U RMSLQJPHQGSHUJVLUMSWSXUZV\\U]S\\QZPXQWS",
"BbLQLU RKQKU RJPJV RIQIU RHQHU RWSXQZP\\Q]S\\UZVXUWSMSLUJVHUGSHQJPLQMS",
"E_JSTSUUWVYUZSYQWPUQTS",
"E_JSNS RR[RW RRKRO RZSVS",
"I[NFVF RRFR[",
"E_J[Z[ RZKRVJK",
"E_ZKJK RJ[RPZ[",
"E_JKZK RZPR[JP",
"E_JKJ[Z[ RJOLOQQTTVYV[",
"E_Z[ZKJ[Z[",
"Bb_`REE`",
"BbEFRa_F",
"Bb]`]O\\KZHWFSEQEMFJHHKGOG`",
"BbGFGWH[J^M`QaSaW`Z^\\[]W]F",
"E_RaJSRFZSRa",
26,
"I[RRTXOTUTPXRR",
"E_ZSJS RRXSYRZQYRXRZ RRLSMRNQMRLRN RLMXY RXMLY",
"E_JKZ[ZKJ[JK",
"E_ZKJ[JKZ[",
"E_JKZ[ZKJ[",
"E_JKZ[ RRSJ[",
"E_ZKJ[ RRSZ[",
"E_ZVJV RZPYOVNSOQQNRKQJP",
"E_JKMMOOQSR[SSUOWMZK",
"E_Z[WYUWSSRKQSOWMYJ[",
"E_ZPSPQQPSQUSVZV RZ\\Q\\N[KXJUJQKNNKQJZJ",
"E_JPQPSQTSSUQVJV RJ\\S\\V[YXZUZQYNVKSJJJ",
"E_U[UTTRRQPROTO[ R[[[RZOWLTKPKMLJOIRI[",
"E_OKORPTRUTTURUK RIKITJWMZP[T[WZZW[T[K",
"E_RKR[ RL[LSMPNOQNSNVOWPXSX[",
"E_JPZP RZVJV RODOb RUDUb",
"E_ZMJSZY RYRXSYTZSYRYT",
"E_JMZSJY RKRJSKTLSKRKT",
"5oJM:SJY RZMJSZY RjMZSjY",
"5oZMjSZY RJMZSJY R:MJS:Y",
"E_ZSJS RJWZ[J_ RZOJKZG",
"E_JSZS RZWJ[Z_ RJOZKJG",
"E_ZLJL RZPJVZ\\",
"E_JLZL RJPZVJ\\",
"E_JPROVMXKZH RZ^X[VYRWJVRUVSXQZN",
"E_ZPRONMLKJH RJ^L[NYRWZVRUNSLQJN",
"E_JPROVMXKZH RZ^X[VYRWJVRUVSXQZN RXGL_",
"E_ZPRONMLKJH RJ^L[NYRWZVRUNSLQJN RXGL_",
"E_Z\\J\\ RZVJVJJZJ RXGL_",
"E_J\\Z\\ RJVZVZJJJ RXGL_",
"E_Z\\J\\ RZVJVJJZJ RSYQ_",
"E_J\\Z\\ RJVZVZJJJ RSYQ_",
"E_ZVJPZJ RJZKYNXQYS[V\\Y[ZZ RSWQ]",
"E_JVZPJJ RJZKYNXQYS[V\\Y[ZZ RSWQ]",
"E_J[KZNYQZS\\V]Y\\Z[ RZHXKVMROJPRQVSXUZX RSXQ^",
"E_J[KZNYQZS\\V]Y\\Z[ RJXLUNSRQZPRONMLKJH RSXQ^",
"E_JSZYZMJS RXGL_",
"E_ZSJYJMZS RXGL_",
"E_Z[J[ RJQZWZKJQ RXGL_",
"E_J[Z[ RZQJWJKZQ RXGL_",
"CaR\\S]R^Q]R\\R^ RRRSSRTQSRRRT RRHSIRJQIRHRJ",
"CaHRISHTGSHRHT RRRSSRTQSRRRT R\\R]S\\T[S\\R\\T",
"Ca\\H[I\\J]I\\H\\J RRRQSRTSSRRRT RH\\G]H^I]H\\H^",
"CaHHIIHJGIHHHJ RRRSSRTQSRRRT R\\\\]]\\^[]\\\\\\^",
">`BQ\\Q R\\GOGKIIKGOGSIWKYO[\\[",
">`GQ\\Q R\\M\\U R\\GOGKIIKGOGSIWKYO[\\[",
"E_JSZS RZPZV RZZPZMYKWJTJRKOMMPLZL",
"C`\\QGQ R\\GOGKIIKGOGSIWKYO[\\[ RR@QARBSAR@RB",
"C`GA\\A R\\QGQ R\\[O[KYIWGSGOIKKIOG\\G",
"E_JSZS RZGJG RZLPLMMKOJRJTKWMYPZZZ",
"C`G`\\` R\\PGP R\\FOFKHIJGNGRIVKXOZ\\Z",
"C`HT\\T RHN\\N R\\GOGKIIKGOGSIWKYO[\\[",
"DfbQHQ RHGUGYI[K]O]S[WYYU[H[",
"Df]QHQ RHMHU RHGUGYI[K]O]S[WYYU[H[",
"E_ZSJS RJPJV RJZTZWYYWZTZRYOWMTLJL",
"Da]AHA RHQ]Q RH[U[YY[W]S]O[KYIUGHG",
"E_ZSJS RJGZG RJLTLWMYOZRZTYWWYTZJZ",
"C`GQ\\Q R\\GGGG[\\[",
"E_PKTKXMZQZUXYT[P[LYJUJQLMPK RZKJ[",
"E_JQRWROZU",
"E_J[JORGZOZ[J[",
"E_NORKVO",
"E_VWR[NW",
"E_ZKJK RJ[RPZ[",
"E_JNZN RJHZH RJ[RSZ[",
"H\\RDSETGSIRJQLRNSOTQSSRTQVRXSYT[S]R^Q`Rb",
"KYQbQDVD",
"KYSbSDND",
"KYQDQbVb",
"KYSDSbNb",
"E_RWR[ RVSZS",
"E_RWR[ RNSJS",
"E_RORK RVSZS",
"E_RORK RNSJS",
"E_ZQJQJV",
"D`[JZLYPYVZZ[\\Y[UZOZK[I\\JZKVKPJLIJKKOLULYK[J",
"E_JSJQLMPKTKXMZQZS",
"E_JSJQLMPKTKXMZQZS RJSZS",
"E_JMLLPKTKXLZMR[JM",
"E_PUJ[ RTKWLYNZQYTWVTWQVOTNQONQLTK",
"E_JSZS RR[RK RVRUPSOQOOPNRNTOVQWSWUVVTVR",
"E_JWZW RJOZO RNKN[ RVKV[",
"E_LPXPZO[MZKXJVKUMUYV[X\\Z[[YZWXVLVJWIYJ[L\\N[OYOMNKLJJKIMJOLP",
"E_ZUJUJP",
"E_RORSUS RPKTKXMZQZUXYT[P[LYJUJQLMPK",
"E_M[RVW[ RN[RWV[ RP[RYT[ RS[RZQ[ RU[RXO[ RYMRPKMROYM RJFZFZKYMKTJVJ[Z[ZVYTKMJJJF",
"JZVFNFNM",
"JZNFVFVM",
"JZV[N[NT",
"JZN[V[VT",
"H\\RbRMSITGVFXGYI",
"H\\RDRYQ]P_N`L_K]",
"E_JUKTMSRRWSYTZU",
"E_ZQYRWSRTMSKRJQ",
"E_LKHK RXK\\K RNORKVO",
"@dXK^K RFKLKX[^[",
"AfJKZ[ RZKJ[ RFKZKbSZ[F[FK",
"AcJKZ[ RZKJ[ RFK^K^[F[FK",
"9k>VfV R>LfL RCQCL RD[DV REVEQ RFLFG RHQHL RJVJQ RK[KV RKLKG RMQML ROVOQ RPLPG RRQRL RTVTQ RULUG RWQWL RYVYQ RZ[ZV RZLZG R\\Q\\L R^V^Q R_L_G R`[`V R>QaQaL R>[>GfGf[>[",
"KYUcOSUC",
"KYOcUSOC",
">cZKJ[ RJKZ[ R^KJKBSJ[^[^K",
"AcKOKW RR[YW RRKYO RRE^L^ZRaFZFLRE",
"H\\PNKX RYNTX RVRUPSOQOOPNRNTOVQWSWUVVTVR",
"E_N[J[JW RZSRSJ[ RVRUPSOQOOPNRNTOVQWSWUVVTVR",
"E_JSZS RNYVY RVMNM",
"E_RPRKNN RZPZKVN RRKJ[R[ZK",
"H\\LS[S RRMRY RXP[SXV RVRUPSOQOOPNRNTOVQWSWUVVTVR",
"E_ZSJ\\JJZS RJSZS",
"E_J[JRZ[J[",
"E_JWJ[Z[ZW",
"E_VWR[NW",
"D`JaZa RJFZF RRFRa",
"D`MFWFWaMaMF",
"D`IF[F[aIaIF RJPZP RZVJV",
"D`IF[F[aIaIF RZSJS RRXSYRZQYRXRZ RRLSMRNQMRLRN",
"D`IF[F[aIaIF RRJ[SR\\ISRJ",
"D`IF[F[aIaIF RPQRPTQUSTURVPUOSPQ",
"D`IF[F[aIaIF RPKTKXMZQZUXYT[P[LYJUJQLMPK",
"E_PKTKXMZQZUXYT[P[LYJUJQLMPK RRbRD",
47,
"E_JSZS RZKJ[",
"E_JSZS RJKZ[",
"D`IaIF[F[aIa[F",
"D`[a[FIFIa[aIF",
"D`IF[F[aIaIF RZMJSZY",
"D`IF[F[aIaIF RJMZSJY",
"E_ZSJS RNWJSNO RR[RK",
"E_JSZS RVWZSVO RR[RK",
"D`IF[F[aIaIF RZSJS RNWJSNO",
"D`IF[F[aIaIF RJSZS RVWZSVO",
"E_PKTKXMZQZUXYT[P[LYJUJQLMPK RLGX_",
"E_J[Z[ RR[RK RZaJa",
"E_RKX[L[RK RRbRD",
"D`IF[F[aIaIF RIKR[[K",
"D`IF[F[aIaIF RRKX[L[RK",
"E_ZKJK RRKR[ RVRUPSOQOOPNRNTOVQWSWUVVTVR",
"E_R[RK RNORKVO RJSZS",
"D`IF[F[aIaIF RR[RK RNORKVO",
"E_ZKJK RRKR[ RMEWE",
"E_R[LKXKR[ RRbRD",
"D`IF[F[aIaIF R[[RKI[",
"D`IF[F[aIaIF RR[LKXKR[",
"E_J[Z[ RR[RK RPQRPTQUSTURVPUOSPQ",
"E_RKR[ RVWR[NW RJSZS",
"D`IF[F[aIaIF RRKR[ RVWR[NW",
"JZJ]Z] RSFQJ",
"E_RKX[L[RK RJ]Z]",
"E_RJ[SR\\ISRJ RJ]Z]",
"E_PQRPTQUSTURVPUOSPQ RJ]Z]",
"E_PKTKXMZQZUXYT[P[LYJUJQLMPK RJ]Z]",
"E_Z[ZQXMTKPKLMJQJ[ RPQRPTQUSTURVPUOSPQ",
"D`IF[F[aIaIF RSFQJ",
"E_PKTKXMZQZUXYT[P[LYJUJQLMPK RRPTVORURPVRP",
"D`IF[F[aIaIF RRYSZR[QZRYR[ RRNSORPQORNRP",
"E_ZKJK RRKR[ RNDOENFMENDNF RVDWEVFUEVDVF",
"E_R[LKXKR[ RNFOGNHMGNFNH RVFWGVHUGVFVH",
"E_RKWZJQZQMZRK RNDOENFMENDNF RVDWEVFUEVDVF",
"E_PQRPTQUSTURVPUOSPQ RNIOJNKMJNINK RVIWJVKUJVIVK",
"E_PKTKXMZQZUXYT[P[LYJUJQLMPK RNDOENFMENDNF RVDWEVFUEVDVF",
"E_JKJULYP[T[XYZUZK RRbRD",
"E_ZMNMLNKOJQJUKWLXNYZY RRbRD",
"E_JSKRNQQRSTVUYTZS RNFOGNHMGNFNH RVFWGVHUGVFVH",
"E_JMZSJY RNFOGNHMGNFNH RVFWGVHUGVFVH",
"E_JSZS RSZS[R]Q^",
"E_R[LKXKR[ RJSKRNQQRSTVUYTZS",
"H\\QFSFUGVHWJXNXSWWVYUZS[Q[OZNYMWLSLNMJNHOGQF RJPKONNQOSQVRYQZP",
"E_JSKRNQQRSTVUYTZS RRbRD",
"MWSZS[R]Q^ RRNSORPQORNRP RJ]Z]",
"D`IF[F[aIaIF RJPZP RTMPY RZVJV",
"D`IF[F[aIaIF RQYRZQ[PZQYQ[ RMGOFTFVGWIWKVMUNSORPQRQS",
"E_IKR[[K RJSKRNQQRSTVUYTZS",
"E_[[RKI[ RJSKRNQQRSTVUYTZS",
36,
"H\\MbMQNOONQMTMVNWOXQXWWYVZT[Q[OZMX",
43,
"H]YMVWUYTZR[P[NZMYLVLRMONNPMRMTNUOVQWXXZZ[ RJ]Z]",
"HZLTST RVZT[P[NZMYLWLQMONNPMTMVN RJ]Z]",
"MXRMRXSZU[ RJ]Z]",
"G]RTRX RMMLNKPKXLZN[O[QZRXSZU[V[XZYXYPXNWM RJ]Z]",
34,
"IbMTQSS[bB RXL`L",
"A_J_F_F[ RJKJ[Z[ RF_OVEQOG",
"E_JWNWN[V[VWZW",
"E_NSN[J[ RVSV[Z[ RJSJQLMPKTKXMZQZSJS",
"E_PQPU RQUQQ RRPRV RSUSQ RTQTU RPTRVTT RPRRPTR RPQRPTQUSTURVPUOSPQ RRbRD",
"E_VWR[NW ROEQDSDUEVGVN RVMTNQNOMNKOIQHVH",
"BbF[^[ RGLIKKKMLNNNU RUSVTUUTTUSUU R]S^T]U\\T]S]U RNTLUIUGTFRGPIONO",
"BbF[N[ RV[^[ RGLIKKKMLNNNU RWLYK[K]L^N^U RNTLUIUGTFRGPIONO R^T\\UYUWTVRWPYO^O",
"BbHPDP RJUFX RJKFH R^XZU R^HZK R`P\\P RTTRUPUNTMRMQNNPLRKVKTU",
"=_RKR[B[BKRK RPKTKXMZQZUXYT[P[LYJUJQLMPK",
"E_JKZKZ[J[JK RRbRD",
"C_ESUS RQWUSQO RJWJ[Z[ZKJKJO",
"@dX[^[ RZO^KZG RF[L[XK^K",
"E_KOYW RR[RK RYOKW RRMONMPLSMVOXRYUXWVXSWPUNRM",
"E_JSOSR[USZS RPKTKXMZQZUXYT[P[LYJUJQLMPK",
"E_R[KOYOR[ RPKTKXMZQZUXYT[P[LYJUJQLMPK",
"E_STJK RJOJKNK RSKTKXMZQZUXYT[P[LYJUJT",
"D`KNKROR RYRWPTOPOMPKR RNXMVKUIVHXIZK[MZNX RVXWZY[[Z\\X[VYUWVVX",
"E_I[N[NKVKV[[[",
"E_I[V[VK RN[NK[K",
"E_JKZK RJSRKZSR[JS",
"E_Z[J[ RZSR[JSRKZS",
"E_JKZK RJSRKZSR[JS RJSZS",
"E_Z[J[ RZSR[JSRKZS RJSZS",
"E_JVLV RJPZP RQVSV RXVZV",
"BbL[FQLGXG^QX[L[",
"D`IF[F[aIaIF",
"MWTFQL",
"AcZSJS RRORK RR[RW RNOJSNW R^[F[FK^K^[",
"AcJSZS RRWR[ RRKRO RVWZSVO RFK^K^[F[FK",
"BbLHQHQC RLSLHQCXCXSLS RLKJKHLGNGXHZJ[Z[\\Z]X]N\\LZKXK",
"BbROJW RZORW RGXGNHLJKZK\\L]N]X\\ZZ[J[HZGX",
"H\\XDVGUITLSQR[Rb",
22,
"H\\XbV_U]TZSURKRD",
"H\\LDNGOIPLQQR[Rb",
22,
"H\\LbN_O]PZQURKRD",
"H\\XGRGRb",
22,
"H\\X_R_RD",
"H\\LGRGRb",
22,
"H\\L_R_RD",
"H\\XDTHSJRNRb",
"H\\RDRIQMPOLSPWQYR]Rb",
"H\\XbT^S\\RXRD",
22,
"H\\LDPHQJRNRb",
"H\\RDRISMTOXSTWSYR]Rb",
"H\\LbP^Q\\RXRD",
22,
"H\\HS\\S",
"H\\WDSHRKR[Q^Mb",
"H\\MDQHRKR[S^Wb",
"E_VbIF\\F",
"E_VDI`\\`",
">fC^CYaYa^",
">fCHCMaMaH",
">fC^CYaYa^ RaHaMCMCH",
"IbMTQSS[bB",
22,
22,
"H\\HG\\G",
"H\\HM\\M",
"H\\\\YHY",
"H\\\\_H_",
"E_UFOFO[",
"E_U[O[OF",
"E_PKTKXMZQZUXYT[P[LYJUJQLMPK RRbRD",
"E_PKTKXMZQZUXYT[P[LYJUJQLMPK RZEJE RRERa",
"E_PKTKXMZQZUXYT[P[LYJUJQLMPK RJaZa RRaRE",
"E_RK[[I[RK RRbRD",
"E_RK[[I[RK RZEJE RRERa",
"E_RK[[I[RK RJaZa RRaRE",
"E_JSKRNQQRSTVUYTZS RRbRD",
"E_JSKRNQQRSTVUYTZS RZEJE RRERa",
"E_JSKRNQQRSTVUYTZS RJaZa RRaRE",
"E_JaZa RRaRE",
"E_ZEJE RRERa",
"E_OFUFU[",
"E_O[U[UF",
"D`TFQL RMKJKJ[Z[ZKWK",
"E_IWN\\NZZZZKTKTTNTNRIW",
"E_Z[J[ RJVRKZV",
22,
"H\\NQNROTQUSUUTVRVQ",
"H\\NQNROTQUSUUTVRVQ RMKWK",
"H\\NQNROTQUSUUTVRVQ RW[M[",
"CaGQGRHTJULUNTOROQ RUQURVTXUZU\\T]R]Q RGK]K",
"CaGQGRHTJULUNTOROQ RUQURVTXUZU\\T]R]Q R][G[",
"E_JQJRKTMUOUQTRRRQ RRRSTUUWUYTZRZQ",
"E_JUZUZP",
"E_JPJUZUZP",
"E_RPRU RJPJUZUZP",
"E_HO\\O RLUXU RRFRO RT[P[",
"E_HS\\S RJMZMZYJYJM",
">fB]C\\FZHYKXPWTWYX\\Y^Za\\b]",
">fbIaJ^L\\MYNTOPOKNHMFLCJBI",
">fB^B]C[EZOZQYRWSYUZ_Za[b]b^",
">fbHbIaK_LULSMROQMOLELCKBIBH",
">fB^FY^Yb^",
">fbH^MFMBH",
"E_I[NKVK[[I[",
"AcRE^L^ZRaFZFLRE RQLSLVMXOYRYTXWVYSZQZNYLWKTKRLONMQL",
0,
"E_HXMN\\NWXHX",
"E_JSZS RJSKNLLNKPLQNSXTZV[XZYXZS",
"E_LMXY RXMLY RPQRPTQUSTURVPUOSPQ",
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
"E_KKK[ RL[LK RMKM[ RN[NK ROKO[ RP[PK RQKQ[ RR[RK RSKS[ RT[TK RUKU[ RV[VK RWKW[ RX[XK RYKY[ RJKZKZ[J[JK",
"E_JKZKZ[J[JK",
"E_KLMKWKYLZNZXYZW[M[KZJXJNKL",
"E_JKZKZ[J[JK RPPPV RQVQP RRPRV RSVSP RTPTV ROVOPUPUVOV",
"E_JWZW RJSZS RJOZO RJKZKZ[J[JK",
"E_NKN[ RRKR[ RVKV[ RJKZKZ[J[JK",
"E_JWZW RJSZS RJOZO RNKN[ RRKR[ RVKV[ RJKZKZ[J[JK",
"E_JKZ[ RN[JW RT[JQ RZUPK RZOVK RJKZKZ[J[JK",
"E_J[ZK RJUTK RJONK RP[ZQ RV[ZW RJKZKZ[J[JK",
"E_J[ZK RJUTK RJONK RJKZ[ RN[JW RP[ZQ RT[JQ RV[ZW RZUPK RZOVK RJKZKZ[J[JK",
"E_PPPV RQVQP RRPRV RSVSP RTPTV ROVOPUPUVOV",
"E_OVOPUPUVOV",
"E_JXTN RJWSN RJVRN RJUQN RJTPN RJSON RJRNN RJQMN RJPLN RJOKN RKXUN RLXVN RMXWN RNXXN ROXYN RPXZN RQXZO RRXZP RSXZQ RTXZR RUXZS RVXZT RWXZU RXXZV RYXZW RJNZNZXJXJN",
"E_JNZNZXJXJN",
"E_M[WQ RMZWP RMYWO RMXWN RMWWM RMVWL RMUWK RMTVK RMSUK RMRTK RMQSK RMPRK RMOQK RMNPK RMMOK RMLNK RN[WR RO[WS RP[WT RQ[WU RR[WV RS[WW RT[WX RU[WY RV[WZ RM[MKWKW[M[",
"E_M[MKWKW[M[",
"E_NNLP RONKR RPNJT RQNIV RRNHX RSNIX RTNJX RUNKX RVNLX RWNMX RXVVX RXNNX RYTUX RYNOX RZRTX RZNPX R[PSX R[NQX R\\NRX RHXMN\\NWXHX",
"E_HXMN\\NWXHX",
"E_JZJ[ RKXK[ RLVL[ RMTM[ RNSN[ ROQO[ RPOP[ RQMQ[ RRKR[ RSMS[ RTOT[ RUQU[ RVSV[ RWTW[ RXVX[ RYXY[ RZ[RLJ[ RZZZ[ RRK[[I[RK",
"E_RK[[I[RK",
"E_OUOV RPSPV RQQQV RRORV RSQSV RTSTV RUUUV ROVRPUV RROVVNVRO",
"E_ROVVNVRO",
"E_KKK[ RLLLZ RMLMZ RNMNY ROMOY RPNPX RQNQX RRORW RSPSV RTPTV RUQUU RVQVU RWSXS RWRWT RJKYSJ[ RZSJ\\JJZS",
"E_ZSJ\\JJZS",
"E_PPPV RQQQU RRQRU RSSUS RSRST ROPUSOV RVSOWOOVS",
"E_VSOWOOVS",
"E_KNKX RLNLX RMOMW RNONW ROOOW RPPPV RQPQV RRPRV RSQSU RTQTU RURUT RVRVT RWRWT RXSWS RJNYSJX RZSJYJMZS",
"E_ZSJYJMZS",
"E_ZLZK RYNYK RXPXK RWRWK RVSVK RUUUK RTWTK RSYSK RR[RK RQYQK RPWPK ROUOK RNSNK RMRMK RLPLK RKNKK RJKRZZK RJLJK RR[IK[KR[",
"E_R[IK[KR[",
"E_UQUP RTSTP RSUSP RRWRP RQUQP RPSPP ROQOP RUPRVOP RRWNPVPRW",
"E_RWNPVPRW",
"E_Y[YK RXZXL RWZWL RVYVM RUYUM RTXTN RSXSN RRWRO RQVQP RPVPP ROUOQ RNUNQ RMSLS RMTMR RZ[KSZK RJSZJZ\\JS",
"E_JSZJZ\\JS",
"E_TVTP RSUSQ RRURQ RQSOS RQTQR RUVOSUP RNSUOUWNS",
"E_NSUOUWNS",
"E_YXYN RXXXN RWWWO RVWVO RUWUO RTVTP RSVSP RRVRP RQUQQ RPUPQ ROTOR RNTNR RMTMR RLSMS RZXKSZN RJSZMZYJS",
"E_JSZMZYJS",
"E_JRJT RKUKQ RLPLV RMWMO RNNNX ROYOM RPLPZ RQ[QK RRJR\\ RS[SK RTLTZ RUYUM RVNVX RWWWO RXPXV RYUYQ RZRZT RRJ[SR\\ISRJ",
"E_RJ[SR\\ISRJ",
"E_RJ[SR\\ISRJ RPRPT RQUQQ RRPRV RSUSQ RTRTT RRPUSRVOSRP",
"E_PKTKXMZQZUXYT[P[LYJUJQLMPK RPQPU RQUQQ RRPRV RSUSQ RTQTU RPTRVTT RPRRPTR RPQRPTQUSTURVPUOSPQ",
"E_RaJSRFZSRa",
"E_PKTKXMZQZUXYT[P[LYJUJQLMPK",
"E_JQKO RKWJU RNLPK RP[NZ RTKVL RVZT[ RYOZQ RZUYW",
"E_NLNZ RRKR[ RVLVZ RPKTKXMZQZUXYT[P[LYJUJQLMPK",
47,
"E_KOKW RLXP[ RLNPK RLMLY RMYMM RNLNZ ROZOL RPKP[ RQ[QK RRKR[ RS[SK RT[XX RTKT[ RTKXN RUZUL RVLVZ RWYWM RXMXY RYWYO RPKTKXMZQZUXYT[P[LYJUJQLMPK",
"E_PKTKXMZQZUXYT[P[LYJUJQLMPK RKOKW RLYLM RMMMY RNZNL ROLOZ RP[LX RP[PK RLN RQKQ[ RR[P[LYJUJQLMPKRKR[",
"E_PKTKXMZQZUXYT[P[LYJUJQLMPK RYWYO RXMXY RWYWM RVLVZ RUZUL RTKXN RTKT[ RXX RS[SK RRKTKXMZQZUXYT[R[RK",
"E_PKTKXMZQZUXYT[P[LYJUJQLMPK RKOKS RLMLS RMSMM RNLNS ROSOL RPKLN RPKPS RQKQS RRKRS RSKSS RTSTK RXN RULUS RVSVL RWMWS RXMXS RYOYS RJSJQLMPKTKXMZQZSJS",
"E_PKTKXMZQZUXYT[P[LYJUJQLMPK RYWYS RXYXS RWSWY RVZVS RUSUZ RT[XX RT[TS RS[SS RR[RS RQ[QS RPSP[ RLX ROZOS RNSNZ RMYMS RLYLS RKWKS RZSZUXYT[P[LYJUJSZS",
"E_SSSK RTKTS RTKXN RUSUL RVLVS RWSWM RXMXS RYSYO RZSRSRK RPKTKXMZQZUXYT[P[LYJUJQLMPK",
"E_QSQ[ RP[PS RP[LX ROSOZ RNZNS RMSMY RLYLS RKSKW RJSRSR[ RT[P[LYJUJQLMPKTKXMZQZUXYT[ RYWYO RXMXY RWYWM RVLVZ RUZUL RTKXN RTKT[ RXX RS[SK RRKTKXMZQZUXYT[R[RK",
"E_KOKW RLYLM RMMMY RNZNL ROLOZ RP[LX RP[PK RLN RQKQ[ RR[P[LYJUJQLMPKRKR[",
"E_YWYO RXMXY RWYWM RVLVZ RUZUL RTKXN RTKT[ RXX RS[SK RRKTKXMZQZUXYT[R[RK",
"E_FDFb RGbGD RHDHb RIbID RJDJb RKbKD RLbLW RLDLO RMXMb RMNMD RNbNY RNDNM ROZOb ROLOD RPbPZ RPDPL RQZQb RQLQD RRbRZ RRDRL RSZSb RSLSD RTbTZ RTDTL RUZUb RULUD RVbVY RVDVM RWXWb RWNWD RXbXW RXDXO RYbYD RZDZb R[b[D R\\D\\b R]b]D R^D^b R_bEbED_D_b RKTKRLONMQLSLVMXOYRYTXWVYSZQZNYLWKT",
"E_FRFD RGNIJ RGDGN RHLHD RIDIK RJJJD RJJMG RKDKI RLHLD RMHQF RMDMH RNGND ROPOS RODOG RPSPP RPGPD RQPQS RQDQG RRSRO RRGRD RSPSS RSFWH RSDSG RTSTP RTGTD RUPUS RUDUG RVGVD RWGZJ RWDWH RXHXD RYDYI RZJZD R[J]N R[D[K R\\L\\D R]D]N R^R^D ROQROUQ RNSOPROUPVSNS RFSFRGNIKJJMHQGSGWHZJ[K]N^R^S_S_DEDESFS R^T^b R]X[\\ R]b]X R\\Z\\b R[b[[ RZ\\Zb RZ\\W_ RYbY] RX^Xb RW^S` RWbW^ RV_Vb RUVUS RUbU_ RTSTV RT_Tb RSVSS RSbS_ RRSRW RR_Rb RQVQS RQ`M^ RQbQ_ RPSPV RP_Pb ROVOS RObO_ RN_Nb RM_J\\ RMbM^ RL^Lb RKbK] RJ\\Jb RI\\GX RIbI[ RHZHb RGbGX RFTFb RUURWOU RVSUVRWOVNSVS R^S^T]X[[Z\\W^S_Q_M^J\\I[GXFTFSESEb_b_S^S",
"E_FRFD RGNIJ RGDGN RHLHD RIDIK RJJJD RJJMG RKDKI RLHLD RMHQF RMDMH RNGND ROPOS RODOG RPSPP RPGPD RQPQS RQDQG RRSRO RRGRD RSPSS RSFWH RSDSG RTSTP RTGTD RUPUS RUDUG RVGVD RWGZJ RWDWH RXHXD RYDYI RZJZD R[J]N R[D[K R\\L\\D R]D]N R^R^D ROQROUQ RNSOPROUPVSNS RFSFRGNIKJJMHQGSGWHZJ[K]N^R^S_S_DEDESFS",
"E_^T^b R]X[\\ R]b]X R\\Z\\b R[b[[ RZ\\Zb RZ\\W_ RYbY] RX^Xb RW^S` RWbW^ RV_Vb RUVUS RUbU_ RTSTV RT_Tb RSVSS RSbS_ RRSRW RR_Rb RQVQS RQ`M^ RQbQ_ RPSPV RP_Pb ROVOS RObO_ RN_Nb RM_J\\ RMbM^ RL^Lb RKbK] RJ\\Jb RI\\GX RIbI[ RHZHb RGbGX RFTFb RUURWOU RVSUVRWOVNSVS R^S^T]X[[Z\\W^S_Q_M^J\\I[GXFTFSESEb_b_S^S",
"E_JSJQLMPKRK",
"E_ZSZQXMTKRK",
"E_ZSZUXYT[R[",
"E_JSJULYP[R[",
"E_JSJQLMPKTKXMZQZS",
"E_ZSZUXYT[P[LYJUJS",
"E_KZK[ RLYL[ RMXM[ RNWN[ ROVO[ RPUP[ RQTQ[ RRSR[ RSRS[ RTQT[ RUPU[ RVOV[ RWNW[ RXMX[ RYLY[ RZ[ZKJ[Z[",
"E_YZY[ RXYX[ RWXW[ RVWV[ RUVU[ RTUT[ RSTS[ RRSR[ RQRQ[ RPQP[ ROPO[ RNON[ RMNM[ RLML[ RKLK[ RJ[JKZ[J[",
"E_YLYK RXMXK RWNWK RVOVK RUPUK RTQTK RSRSK RRSRK RQTQK RPUPK ROVOK RNWNK RMXMK RLYLK RKZKK RJKJ[ZKJK",
"E_KLKK RLMLK RMNMK RNONK ROPOK RPQPK RQRQK RRSRK RSTSK RTUTK RUVUK RVWVK RWXWK RXYXK RYZYK RZKZ[JKZK",
"E_PQRPTQUSTURVPUOSPQ",
"E_JKZKZ[J[JK RK[KK RLKL[ RM[MK RNKN[ RO[OK RPKP[ RQ[QK RJ[JKRKR[J[",
"E_JKZKZ[J[JK RYKY[ RX[XK RWKW[ RV[VK RUKU[ RT[TK RSKS[ RZKZ[R[RKZK",
"E_JKZKZ[J[JK RYLYK RXMXK RWNWK RVOVK RUPUK RTQTK RSRSK RRSRK RQTQK RPUPK ROVOK RNWNK RMXMK RLYLK RKZKK RJKJ[ZKJK",
"E_JKZKZ[J[JK RKZK[ RLYL[ RMXM[ RNWN[ ROVO[ RPUP[ RQTQ[ RRSR[ RSRS[ RTQT[ RUPU[ RVOV[ RWNW[ RXMX[ RYLY[ RZ[ZKJ[Z[",
"E_JKZKZ[J[JK RR[RK",
"E_RK[[I[RK RRUQVRWSVRURW",
"E_J[RL RJZJ[ RKXK[ RLVL[ RMTM[ RNSN[ ROQO[ RPOP[ RQMQ[ RRKR[ RRK[[I[RK",
"E_Z[RL RZZZ[ RYXY[ RXVX[ RWTW[ RVSV[ RUQU[ RTOT[ RSMS[ RRKR[ RRKI[[[RK",
"C`OFTFXHZJ\\N\\SZWXYT[O[KYIWGSGNIJKHOF",
"E_JKZKZ[J[JK RRKRSJS",
"E_JKZKZ[J[JK RR[RSJS",
"E_JKZKZ[J[JK RR[RSZS",
"E_JKZKZ[J[JK RRKRSZS",
"E_PKTKXMZQZUXYT[P[LYJUJQLMPK RRKRSJS",
"E_PKTKXMZQZUXYT[P[LYJUJQLMPK RR[RSJS",
"E_PKTKXMZQZUXYT[P[LYJUJQLMPK RR[RSZS",
"E_PKTKXMZQZUXYT[P[LYJUJQLMPK RRKRSZS",
"E_JKJ[ZKJK",
"E_ZKZ[JKZK",
"E_J[JKZ[J[",
"E_JKZKZ[J[JK",
"E_KKK[ RL[LK RMKM[ RN[NK ROKO[ RP[PK RQKQ[ RR[RK RSKS[ RT[TK RUKU[ RV[VK RWKW[ RX[XK RYKY[ RJKZKZ[J[JK",
"E_OVOPUPUVOV",
"E_PPPV RQVQP RRPRV RSVSP RTPTV ROVOPUPUVOV",
"E_Z[ZKJ[Z[",
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
48,
"PfUUYZ",
"PfWTYT[V[XYZWZUXUVWT",
"PfZKXS R^K\\S",
"PfYFUISMSQUUZXZUXTXRZQ[R[L]N^L^FaIcMcQaU\\X",
"PfZJYMVQ RYM`M\\T RZR]V",
"PfbHTWWK^R",
"PfWG_GcMcS_XWXSSSMWG",
"PfaD[OaZ",
"PfUD[OUZ",
"PfaD[OaZ R^DXO^Z",
"PfUD[OUZ RXD^OXZ",
"PfbD^D^R",
"PfT[X[XO",
"PfbDbH^H^PZPZDbD",
"PfT[TWYWYO]O][T[",
"Pf^DbDaIaOaUbZ^Z^D",
"PfTDXDX[T[UVUITD",
"PfUIaI RUNaN R[N[Y",
"PfUJaJaNUNUJ RURaRaVUVUR",
"PfbD_H_VbZ",
"PfTDWHWVTZ",
"Pf\\DbDaIaOaUbZ\\Z\\D",
"PfTDZDZ[T[UVUITD",
"PfbD]F]XbZ R`E`Y",
"PfTDYFYXTZ RVEVY",
"PfbD]D][b[ R`D`[",
"PfTDYDY[T[ RVDV[",
"PfTOXL^RbO",
"Pf^EbK RYE]K",
"PfWDTJ R[DXJ",
"PfXTTY R]TYY",
"PfWI_I RWL_L R[L[S RWSXU^U_S RVNXNYPXRVRUPVN R^N`NaP`R^R]P^N RTNRNRSTSVX`XbSdSdNbN",
"Pf[F[Y",
"PfXJXU R]F]X",
"PfVHVX R[J[V R`G`X",
"PfaK^SUZ RWOaV",
"PfZHVN]O_R_U]XYXWTWR_M",
"Pf[M[P RTPbP",
"Pf[J[M RTMbM RTQbQ",
"Pf[I[L RTLbL RTPbP RTTbT",
"PfXLWOTR RWObO R`O_VV[ RVQ[S_Y",
"PfT\\W\\Y^YaWcTcRaR^T\\",
"PfTAWAYCYFWHTHRFRCTA",
"Pf_AbAdCdFbH_H]F]C_A",
"Pf_\\b\\d^dabc_c]a]^_\\",
"PfgOjOlQlTjVgVeTeQgO",
"PfgKjKlMlPjRgRePeMgK RgTjTlVlYj[g[eYeVgT",
"PfSQVMYQ\\M_QbM",
"Pf]DWP]Z",
"Pf]I`L R`HcK R]DWP]Z",
"Pf_GWY",
"Pf_MaP RbMdP R_GWY",
"PfVH_X",
"PfWG_GcMcS_XWXSSSMWG RWK_K RWO_O R[O[U",
"PfUFZY R[FUY R\\FaY RaF\\Y",
"PfULaL R[E[Y",
"PfTLbL RXEXY R^E^Y",
"PfTNbN RWGWVUY R[I[V R_H_Y",
"PfXI^N\\O RXP^U",
"PfUJaJaWUWUJ RaJUW",
"PfTLWHZM]JbW",
"PfTIVI RXIZI R\\I^I R`IbI RbK RbMbO RbQbS RbUbW R`W R^W\\W RZWXW RVWTWTU RTSTQ RTOTM RTKTI RWM[K]N`L RWQ_Q RWT_T R\\PYV",
"PfUHaHaYUYUH R_JWW RWJ_W",
48,
"PfVO]O RYLYTZY R\\QXYWYVXVUZR^R`U`W]Z",
"PfTI^H RYEXPZY R]LZUVZTUXP^NaRaX][",
"PfVPVWX[ZX R]Q`W",
"Pf^J`NaS RTHTOUTWZZT",
"PfZJ]L RWO]N_Q^VZ[",
"PfXD]F RUM\\J_M_S]XXZ",
"PfZN]P RXR^RX[ R[W]W][`[",
"PfYE]H RWL^KV[ RYU]R]Z`Z",
"PfUQ[Q RXNX[UYUWZT^T`W`Y[[ R]O`R",
"PfTJ[I RWEWYTWTSZP^QaS`X[Y R^HaL",
"PfSLZK\\OZZWY RXDTZ R]IaQ",
"PfSLZK\\OZZWX RXDTY R]H`Q R`JbM RcIeL",
"PfVI^G RUNaK RYD]SZS RVTVWXY\\Z",
"PfVI^G RUNaK RYD]SZS RVTVWXY\\Z R_DaG RbCdF",
"Pf]EXO]Z",
"Pf]EXO]Z R_IaL RbHdK",
"PfZLaL RVDUKURUVVYXS R^E_M_S^W\\Z",
"PfZLaL RVDUKURUVVYXS R^E_M_S^W\\Z RaEcH RdDfG",
"PfWG^G[J RWPUUWZ`Z",
"PfWG^G[J RWPUUWZ`Z R`DbG RcCeF",
"PfTK`I RYE_R[Q RVRVVXY]Z",
"PfTK`I RYE_R[Q RVRVVXY]Z R_DaG RbCdF",
"PfWEWVXYZ[][`YaU",
"PfWEWVXYZ[][`YaU R\\L^O R_KaN",
"PfSJaJ R]E]S\\WX[ R\\OZMYMWPWRYSZS\\Q",
"PfSJaJ R]E]S\\WX[ R\\OZMYMWPWRYSZS\\Q R`DbG RcCeF",
"PfTMbL R^E^S\\R RWGWZ`Z",
"PfTMbL R^E^S\\R RWGWZ`Z R`EbH RcDeG",
"PfWF_EXM RTNaL R_M[PYRYU[X^Z",
"PfWF_EXM RTNaL R_M[PYRYU[X^Z RaDcG RdCfF",
"PfTI[I RYDTY RZN`N RYSZW\\YaY",
"PfTI[I RYDTY RZN`N RYT[YaY R_GaJ RbFdI",
"PfTI^I RXDUSYO]O_R_V\\YX[",
"PfTI^I RXDUSYO]O_R_V\\YX[ R^E`H RaDcG",
"PfTO]M`NaR_UYX",
"PfSL]I`JaMaP`S]VWX",
"PfSL]I`JaMaP`S]VWX R`EbH RcDeG",
"PfTIaG R_H[KYPYV[Y^Z",
"PfTIaG R_H[KYPYV[Y^Z R`CbF RcBeE",
"Pf_KWQUSUWWZ_Z RWDXIZN",
"Pf_KWQUSUWWZ_Z RWDXIZN R_GaJ RbFdI",
"PfTIZI RXDTU R_HbL R]L]X[YXXXT[SaX",
"PfZHaH RUDTLTRUYWR RZSZW[XaX",
"PfUGXW R[EXTUXSUTQWK]JaNaV^Z\\ZZW\\TbY",
"PfWEWZ RTJWJWK RSVZK^IaJbNaU^Y\\YZXZU]TbX",
"Pf[GWWTTTLVH[F_GbLbRaV\\Y",
"PfYIaI R^E^YYXYT\\SaW RUETKTQUYVR",
"PfYIaI R^E^YYXYT\\SaW RUETKTQUYVR R`EbH RcDeG",
"PfYIaI R^E^YYXYT\\SaW RUETKTQUYVR RbDcDdEdFcGbGaFaEbD",
"PfSKYGUNUTVXXZ[Y\\W]S^M]GbO",
"PfSKYGUNUTVXXZ[Y\\W]S^M]GbO R`EbH RcDeG",
"PfSKYGUNUTVXXZ[Y\\W]S^M]GbO RbEcEdFdGcHbHaGaFbE",
"PfYE]H RZK[Q]U\\YYYWW RVPTX R_QaW",
"PfYE]H RZK[Q]U\\YYYWW RVPTX R_QaW R_DaG RbCdF",
"PfYE]H RZK[Q]U\\YYYWW RVPTX R_QaW R`DaDbEbFaG`G_F_E`D",
"PfTRYKbS",
"Pf^J`M RaIcL RTRYKbS",
"Pf_I`IaJaK`L_L^K^J_I RTRYKbS",
"PfYF`F RYL`L R^F^ZZYZW\\UbX RUETKTQUZWS",
"PfYF`F RYL`L R^F^[ZYZW\\UbX RUETKTQUZWS RaCcF RdBfE",
"PfYF`F RYL`L R^F^[ZYZW\\UbX RUETKTQUZWS RcCdCeDeEdFcFbEbDcC",
"PfTH`H RVM^M R[D[YXYUWVUZT`W",
"PfVG\\GZNVXTUTRWP[PbT R_K_Q^U[Y",
"PfSHYH RWEVVXZ^Z_V_Q RVRUTTTSRSPTNUNVP R]IaN",
"PfUHYX R[FYVVZSVSRWM[K_MbRaW]Z",
"PfYDXVYZ[[^[`ZaV`P RTI\\I RUO\\O",
"PfUR]N`O`Q_S\\T RVL[[ RYK[M",
"PfSO_KaLbP_S\\S RUG[[ RYE\\H",
"PfTLTVWP\\MaQaV]YYV R]J]R[[",
"PfULUXXP[M_MbPbU_W\\WZU R]J]Y[[",
"Pf[N[ZVYVVYU`X R[Q_Q",
"Pf[E[[WZUXUVWTaY R[K`J",
"PfYE]H RXIVUYQ]P`S_XY[",
"Pf^E^R]VYZ RWEVJVNWQYN",
"PfWF_EVS[O`OaRaW][Y[XWZU^Y",
"PfWEWZ RTJXIWJ RSV\\I_I`L_S_YbU",
"PfXG^FWT[O`OaRaW^YZZ",
"PfWIWZ RULXLWN RUU[M^MaNaT_W[Y",
"PfWEWZ RTKXJWL RSVYN[K_KaMbQ`U[Y",
"PfWG]FWZUUVQZM^NaQaX][ZY[V_X",
"PfXE^EVN R\\K`M`QZTWRXP[QTY RVWXW[Z R]W_WaY",
"PfUH^H RZDUSYM[O\\U R`NWUWXZ[_[",
"Pf[EU[ZQ\\Q^[_[bV",
"PfXD]F RUM\\J_M_S]XXZ R`FbI RcEeH",
"PfUO\\N]P\\YYW RYJUY R^LaQ",
"PfYP`O RUKTQTUVZWW R]L]V\\X[[",
48,
48,
"Pf^E`H RaDcG",
"PfaDbDcEcFbGaG`F`EaD",
"PfSEUH RVDXG",
"PfTDUDVEVFUGTGSFSETD",
"PfYI`P\\R",
"PfYI`P\\R R^G`J RaFcI",
"PfZJ`J R[EUW RXP^P`S_X\\[YZ",
"PfTLbL RTTbT",
"PfVK`K_N]Q R[N[RZUXX",
"PfTGbGaI_L\\N RZJZQZSYVW[",
"Pf[P[Z R^J\\NYQVS",
"Pf[L[[ R`E^H[LWOTQ",
"PfZHZL RVOVL_L_O^S]U[WXY",
"Pf[D[H RUOUHaH`N_Q]U[XWZ",
"PfWL_L R[L[W RVW`W",
"PfUIaI RTWbW R[I[W",
"PfWO`O R]K]Z[Y R\\O[RYUVX",
"PfUKbK R^D^Z[Y R]K[PXSTW",
"PfUJaJ`Y]W RZCZJZOYSWVUY",
"PfUJaJ`Y]W RZCZJZOYSWVUY R_EaH RaCcF",
"PfVL^J RUSaP RYD]Z",
"Pf]E_G R`DbF RVL^J RUSaP RYD]Z",
"PfZDYIWLUP RZH`H`L_P]T[WWZ",
"PfZDYIWLUO RZGaG`L_P]T[WWZ R`DbF RcCeE",
"PfWKbK RXDWHUMTP R]K]P\\SZVWZ",
"PfWKbK RXDWHUMTQ R]K]P\\SZVWZ R^G`I RaFcH",
"PfUIaIaWUW",
"Pf`FbH RcEeG RUIaIaWUW",
"PfTKbK RWEWR R_D_K_O^S]U[XYZ",
"PfTKbK RWEWR R_D_K_O^S]U[XYZ RaDbF RdCeE",
"PfWFZI RULXO RUYZW]U_SbK",
"PfWFZI RULXO RUYZW]U_SbK R_GaI RbFdH",
"PfUF^F]L[PYSWVTY R[Q]T`Y",
"PfUF^F]L[OYSWVTY R[Q]T`Y R`EbG RcDeF",
"PfULbJ^R RYEYXaX",
"Pf_EaG RbDdF RULbJ^R RYDYXaX",
"PfUFWL R`F`L_P^S\\VWY",
"PfaG`L_P^T\\WXZ RaDcF RdCfE RUGWM",
"PfXL]R RYDXHWLUP RYH`H_L^P]T[WXZ",
"PfXL]R RYDXHWLUP RYH`H_L^P]T[WXZ R`EbG RcDeF",
"PfTNbN R_E]FZGVH R\\G\\M[QZUYWVZ",
"PfTNbN R_E]FZGVH R\\G\\M[QZUYWWZ R`DbF RcCeE",
"PfULWQ RZK[P R`L`Q_T\\WYY",
"PfUGWN RYF[L R`G`M_Q]U[WXY",
"PfUGWN RYF[L R`G`M_Q]U[WXY RaEcG RdDfF",
"PfWG_G RTMbM R[M[RYVVZ",
"Pf`EbG RcDeF RWG_G RTMbM R[M[RYVVZ",
"Pf[D[Z R[MaR",
"Pf_KaM RbJdL R[D[Z R[MaR",
"PfTLbL R[D[K[QZTXWVZ",
"PfUKaK RSWcW",
"PfXM_W RWF`F_L^P\\UZWVZ",
"PfYD]G R[P[[ R]QaU RVH`H^L\\OYRTU",
"Pf_F^L]QZUVY",
"Pf^JbV RYJXOVSTV",
"Pf^JbV RYJXOVSTV R_HaJ RbGdI",
"Pf^JbV RYJXOVSTV R`GaGbHbIaJ`J_I_H`G",
"PfUFUYaY R`J\\MYNVO",
"PfUFUYaY R`J\\MYNVO R`HbJ RcGeI",
"PfUFUYaY R`J\\MYNVO RaFbFcGcHbIaI`H`GaF",
"PfUH`H`M_R]UZWVY",
"PfUH`H`M_R]UZWVY RaFcH RdEfG",
"PfUH`H`M_R]UZWVY RbEcEdFdGcHbHaGaFbE",
"PfTRYJbV",
"Pf]K_M R`JbL RTRYJbV",
"Pf_K`KaLaM`N_N^M^L_K RTRYJbV",
"PfUKaK R[E[ZXY R^OaW RWOVRUTTW",
"PfUKaK R[E[ZXY R^OaW RWOVRUTTW R`GbI RcFeH",
"PfUKaK R[E[ZXY R^OaW RWOVRUTTW RaFbFcGcHbIaI`H`GaF",
"PfTJaJ_N]Q[S RWPZS[U]X",
"PfWFaJ RWM_P RUT`Y",
"Pf[FUY_W R]PaZ",
"Pf`E_J]OZSXUTX RXKZM]Q`U",
"PfVG`G RSOcO RZGZY`Y",
"PfUOaL^R RXI[Z",
"PfXE[Z RTMaI`L_O^Q",
"PfXL^L^V RVVaV",
"PfVI`I_W RSWcW",
"PfWL_L_XWX RWR_R",
"PfUHaHaXUX RUPaP",
"PfVG`G RTLaLaQ_T\\WXZ",
"PfXEXP R_E_M_Q]U\\WYZ",
"PfWGWOVSUVTY R[E[Y]W_TaP",
"PfWEWX[W^U`SbO",
"PfUHUV RUHaHaVUV",
"PfVPVJ`J_P]UYZ",
"PfUGUN RaG`M_Q^U\\XYZ RUGaG",
"PfWJbJ RWJWS RSScS R]D]Z",
"PfVIaI]P R[L[W RSWcW",
"PfVM`M RUF`F`L`O_S]VZXVZ",
"PfUHYL RUXZW]T_QaJ",
"Pf[D[H RUOUHaH`N_Q]U[XWZ RaEcG RdDfF",
"PfWM_M^Y\\X R[IZNYSWX",
"PfYMaM RYIXMWPUS R_M^Q]T\\WZZ",
"PfaEcG RdDfF RUGUN RaG`N`Q^U\\WYZ RUGaG",
"Pf`GbI RcFeH RWJbJ RWJWS RSScS R]D]Z",
"Pf`FbH RcEeG RVIaI]P R[L[W RSWcW",
"PfVM`M RUF`F`L`O_S]VZXVZ RaEcG RdDfF",
"PfZP\\P]Q]S\\TZTYSYQZP",
"PfSPcP",
"PfWK^U",
"Pf\\M^O R_KaM RWK^U",
"PfVF`F`Y",
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
23,
"PoROlO",
"PoRFlF RX[`[ R`F`[",
"PoRFlF R^[e[ RZFVQ RWNiNfZ",
"Po\\D\\[j[jW RSOkK",
"PoR[l[ R_D_[",
"PoRFlF R_F_[",
"PoRGlG R[UU[ R^LYW R_G\\T",
"PoRFlF R\\F[PXVT[ R\\NiMiTg[`[",
"PoRIlI RWLZS^WcYj[ RbDbLaT\\XYZS[",
"PoTFjF RVPhP RR[l[",
"Po^MjM RR[l[ R^D^[",
"PoRElE R^E^[ R^KjQ",
"PoSGlG RfFf[ RXVR[ RYFYPXV",
"PoRElE R`H`[ RaGXPRS RaLiOlS",
"PoYHiH RRTlT R\\[d[ RYCWNgNeZ",
"PoRElE RURjR Rb[h[ RUJUU R_E_R R_KkKjRi[",
"PoRElE R_KjK Rb[i[ R_E_P RUQlQi[ RVITR",
"PoROlO RR[l[ R[FZNX[ RUFgFf[",
"PoaXhX RR[l[ R`PcT RXUSW R^NVV RVK`P RaH^O RTFkFkNiX",
"PoTGjG RRLlL ReS`X RYQhQbW R^C\\JXQ RYWeZ",
"PoWLgL RWTgT RR[l[ RWEW[ RWEgEg[",
"PoSFkF RR[l[ R`I`Y RcMfOkS RaF`IXQRS",
"PoRJlJ R_RgR RWYkY RWDW[ R_C_T RgDgT",
"PoRKlK RWYgY RWCW[ R_C_Y RgCg[",
"PoWNkN RR[l[ RWGW[ RdNd[ RhEWG",
"PoRElE Re[j[ RSKS[ RSKkKk[ R_F^PZUVV R^NgV",
"PoR[l[ R[D[[ RcDc[ RTKXS RjKfS",
"PoR[l[ RhTlX RaT\\X RYL\\O^T ReMiV RXOTW RcN_W RdHgS RYEWS RdDbR",
"PoRGlG RUPjP R[[`[ R`K`[ ReSlY RYKUO RXTRZ R\\CYL",
"Po`VkV RTV]V RR[l[ RkJgN RbJ`NhN`V R]J\\N RVKTO[OTV RZDVM RfDbL",
"PoYX_X RS[k[ R_J_X RVEgEdG_J RRL[LXQSV RjJgMbN R`JbOgTlV",
"PoSEkE RUJiJ RRPlP RZZjZ RXZhZ RRZeZ R_E_P ReTl[ R[PWZ"
];

